// 越南语语言包
import vnLocale from 'element-ui/lib/locale/lang/vi'
export default {
  ...vnLocale,
  // 单据中心
  invoicesCenter: {
    dialogmodulestroeTitle: '1 Phiếu điều chuyển',
    dialogmodulestroeFillinfo: '2 Vui lòng điền thông tin',
    dialogmodulestroeReceiver: '3 Bên nhận hàng',
    dialogmodulestroeRemark: '4 Ghi chú',
    dialogmodulestroeSelectreceiver: '5 Vui lòng chọn bên nhận hàng',
    dialogmodulestroeFillremark: '6 Vui lòng điền thông tin ghi chú',
    dialogmodulestroeAddgoodsdetail: '7 Thêm chi tiết hàng hóa',
    dialogmodulestroeInputgoodsno: '8 Vui lòng nhập số hàng hóa',
    dialogmodulestroeSearch: '9 Tìm kiếm',
    dialogmodulestroeSelectallpages: '10 Chọn tất cả trên mọi trang',
    dialogmodulestroeConfirmadd: '11 Xác nhận thêm',
    dialogmodulestroeAddedgoodslist: '12 Danh sách hàng hóa đã thêm',
    dialogmodulestroeScanbarcode: '13 Quét mã hoặc nhập mã vạch',
    dialogmodulestroeConfirm: '14 Xác nhận',
    dialogmodulestroeNegativescan: '15 Quét âm (Giảm)',
    dialogmodulestroePositivescan: '16 Quét dương (Tăng)',
    dialogmodulestroeEntergoodsno: '17 Nhập mã hàng',
    dialogmodulestroeClear: '18 Xóa trống',
    dialogmodulestroeViewscantrack: '19 Xem lịch sử quét mã',
    dialogmodulestroeCurrentscannedgoods: '20 Hàng hóa đang quét mã',
    dialogmodulestroeGoodsno: '21 Mã hàng',
    dialogmodulestroeColor: '22 Màu sắc',
    dialogmodulestroeSize: '23 Kích cỡ',
    dialogmodulestroeQuantityoutofrange: '24 Số lượng',
    dialogmodulestroeInputcontent: '25 Nhập nội dung',
    dialogmodulestroeSavedraft: '26 Lưu bản nháp',
    dialogmodulestroeSubmit: '27 Xác nhận gửi đi',
    dialogmodulestroePleaseenterbarcode: '28 Nhập mã vạch',
    dialogmodulestroePleaseselectreceiver: '29 Vui lòng chọn bên nhận hàng',
    dialogmodulestroeReceivercannotequalsender: '30 Bên nhận hàng không được trùng với bên giao hàng',
    dialogmodulestroeGoodsnoname: '31 Tên mã hàng',
    dialogmodulestroeUsablestock: '32 Tồn kho khả dụng',
    dialogmodulestroeGoodsname: '33 Tên hàng hóa',
    dialogmodulestroeRetailprice: '34 Giá bán lẻ',
    dialogmodulestroeAllotquantity: '35 Số lượng điều chuyển',
    dialogmodulestroePleaseselectgoods: '36 Vui lòng chọn hàng hóa trước khi thêm',
    dialogmodulestroePleasefillallotquantity: '37 Vui lòng điền số lượng điều chuyển',
    dialogmodulestroePleasefillremark: '38 Vui lòng điền ghi chú',
    dialogmodulestroeOperationsuccess: '39 Thao tác thành công',
    dialogmodulestroeConfirmdelete: '40 Bạn có chắc chắn muốn xóa bản ghi này?',
    dialogmodulestroeQuantityoutofrangeV1: '41 Số lượng vượt quá giới hạn cho phép',
    dialogmodulestroeNegativestocknotallowed: '42 Hàng hóa hiện tại không cho phép tồn kho âm',
    dialogmodulestroeTips: '43 Thông báo',
    differdetaildialogDiffinfo: '44 Thông tin chênh lệch',
    differdetaildialogSendnum: '45 Số lượng xuất',
    differdetaildialogReceivenum: '46 Số lượng nhập',
    differdetaildialogDiscrepancynum: '47 Chênh lệch nhập kho',
    differdetaildialogSendduty: '48 Bên giao chịu trách nhiệm',
    differdetaildialogReceiveduty: '49 Bên nhận chịu trách nhiệm',
    differdetaildialogTransportduty: '50 Đơn vị vận chuyển chịu trách nhiệm',
    differdetaildialogStatus: '51 Trạng thái',
    differdetaildialogStatusunassigned: '52 Chưa xác định trách nhiệm',
    differdetaildialogStatusassigned: '53 Đã xác định trách nhiệm',
    differdetaildialogPackcompletetime: '54 Đóng gói hoàn tất:',
    differdetaildialogInvoiceouttime: '55 Thời gian xuất hàng:',
    differdetaildialogCheckcompletetime: '56 Nhận hàng hoàn tất:',
    differdetaildialogDiffgoods: '57 Hàng hóa chênh lệch',
    differdetaildialogGoodsno: '58 Mã hàng',
    differdetaildialogGoodsname: '59 Tên hàng hóa',
    differdetaildialogColor: '60 Màu sắc',
    differdetaildialogSize: '61 Kích cỡ',
    differdetaildialogDiff: '62 Chênh lệch',
    differdetaildialogSenddutycol: '63 Bên giao chịu trách nhiệm',
    differdetaildialogReceivedutycol: '64 Bên nhận chịu trách nhiệm',
    differdetaildialogTransportdutycol: '65 Đơn vị vận chuyển chịu trách nhiệm',
    differdetaildialogDiffreceive: '66 Nhận hàng chênh lệch',
    differdetaildialogCheckusername: '67 Người nhận hàng:',
    differdetaildialogCheckcompletetimelabel: '68 Thời gian nhận hàng:',
    differdetaildialogDiffresponsibility: '69 Xác định trách nhiệm chênh lệch',
    differdetaildialogAffirmdutyusername: '70 Người xác định trách nhiệm:',
    differdetaildialogAffirmdutytime: '71 Thời gian xác định trách nhiệm:',
    differdetaildialogRemark: '72 Giải thích xác định trách nhiệm:',
    differdetaildialogEvidence: '73 Bằng chứng xác định trách nhiệm:',
    differdetaildialogCloudwarehousetips: '74 Khi bên giao hàng là kho cloud (cloud warehouse), sẽ có các trường hợp sau:',
    differdetaildialogCloudwarehousecase: '75 ①. Kho cloud có tồn kho, nhưng thực tế đã bỏ sót không giao hàng.',
    differdetaildialogCloudwarehousecasedetail: '76 Liên hệ JD bổ sung phát hàng offline, sau khi hoàn tất nhận hàng thì tiến hành xác định trách nhiệm. Do logic hệ thống là nhận hàng trước rồi mới tạo bản ghi chênh lệch, nên không có cách nào để nhập kho lần thứ hai. Khi xác định trách nhiệm, cần quy chênh lệch phần này của kho cloud cho bên nhận hàng chịu trách nhiệm để khớp với tồn kho của cửa hàng (Trong trường hợp thông thường, việc bên nhận chịu trách nhiệm đồng nghĩa với việc nhận sót, nên hệ thống sẽ tự động bổ sung tồn kho).',
    differdetaildialogCloudwarehousecaseV1: '77 ②. Kho cloud không có tồn kho nhưng JD thao tác nhầm khiến đơn hàng xuất vượt. Hoặc một mẫu nào đó được thông báo tạm ngừng phân phối nhưng kho cloud đã thao tác xuất hàng, offline cần lấy hàng thực tế ra và không giao đi.',
    differdetaildialogCloudwarehousecasedetailV1: '78 Khi xác định trách nhiệm, việc quy chênh lệch cho bên giao hàng chịu trách nhiệm, logic hệ thống sẽ tự động hoàn trả số lượng chênh lệch cho bên giao hàng để tăng tồn kho. Tuy nhiên, do không thể trực tiếp thay đổi dữ liệu trên hệ thống JD, cần tạo đơn trên backend của JD để hệ thống JD và hệ thống nội bộ khớp tồn kho với nhau.',
    differdetaildialogTransportdutytips: '79 Đối với số lượng chênh lệch mà đơn vị vận chuyển chịu trách nhiệm, ngoài việc yêu cầu bồi thường từ đơn vị logistics, cần làm thêm phiếu điều chỉnh tồn kho để giảm bớt tồn kho.',
    differdetaildialogTitleprefix: '80 Chi tiết chênh lệch nhận hàng —',
    differdetaildialogTitle: '81 Chi tiết chênh lệch nhận hàng',
    endpackCompletecheck: '82 Hoàn tất kiểm nhận',
    endpackCompletepick: '83 Hoàn tất nhặt hàng',
    endpackDiffconfirmprefix: '84 Hiện tại dữ liệu có chênh lệch, có tiếp tục "Gửi" không?',
    endpackChecktext: '85 Kiểm nhận',
    endpackPicktext: '86 Nhặt hàng',
    endpackTotalquantity: '87 Tổng số lượng:',
    endpackCompletedprefix: '88 Đã',
    endpackChecklabel: '89 kiểm nhận:',
    endpackPicklabel: '90 nhặt hàng:',
    endpackOverprefix: '91 Vượt',
    endpackCheckoverlabel: '92 kiểm nhận:',
    endpackPickoverlabel: '93 nhặt hàng:',
    endpackPendingprefix: '94 Chưa',
    endpackCheckpendinglabel: '95 kiểm nhận:',
    endpackPickpendinglabel: '96 nhặt hàng:',
    endpackCancel: '97 Hủy',
    endpackConfirm: '98 Xác nhận',
    entrycourierinfoDialogtitle: '99 Nhập thông tin đơn vị vận chuyển',
    entrycourierinfoDocumentnumber: '100 Mã đơn',
    entrycourierinfoSender: '101 Bên gửi',
    entrycourierinfoReceiver: '102 Bên nhận',
    entrycourierinfoModify: '103 Sửa',
    entrycourierinfoSelectentrymethod: '104 Chọn phương thức nhập:',
    entrycourierinfoAutojdorder: '105 Tự động đặt hàng JD',
    entrycourierinfoManualorder: '106 Đặt hàng thủ công',
    entrycourierinfoNoexpressshipment: '107 Giao hàng không cần đơn vị vận chuyển',
    entrycourierinfoScanexpressno: '108 Vui lòng quét hoặc nhập số vận đơn',
    entrycourierinfoConfirm: '109 Xác nhận',
    entrycourierinfoLogisticscompany: '110 Đơn vị vận chuyển',
    entrycourierinfoPleaseselect: '111 Vui lòng chọn',
    entrycourierinfoPaymenttype: '112 Trả ngay/Thanh toán cuối tháng',
    entrycourierinfoMonthlyaccount: '113 Tài khoản thanh toán cuối tháng',
    entrycourierinfoCashpayment: '114 Trả ngay',
    entrycourierinfoMonthlypayment: '115 Thanh toán cuối tháng',
    entrycourierinfoEstimatedweight: '116 Khối lượng dự kiến:',
    entrycourierinfoKilogram: ' kilogram',
    entrycourierinfoWeightcalculation: ' (Tính theo trọng lượng gram của hàng hóa)',
    entrycourierinfoHeavyweightexpress: '119 Khối lượng hiện tại >30kg, sẽ đặt JD Fast Express (Hàng nặng)',
    entrycourierinfoLightweightexpress: '120 Khối lượng hiện tại <30kg, sẽ đặt JD Express (Hàng nhẹ)',
    entrycourierinfoSystemruleorder: '121 Đặt hàng theo quy tắc hệ thống',
    entrycourierinfoForceheavyexpress: '122 Bắt buộc đặt hàng nặng (Fast Express)',
    entrycourierinfoCancel: '123 Hủy',
    entrycourierinfoSubmit: '124 Xác nhận',
    entrycourierinfoModifyreceivername: '125 Vui lòng sửa tên người nhận',
    entrycourierinfoInputreceivername: '126 Nhập tên người nhận',
    entrycourierinfoModifyreceiverphone: '127 Vui lòng sửa số điện thoại người nhận',
    entrycourierinfoInputreceiverphone: '128 Nhập số điện thoại người nhận',
    entrycourierinfoRequiredlogisticscompany: '129 Vui lòng chọn đơn vị vận chuyển',
    entrycourierinfoRequiredexpressno: '130 Vui lòng điền số vận đơn',
    entrycourierinfoRequiredpaymenttype: '131 Vui lòng chọn Trả ngay/Thanh toán cuối tháng',
    entrycourierinfoRequiredmonthlyaccount: '132 Vui lòng điền tài khoản thanh toán cuối tháng',
    entrycourierinfoOperationsuccess: '133 Thao tác thành công',
    packageepcphDialogtitle: '134 Thông báo',
    packageepcphPackagedetails: '135 Chi tiết kiện hàng',
    packageepcphSearchlabel: '136 Mã hàng/Mã vạch/Mã rút gọn',
    packageepcphSearchplaceholder: '137 Nhập xong nhấn Enter để tìm kiếm',
    packageepcphGoodstab: '138 Hàng hóa',
    packageepcphTotal: '139 Tổng cộng',
    packageepcphTotalamount: '140 Tổng số mẫu:',
    packageepcphUnitpiece: ' mẫu',
    packageepcphTotalcount: '142 Tổng số lượng:',
    packageepcphUnititem: ' lượng/chiếc',
    packageepcphColumngoodsno: '144 Mã hàng',
    packageepcphColumngoodsname: '145 Tên hàng hóa',
    packageepcphColumncolor: '146 Màu sắc',
    packageepcphColumnsize: '147 Kích cỡ',
    packageepcphColumnquantity: '148 Số lượng',
    packageepcphColumntotal: '149 Tổng số',
    printdeliveryorderPrinttitle: '150 In đơn',
    printdeliveryorderDeliveryinfotitle: '151 Thông tin đơn kèm hàng',
    printdeliveryorderPackageinfotitle: '152 Thông tin kiện hàng',
    printdeliveryorderPrintbutton: '153 In',
    printdeliveryorderDocumentdatelabel: '154 Ngày đơn:',
    printdeliveryorderDocumentnolabel: '155 Số đơn:',
    printdeliveryorderSenderlabel: '156 Bên giao hàng:',
    printdeliveryorderReceiverlabel: '157 Bên nhận hàng:',
    printdeliveryorderPackagenolabel: '158 Mã kiện hàng:',
    printdeliveryorderStorenolabel: '159 Mã cửa hàng:',
    printdeliveryorderRemarklabel: '160 Ghi chú:',
    printdeliveryorderRemarkcontent: '161 Đây là nội dung ghi chú',
    printdeliveryorderEstimatedweightlabel: '162 Khối lượng dự kiến:',
    printdeliveryorderActualweightlabel: '163 Khối lượng thực tế:',
    printdeliveryorderSummarycolumn: '164 Tổng hợp',
    printdeliveryorderGoodsnamecolumn: '165 Tên hàng hóa',
    printdeliveryorderGoodsnocolumn: '166 Mã hàng',
    printdeliveryorderColorcolumn: '167 Màu sắc',
    printdeliveryorderGoodsdistributiontitle: '168 Phiếu cung cấp hàng hóa cho cửa hàng',
    printdeliveryorderStoreouttitle: '169 Phiếu điều chuyển xuất của cửa hàng',
    printdeliveryorderStorereturntitle: '170 Phiếu trả hàng của cửa hàng',
    printdeliveryorderStorereturnsupplytitle: '171 Phiếu trả hàng cho nhà cung cấp từ cửa hàng',
    puhuotablePhnumber: '172 Số lượng cung cấp',
    puhuotableTcnumber: '173 Số lượng trả kho',
    puhuotableDbnumber: '174 Số lượng điều chuyển',
    puhuotableChnumber: '175 Số lượng xuất hàng',
    puhuotableChdnumber: '176 Chênh lệch xuất hàng',
    puhuotableRknumber: '177 Số lượng nhập kho',
    puhuotableRkdnumber: '178 Chênh lệch nhập kho',
    puhuotableSummary: '179 Tổng hợp',
    puhuotableOperation: '180 Thao tác',
    puhuotableUsablestock: '181 Tồn kho khả dụng',
    puhuotableTgnumber: '182 Số lượng trả NCC',
    puhuotableThnumber: '183 Số lượng trả hàng',
    puhuotableTotal: '184 Tổng',
    puhuotableReceived: '185 Đã',
    puhuotableUnreceived: '186 Chưa',
    puhuotableDelete: '187 Xóa',
    puhuotableTotalrow: '188 Tổng cộng',
    puhuotableTotalamount: '189 Tổng số mẫu',
    puhuotableRetailtotal: '190 Tổng giá bán lẻ',
    puhuotableTotalpieces: '191 Tổng số lượng',
    puhuotableShipmentdifftotal: '192 Tổng chênh lệch xuất',
    puhuotableStoragedifftotal: '193 Tổng chênh lệch nhập',
    puhuotableConfirmdelete: '194 Bạn có chắc chắn muốn xóa bản ghi này?',
    puhuotableTips: '195 Thông báo',
    puhuotableOperationsuccess: '196 Thao tác thành công',
    puhuotableInputpositiveinteger: '197 Vui lòng nhập số nguyên lớn hơn hoặc bằng 0',
    puhuotableTransferlimit: '198 Số lượng điều chuyển không được lớn hơn tồn kho khả dụng',
    puhuotableInputvalidvalue: '199 Vui lòng nhập giá trị hợp lệ',
    puhuotableConfirmclear: '200 Bạn có chắc chắn muốn làm trống các bản ghi?',
    puhuotableCheckablequantity: '201 Số lượng có thể kiểm nhận là',
    puhuotableTransferstock: '202 Số lượng điều chuyển',
    puhuotableTipsV1: '203 Thông báo',
    puhuotablePuhuonum: '204 Số lượng cung cấp',
    puhuotableTuicangnum: '205 Số lượng trả kho',
    puhuotableDiaobonum: '206 Số lượng điều chuyển',
    puhuotableChuhuonum: '207 Số lượng xuất hàng',
    puhuotableChuhuodiff: '208 Chênh lệch xuất hàng',
    puhuotableRukunum: '209 Số lượng nhập kho',
    puhuotableRukudiff: '210 Chênh lệch nhập kho',
    puhuotableTihuonum: '211 Số lượng nhận hàng',
    puhuotableTuigongnum: '212 Số lượng trả NCC',
    puhuotableYitinum: '213 Số lượng đã nhận',
    puhuotableWeitinum: '214 Số lượng chưa nhận',
    puhuotableCaigounum: '215 Số lượng mua hàng',
    puhuotableAvailablestock: '216 Tồn kho khả dụng',
    puhuotableOccupiedstock: '217 Tồn kho đã được phân bổ',
    puhuotableTransitstock: '218 Tồn kho đang trên đường',
    puhuotableFinishedfirstorder: '219 Đơn thành phẩm đầu tiên',
    puhuotableFinishedreplenishorder: '220 Đơn bổ sung thành phẩm',
    puhuotableProcessfirstorder: '221 Đơn gia công đầu tiên',
    puhuotableProcessreplenishorder: '222 Đơn bổ sung gia công',
    puhuotableMaterialfirstorder: '223 Đơn nguyên phụ liệu đầu tiên',
    puhuotablePuhuocount: '224 Số cung cấp',
    puhuotableTuicangcount: '225 Số trả kho',
    puhuotableDiaobocount: '226 Số điều chuyển',
    puhuotableReturnsupply: '227 Trả NCC',
    puhuotableOrderquantitygarment: '228 Số lượng đặt hàng (Thành phẩm)',
    puhuotableCompletequantity: '229 Số lượng hoàn thành',
    puhuotableDifference: '230 Chênh lệch',
    puhuotableOriginaltransitstock: '231 Tồn kho trên đường ban đầu',
    puhuotableAdjustto: '232 Điều chỉnh thành',
    puhuotableTotalcount: '233 Tổng số',
    puhuotableAlreadyreceived: '234 Đã nhận',
    puhuotableNotreceived: '235 Chưa nhận',
    puhuotablePurchasecount: '236 Số mua hàng',
    puhuotableStoragecount: '237 Số nhập kho',
    puhuotableAlreadytaken: '238 Số đã nhận',
    puhuotableNottaken: '239 Số chưa nhận',
    puhuotableCurrenttakedelivery: '240 Lần nhận hàng này',
    puhuotableReturncount: '241 Số trả hàng',
    puhuotableSelectdate: '242 Chọn ngày',
    puhuotableDeleteV1: '243 Xóa',
    puhuotableBatchmodify: '244 Sửa hàng loạt',
    puhuotableTotalV1: '245 Tổng cộng',
    puhuotableTotalstyles: '246 Tổng số mẫu',
    puhuotableTotalpiecesV1: '247 Tổng số lượng',
    puhuotableTotalprice: '248 Tổng giá',
    puhuotableTotalretailprice: '249 Tổng giá bán lẻ',
    puhuotableTotalshipmentdiff: '250 Tổng chênh lệch xuất',
    puhuotableTotalstoragediff: '251 Tổng chênh lệch nhập',
    puhuotableTotaladjustpieces: '252 Tổng số lượng điều chỉnh',
    puhuotableReturnsupplyamount: '253 Giá trị trả NCC',
    puhuotableBatchadjustretailprice: '254 Điều chỉnh giá bán lẻ hàng loạt',
    puhuotablePleaseinput: '255 Vui lòng nhập',
    puhuotableCancel: '256 Hủy',
    puhuotableConfirm: '257 Xác nhận',
    puhuotableAddpurchasequantity: '258 Vui lòng thêm số lượng hàng hóa cần mua',
    puhuotableSelectdeliverydaterange: '259 Vui lòng chọn khoảng thời gian giao hàng lần đầu',
    puhuotableFirstdeliverydateerror: '260 Ngày giao hàng lần đầu không được lớn hơn ngày giao hàng cuối cùng',
    puhuotableConfirmdeleteV1: '261 Bạn có chắc chắn muốn xóa bản ghi này?',
    puhuotableTip: '262 Thông báo',
    puhuotableOperationsuccessV1: '263 Thao tác thành công',
    puhuotableInputpositiveintegerV1: '264 Vui lòng nhập số nguyên lớn hơn hoặc bằng 0',
    puhuotableReturncannotexceedstock: '265 Số trả kho không được lớn hơn tồn kho khả dụng',
    puhuotableDistributioncannotexceedstock: '266 Số cung cấp không được lớn hơn tồn kho khả dụng',
    puhuotableTakecannotexceeduntaken: '267 Số nhận hàng không được lớn hơn số chưa nhận',
    puhuotableReturncannotexceedstorage: '268 Số trả NCC không được lớn hơn số nhập kho',
    puhuotableConfirmclearall: '269 Thao tác này sẽ làm trống các bản ghi đã thêm',
    puhuotableInputvalidvalueV1: '270 Vui lòng nhập giá trị hợp lệ',
    puhuotableCheckquantitylimit: '271 Số lượng có thể kiểm nhận là',
    puhuotableInputvalidvalueNum: '272 Vui lòng nhập số điều chỉnh',
    puhuotableSizegroup: '273 Nhóm kích cỡ',
    puhuotablePieces: ' Lượng/chiếc',
    returndialogTitle: '275 Thêm phiếu trả hàng NCC từ cửa hàng',
    returndialogConfirmsubmit: '276 Xác nhận gửi đi',
    returndialogFillinfo: '277 Vui lòng điền thông tin',
    returndialogReceiver: '278 Bên nhận hàng',
    returndialogSelectsupplier: '279 Vui lòng chọn nhà cung cấp',
    returndialogRemark: '280 Ghi chú',
    returndialogFillremark: '281 Vui lòng điền thông tin ghi chú',
    returndialogAddgoodsdetail: '282 Thêm chi tiết hàng hóa',
    returndialogSelectgoodsno: '283 Vui lòng chọn mã hàng',
    returndialogQuery: '284 Tìm kiếm',
    returndialogSelectallpages: '285 Chọn tất cả trên mọi trang',
    returndialogConfirmadd: '286 Xác nhận thêm',
    returndialogAddedgoodslist: '287 Danh sách hàng hóa đã thêm',
    returndialogSearchgoodsno: '288 Tìm kiếm mã hàng',
    returndialogInputgoodsno: '289 Nhập mã hàng',
    returndialogSearch: '290 Tìm kiếm',
    returndialogClearall: '291 Xóa trống một lần',
    returndialogInputcontent: '292 Nhập nội dung',
    returndialogGoodsno: '293 Mã hàng',
    returndialogGoodsname: '294 Tên mã hàng',
    returndialogAvailablestock: '295 Tồn kho khả dụng',
    returndialogProductname: '296 Tên hàng hóa',
    returndialogRetailprice: '297 Giá bán lẻ',
    returndialogColor: '298 Màu sắc',
    returndialogReturnsupplycount: '299 Số lượng trả NCC',
    returndialogPleaseselect: '300 Vui lòng chọn',
    returndialogSelectgoodsfirst: '301 Vui lòng chọn hàng hóa trước khi thêm',
    returndialogMaxaddlimit: '302 Có thể thêm tối đa',
    returndialogRecords: '303 {count} bản ghi một lần',
    returndialogSelectreceiver: '304 Vui lòng chọn bên nhận hàng',
    returndialogFillreturncount: '305 Vui lòng điền số lượng trả NCC',
    returndialogOperationsuccess: '306 Thao tác thành công',
    returndialogConfirmdelete: '307 Bạn có chắc chắn muốn xóa bản ghi này?',
    returndialogTip: '308 Thông báo',
    scantrajectoryTitle: '309 Lịch sử quét mã',
    scantrajectorySerialnumber: '310 STT',
    scantrajectoryScannedgoods: '311 Hàng hóa được quét mã',
    scantrajectoryGoodsno: '312 Mã hàng',
    scantrajectoryColor: '313 Màu sắc',
    scantrajectorySize: '314 Kích cỡ',
    scantrajectoryScancount: '315 Số lượng quét mã',
    detailTitle: '316 Chi tiết đơn',
    detailStartaccept: '317 Bắt đầu kiểm nhận',
    detailStartpick: '318 Bắt đầu nhặt hàng',
    detailInvoiceinfo: '319 Thông tin đơn',
    detailCreator: '320 Người tạo',
    detailSender: '321 Bên giao hàng',
    detailReceiver: '322 Bên nhận hàng',
    detailTransfernum: '323 Số lượng điều chuyển',
    detailOutnum: '324 Số lượng xuất hàng',
    detailInnum: '325 Số lượng nhập kho',
    detailOutdiffnum: '326 Số chênh lệch xuất',
    detailIndiffnum: '327 Số chênh lệch nhập',
    detailCreatetime: '328 Thời gian tạo',
    detailUpdatetime: '329 Thời gian cập nhật',
    detailLastmodifier: '330 Người sửa cuối',
    detailTotaltime: '331 Tổng thời gian',
    detailGoodsmanager: '332 Người phụ trách hàng hóa',
    detailRemark: '333 Ghi chú',
    detailDiffreason: '334 Nguyên nhân xuất hàng chênh lệch',
    detailProductlist: '335 Danh sách hàng hóa',
    detailDeliveryinfo: '336 Thông tin giao hàng',
    detailOrderno: '337 Mã đơn',
    detailPackageno: '338 Mã kiện hàng',
    detailProductnum: '339 Số lượng hàng hóa',
    detailLogisticsname: '340 Đơn vị logistics',
    detailExpressno: '341 Số vận đơn',
    detailStatus: '342 Trạng thái',
    detailPendingupdate: '343 Đang chờ cập nhật',
    detailPackfinishtime: '344 Thời gian hoàn tất đóng gói',
    detailShiptime: '345 Thời gian giao hàng',
    detailSigntime: '346 Thời gian ký nhận',
    detailAction: '347 Thao tác',
    detailViewpackage: '348 Xem kiện hàng',
    detailLogisticstrack: '349 Lộ trình logistics',
    detailModifyinfo: '350 Sửa thông tin',
    detailPrint: '351 In',
    detailDiffinfo: '352 Thông tin chênh lệch nhận hàng',
    detailConsignee: '353 Người nhận hàng',
    detailReceivefinishtime: '354 Thời gian hoàn tất nhận hàng',
    detailOutlabelnum: '355 Số lượng nhãn xuất hàng',
    detailDifference: '356 Chênh lệch',
    detailSenderduty: '357 Trách nhiệm bên giao',
    detailReceiverduty: '358 Trách nhiệm bên nhận',
    detailTransportduty: '359 Trách nhiệm đơn vị vận chuyển',
    detailUndetermined: '360 Chưa xác định trách nhiệm',
    detailDetermined: '361 Đã xác định trách nhiệm',
    detailViewdetail: '362 Xem chi tiết',
    detailCancelapply: '363 Lịch sử yêu cầu hủy đơn',
    detailApplicant: '364 Người yêu cầu',
    detailApplytime: '365 Thời gian yêu cầu',
    detailApplyreason: '366 Lý do yêu cầu',
    detailPendingapproval: '367 Chờ phê duyệt',
    detailApproved: '368 Đã phê duyệt',
    detailRejected: '369 Đã từ chối',
    detailApprover: '370 Người phê duyệt',
    detailApprovetime: '371 Thời gian phê duyệt',
    detailSelectpackage: '372 Vui lòng chọn mã kiện hàng',
    detailSelect: '373 Chọn',
    detailPackageexpressno: '374 Số vận đơn kiện hàng',
    detailAcceptstatus: '375 Trạng thái kiểm nhận',
    detailUnaccepted: '376 Chưa kiểm nhận',
    detailAccepting: '377 Đang kiểm nhận',
    detailAccepted: '378 Đã kiểm nhận',
    detailProductcount: '379 Số lượng hàng hóa',
    detailConfirm: '380 Xác nhận',
    detailChoosepackage: '381 Vui lòng chọn mã kiện hàng',
    detailPackageaccepted: '382 Kiện hàng này đã được kiểm nhận, không thể chọn!',
    detailUsepda: '383 Vui lòng sử dụng PDA để nhặt hàng',
    detailRfidnotice: '384 Đơn này đã được xuất hàng bằng chip RFID và cửa hàng đã bật chức năng nhận hàng bằng chip RFID. Vui lòng sử dụng máy kiểm kê để nhận hàng cho đơn này!',
    detailGotit: '385 Đã hiểu',
    detailCancelexpress: '386 Bạn có chắc chắn muốn hủy vận đơn?',
    detailCancelsuccess: '387 Hủy thành công',
    detailTip: '388 Thông báo',
    tableconfigGoodsname: '389 Tên hàng hóa',
    tableconfigGoodsnowithimage: '390 Mã hàng(Nhấp để xem ảnh)',
    tableconfigRetailprice: '391 Giá bán lẻ',
    tableconfigTotal: '392 Tổng hợp',
    tableconfigColor: '393 Màu sắc',
    tableconfigRemark: '394 Ghi chú',
    tableconfigGoodsno: '395 Mã hàng',
    tableconfigPuhuoquantity: '396 Số lượng cung cấp',
    tableconfigShipmentquantity: '397 Số lượng xuất hàng',
    tableconfigShipmentdifference: '398 Chênh lệch xuất hàng',
    tableconfigStoragequantity: '399 Số lượng nhập kho',
    tableconfigStoragedifference: '400 Chênh lệch nhập kho',
    tableconfigReturnwarehousequantity: '401 Số lượng trả kho',
    tableconfigReturnsupplierquantity: '402 Số lượng trả NCC',
    tableconfigTransferquantity: '403 Số lượng điều chuyển',
    tableconfigTotalitems: '404 Tổng số mẫu',
    tableconfigTotaltransferitems: '405 Tổng số lượng điều chuyển',
    tableconfigTotalshipmentdifference: '406 Tổng chênh lệch xuất',
    tableconfigTotalstoragedifference: '407 Tổng chênh lệch nhập',
    tableconfigView: '408 Xem',
    tableconfigUsableinventory: '409 Tồn kho khả dụng',
    tableconfigReturnquantity: '410 Số lượng trả hàng',
    tableconfigDelete: '411 Xóa',
    tableconfigShortcode: '412 Mã rút gọn',
    tableconfigQuantity: '413 Số lượng',
    tableconfigTotalgoods: '414 Tổng số hàng hóa',
    trackdialogTitle: '415 Lộ trình logistics',
    trackdialogSender: '416 Bên giao hàng',
    trackdialogContact: '417 Thông tin liên hệ',
    trackdialogSenderaddr: '418 Địa chỉ giao hàng',
    trackdialogLogisticsname: '419 Đơn vị vận chuyển',
    trackdialogExpressno: '420 Số vận đơn',
    trackdialogDeliverytime: '421 Thời gian dự kiến nhận hàng',
    trackdialogQuerybtn: '422 Truy vấn',
    trackdialogTableindex: '423 STT',
    trackdialogTabletime: '424 Thời gian',
    trackdialogTabletrack: '425 Lộ trình logistics',
    checkacceptpackdrawerTitle: '426 Kiểm nhận',
    checkacceptpackdrawerSender: '427 Bên giao hàng:',
    checkacceptpackdrawerInvoicessn: '428 Mã đơn',
    checkacceptpackdrawerPackageno: '429 Mã kiện hàng',
    checkacceptpackdrawerOnekeyaccept: '430 Kiểm nhận một lần',
    checkacceptpackdrawerClearall: '431 Xóa số liệu kiểm nhận',
    checkacceptpackdrawerCompleteaccept: '432 Hoàn tất kiểm nhận và gửi',
    checkacceptpackdrawerScanplaceholder: '433 Vui lòng quét mã hoặc nhập mã vạch',
    checkacceptpackdrawerConfirm: '434 Xác nhận',
    checkacceptpackdrawerNegativescan: '435 Quét âm (Giảm)',
    checkacceptpackdrawerPositivescan: '436 Quét dương (Tăng)',
    checkacceptpackdrawerShowunreceived: '437 Chỉ hiển thị chưa nhận',
    checkacceptpackdrawerEntergoodsno: '438 Nhập mã hàng',
    checkacceptpackdrawerQuery: '439 Tìm kiếm',
    checkacceptpackdrawerScantrajectory: '440 Lịch sử quét mã',
    checkacceptpackdrawerCurrentgoods: '441 Hàng hóa đang quét mã',
    checkacceptpackdrawerGoodsno: '442 Mã hàng',
    checkacceptpackdrawerColor: '443 Màu sắc',
    checkacceptpackdrawerSize: '444 Kích cỡ',
    checkacceptpackdrawerQuantity: '445 Số lượng',
    checkacceptpackdrawerMinaccept: '446 Vui lòng kiểm nhận ít nhất một mặt hàng',
    checkacceptpackdrawerNodifference: '447 Không cho phép gửi khi có chênh lệch, vui lòng liên hệ nhân viên hàng hóa',
    checkacceptpackdrawerSuccess: '448 Thao tác thành công',
    checkacceptpackdrawerNoacceptyet: '449 Chưa bắt đầu kiểm nhận',
    checkacceptpackdrawerMaxaccept: '450 Số lượng có thể kiểm nhận là',
    checkacceptpackdrawerGoodsnoNum: '451 Tên hàng hóa',
    checkacceptpackdrawerProductName: '452 Mã hàng',
    checkacceptpacktableGoodsname: '453 Tên hàng hóa',
    checkacceptpacktableGoodsno: '454 Mã hàng (Nhấp để xem ảnh)',
    checkacceptpacktableColor: '455 Màu sắc',
    checkacceptpacktableTotal: '456 Tổng hợp',
    checkacceptpacktableTotalnum: '457 Tổng số',
    checkacceptpacktableReceived: '458 Đã nhận',
    checkacceptpacktableUnreceived: '459 Chưa nhận',
    checkacceptpacktableTotalitems: '460 Tổng số lượng',
    checkacceptpacktableFooterreceived: '461 Đã nhận',
    checkacceptpacktableFooterunreceived: '462 Chưa nhận',
    distributioncheckTitle: '463 Kiểm nhận',
    distributioncheckSenderlabel: '464 Bên giao hàng:',
    distributioncheckInvoicenolabel: '465 Mã đơn',
    distributioncheckPackagenolabel: '466 Mã kiện hàng',
    distributioncheckOnekeyacceptancebtn: '467 Kiểm nhận một lần',
    distributioncheckClearacceptancebtn: '468 Xóa số liệu kiểm nhận',
    distributioncheckSubmitbtn: '469 Hoàn tất kiểm nhận và gửi',
    distributioncheckBarcodeplaceholder: '470 Vui lòng quét mã hoặc nhập mã vạch',
    distributioncheckNegativescan: '471 Quét âm (Giảm)',
    distributioncheckPositivescan: '472 Quét dương (Tăng)',
    distributioncheckOnlyshowunreceived: '473 Chỉ hiển thị chưa nhận',
    distributioncheckGoodsnoplaceholder: '474 Nhập mã hàng',
    distributioncheckSearchbtn: '475 Tìm kiếm',
    distributioncheckScantrajectorybtn: '476 Lịch sử quét mã',
    distributioncheckCurrentgoodslabel: '477 Hàng hóa đang quét mã',
    distributioncheckGoodsnolabel: '478 Mã hàng',
    distributioncheckColorlabel: '479 Màu sắc',
    distributioncheckSizelabel: '480 Kích cỡ',
    distributioncheckQuantitylabel: '481 Số lượng',
    distributioncheckAtleastoneaccept: '482 Vui lòng kiểm nhận ít nhất một mặt hàng',
    distributioncheckNodiffsubmit: '483 Không cho phép gửi khi có chênh lệch, vui lòng liên hệ nhân viên hàng hóa',
    distributioncheckNoacceptyet: '484 Chưa bắt đầu kiểm nhận',
    distributioncheckOperationsuccess: '485 Thao tác thành công',
    distributioncheckAcceptablequantity: '486 Số lượng có thể kiểm nhận là',
    distributioncheckProductsubmit: '487 Xác nhận',
    distributioncheckProductNamelabel: '488 Tên hàng hóa',
    distributiondetailTitle: '489 Chi tiết đơn',
    distributiondetailStartacceptbtn: '490 Bắt đầu kiểm nhận',
    distributiondetailInvoiceinfosection: '491 Thông tin đơn',
    distributiondetailCreatorlabel: '492 Người tạo',
    distributiondetailSenderlabel: '493 Bên giao hàng',
    distributiondetailReceiverlabel: '494 Bên nhận hàng',
    distributiondetailPlancountlabel: '495 Số lượng kế hoạch',
    distributiondetailShipmentcountlabel: '496 Số lượng xuất hàng',
    distributiondetailStoragecountlabel: '497 Số lượng nhập kho',
    distributiondetailShipmentdiffcountlabel: '498 Số chênh lệch xuất',
    distributiondetailStoragediffcountlabel: '499 Số lượng chênh lệch khi nhập kho',
    distributiondetailCreatetimelabel: '500 Thời gian tạo',
    distributiondetailUpdatetimelabel: '501 Thời gian cập nhật',
    distributiondetailLastmodifierlabel: '502 Người sửa cuối',
    distributiondetailTotaltimelabel: '503 Tổng thời gian xử lý',
    distributiondetailProductmanagerlabel: '504 Người phụ trách hàng hóa',
    distributiondetailRemarklabel: '505 Ghi chú',
    distributiondetailProductlistsection: '506 Danh sách hàng hóa',
    distributiondetailShipmentinfosection: '507 Thông tin giao hàng',
    distributiondetailInvoicenolabel: '508 Số đơn',
    distributiondetailSendernamelabel: '509 Bên giao hàng',
    distributiondetailReceivernamelabel: '510 Bên nhận hàng',
    distributiondetailPackagenolabel: '511 Số kiện hàng',
    distributiondetailProductcountlabel: '512 Số lượng hàng hóa',
    distributiondetailWeightlabel: '513 Trọng lượng',
    distributiondetailLogisticscompanylabel: '514 Đơn vị vận chuyển',
    distributiondetailTrackingnolabel: '515 Số vận đơn',
    distributiondetailStatuslabel: '516 Trạng thái',
    distributiondetailShipmenttimelabel: '517 Thời gian giao hàng',
    distributiondetailSigntimelabel: '518 Thời gian ký nhận',
    distributiondetailActionlabel: '519 Thao tác',
    distributiondetailViewpackagebtn: '520 Xem kiện hàng',
    distributiondetailTrackingbtn: '521 Lộ trình vận chuyển',
    distributiondetailDiffinfosection: '522 Thông tin chênh lệch khi nhận hàng',
    distributiondetailReceiverlabelV1: '523 Người nhận hàng',
    distributiondetailReceivecompletetimelabel: '524 Thời gian hoàn thành nhận hàng',
    distributiondetailShipmentlabelcountlabel: '525 Số lượng nhãn xuất hàng',
    distributiondetailDifferencelabel: '526 Chênh lệch',
    distributiondetailSenderresponsibilitylabel: '527 Trách nhiệm bên giao',
    distributiondetailReceiverresponsibilitylabel: '528 Trách nhiệm bên nhận',
    distributiondetailTransportresponsibilitylabel: '529 Trách nhiệm bên vận chuyển',
    distributiondetailUndeterminedresponsibility: '530 Chưa xác định trách nhiệm',
    distributiondetailDeterminedresponsibility: '531 Đã xác định trách nhiệm',
    distributiondetailViewdetailbtn: '532 Xem chi tiết',
    distributiondetailCancelrecordsection: '533 Lịch sử yêu cầu hủy',
    distributiondetailApplicantlabel: '534 Người yêu cầu',
    distributiondetailApplytimelabel: '535 Thời gian yêu cầu',
    distributiondetailApplyreasonlabel: '536 Lý do yêu cầu',
    distributiondetailPendingapproval: '537 Chờ phê duyệt',
    distributiondetailApproved: '538 Đã phê duyệt',
    distributiondetailRejected: '539 Đã từ chối',
    distributiondetailApproverlabel: '540 Người phê duyệt',
    distributiondetailApprovetimelabel: '541 Thời gian phê duyệt',
    distributiondetailSelectpackagetitle: '542 Vui lòng chọn số kiện hàng',
    distributiondetailSelectlabel: '543 Chọn',
    distributiondetailConfirmbtn: '544 Xác nhận',
    distributiondetailNotaccepted: '545 Chưa kiểm nhận',
    distributiondetailAcceptin: '546 Đang kiểm nhận',
    distributiondetailAccepted: '547 Đã kiểm nhận',
    distributiondetailNotcollected: '548 Chưa nhận hàng',
    distributiondetailPendingshipment: '549 Chờ giao hàng',
    distributiondetailIntransit: '550 Đang vận chuyển',
    distributiondetailIndelivery: '551 Đang giao hàng',
    distributiondetailDelivered: '552 Giao hàng thành công',
    distributiondetailCancelexpressconfirm: '553 Xác nhận hủy vận đơn?',
    distributiondetailCancelsuccess: '554 Hủy thành công',
    distributiondetailRfidwarningmsg: '555 Đơn này đã xuất hàng bằng chip RFID và cửa hàng đã kích hoạt chức năng nhận hàng bằng chip RFID. Vui lòng sử dụng máy kiểm kê để nhận hàng cho đơn này!',
    distributiondetailWarningtitle: '556 Thông báo',
    distributiondetailConfirmknow: '557 Đã hiểu',
    distributiondetailNoacceptyet: '558 Kiện hàng này đã được kiểm nhận, không thể chọn!',
    endpackAccepttitle: '559 Hoàn thành kiểm nhận',
    endpackPicktitle: '560 Hoàn thành nhặt hàng',
    endpackAcceptconfirmmsg: '561 Dữ liệu hiện tại có chênh lệch. Tiếp tục "Gửi kiểm nhận"?',
    endpackPickconfirmmsg: '562 Dữ liệu hiện tại có chênh lệch. Tiếp tục "Gửi nhặt hàng"?',
    endpackTotalcountlabel: '563 Tổng số lượng:',
    endpackAcceptedlabel: '564 Đã kiểm nhận:',
    endpackPickedlabel: '565 Đã nhặt hàng:',
    endpackOveracceptlabel: '566 Vượt kiểm nhận:',
    endpackOverpicklabel: '567 Vượt nhặt hàng:',
    endpackUnacceptlabel: '568 Chưa kiểm nhận:',
    endpackUnpicklabel: '569 Chưa nhặt hàng:',
    endpackCancelbtn: '570 Hủy bỏ',
    endpackConfirmbtn: '571 Xác nhận',
    packageepcphDialogtitleV1: '572 Thông báo',
    packageepcphPackagedetail: '573 Chi tiết kiện hàng',
    packageepcphGoodsinputlabel: '574 Mã hàng/Mã vạch/Mã rút gọn',
    packageepcphInputplaceholder: '575 Nhập và nhấn Enter để tìm kiếm',
    packageepcphGoodstabV1: '576 Hàng hóa',
    packageepcphTotallabel: '577 Tổng cộng',
    packageepcphTotalamountlabel: '578 Tổng số mẫu:',
    packageepcphUnitpieceV1: ' mẫu',
    packageepcphTotalquantitylabel: '580 Tổng số lượng:',
    packageepcphUnititemV1: ' chiếc',
    packageepcphGridgoodsno: '582 Mã hàng',
    packageepcphGridgoodsname: '583 Tên hàng hóa',
    packageepcphGridcolor: '584 Màu sắc',
    packageepcphGridsize: '585 Kích cỡ',
    packageepcphGridquantity: '586 Số lượng',
    packageepcphGridtotal: '587 Tổng số',
    submitdialogDialogtitle: '588 Số lượng nhận hàng có chênh lệch. Vui lòng xác nhận tình trạng chênh lệch.',
    submitdialogOrdernolabel: '589 Số đơn:',
    submitdialogPackagenolabel: '590 Số kiện hàng:',
    submitdialogTotallabel: '591 Tổng số:',
    submitdialogReceivedlabel: '592 Đã nhận:',
    submitdialogUnreceivedlabel: '593 Chưa nhận:',
    submitdialogInstruction: '594 Quay lại màn hình và lọc "Chỉ xem chưa nhận xong" để kiểm đếm số lượng thực tế của hàng hóa chưa nhận đủ. Nếu phát hiện còn thiếu, hãy tiếp tục thao tác nhận bổ sung.',
    submitdialogInstructionV1: '595 <span style="color:red;">Nếu thực sự thiếu hàng</span>, vui lòng kiểm đếm toàn bộ số lượng hàng hóa dưới sự giám sát, chụp ảnh bao bì và mặt phiếu giao hàng để lưu, sau đó nhấn nút "Gửi chênh lệch" bên dưới. Hệ thống sẽ tạo bản ghi chênh lệch cho <span style="color:red;">{count}</span> chiếc chưa nhận. Cửa hàng cần liên hệ chuyên viên IT để phản hồi tình trạng chênh lệch và chờ xác minh từ hậu thuẫn. Có thể xem bản ghi chênh lệch trong Chi tiết đơn hàng.',
    submitdialogSubmitbtn: '596 Xác nhận thiếu hàng, Gửi chênh lệch nhận hàng',
    tableconfigGoodsnameV1: '597 Tên hàng hóa',
    tableconfigGoodsnowithimageV1: '598 Mã hàng(Nhấn để xem ảnh)',
    tableconfigRetailpriceV1: '599 Giá bán lẻ',
    tableconfigColorV1: '600 Màu sắc',
    tableconfigTotalV1: '601 Tổng hợp',
    tableconfigDistributionquantity: '602 Số lượng phân phối',
    tableconfigShipmentquantityV1: '603 Số lượng xuất hàng',
    tableconfigShipmentdifferenceV1: '604 Chênh lệch xuất hàng',
    tableconfigStoragequantityV1: '605 Số lượng nhập kho',
    tableconfigStoragedifferenceV1: '606 Chênh lệch nhập kho',
    tableconfigShortcodeV1: '607 Mã rút gọn',
    tableconfigGoodsnoV1: '608 Mã hàng',
    tableconfigQuantityV1: '609 Số lượng',
    tableconfigTotalstyles: '610 Tổng số mẫu',
    tableconfigUnitpiece: ' mẫu',
    tableconfigTotalitemsV1: '612 Tổng số lượng',
    tableconfigUnititem: ' chiếc',
    configbutionOrderno: '614 Số đơn phân phối hàng',
    configbutionState: '615 Trạng thái',
    configbutionStatedraft: '616 Đơn nháp (xanh dương): Lưu tạm bản nháp đơn, không chiếm dụng tồn kho.',
    configbutionStatepresubmit: '617 Gửi trước (tím): Gửi đơn trước, nhưng chưa chuyển xuống kho, sẽ chiếm dụng tồn kho của kho.',
    configbutionStatereleased: '618 Đã chuyển xuống (xanh lá): Đã gửi đơn và chuyển xuống kho, chờ kho nhặt hàng xuất kho.',
    configbutionStatepicking: '619 Đang nhặt hàng (cam): Kho đã nhận chỉ thị, đang tiến hành nhặt hàng xuống kệ.',
    configbutionStatepickcompleted: '620 Hoàn thành nhặt hàng (xanh lá): Kho đã hoàn thành nhặt hàng và gửi, đặt vào khu vực chờ đóng gói.',
    configbutionStatepacking: '621 Đang đóng gói (cam): Người đóng gói đang niêm phong túi đóng gói.',
    configbutionStatepackcompleted: '622 Hoàn thành đóng gói (xanh lá): Đã đóng gói xong, chờ nhập thông tin vận chuyển để xuất hàng.',
    configbutionStateshipped: '623 Đã xuất hàng (xanh dương): Kho đã nhặt hàng theo đơn và xuất kho, sẽ trừ tồn kho kho, trạng thái logistics đang trên đường. Sẽ tăng tồn kho đang về của cửa hàng.',
    configbutionStateshippeddetail: '624 Sẽ tăng hàng đang trên đường về cửa hàng',
    configbutionStatesigned: '625 Đã ký nhận (xanh lá): Khi giao hàng bằng đối tác vận chuyển, thông tin logistics đã cho thấy cửa hàng đã ký nhận, chờ cửa hàng mở kiểm nhận.',
    configbutionStatechecking: '626 Đang kiểm nhận (cam): Cửa hàng đang mở gói và kiểm nhận.',
    configbutionStatestockin: '627 Đã nhập kho (xanh lá): Sau khi kiểm nhận hoàn tất, thao tác xác nhận nhập kho, tồn kho đang về của cửa hàng sẽ chuyển thành tồn kho thực tế được tăng.',
    configbutionStatecancelled: '628 Đã hủy (đỏ): Các trạng thái Đơn nháp, Gửi trước, Đã chuyển xuống có thể được thực hiện thao tác hủy.',
    configbutionStatecancelapply: '629 Yêu cầu hủy (đỏ): Đơn hàng đã xuất hàng thực hiện yêu cầu hủy.',
    configbutionHasdiscrepancy: '630 Chênh lệch nhận hàng chờ xử lý',
    configbutionYes: '631 Có',
    configbutionNo: '632 Không',
    configbutionUpdatetime: '633 Thời gian cập nhật',
    configbutionSender: '634 Bên giao hàng',
    configbutionBoxorderno: '635 Số đơn theo thùng',
    configbutionReceiver: '636 Bên nhận hàng',
    configbutionIncomingquantity: '637 Số lượng hàng đến',
    configbutionStockinquantity: '638 Số lượng nhập kho',
    configbutionOrderpackagecount: '639 Số kiện hàng theo đơn',
    configbutionShippedpackagecount: '640 Số kiện hàng đã xuất',
    configbutionReceivedpackagecount: '641 Số kiện hàng đã nhận',
    configbutionUnreceivedpackagecount: '642 Số kiện hàng chưa nhận',
    configbutionStockindifference: '643 Số lượng chênh lệch nhập kho',
    configbutionGoodsmanager: '644 Người phụ trách hàng hóa',
    configbutionRemark: '645 Ghi chú',
    configbutionCreator: '646 Người tạo',
    configbutionCreatetime: '647 Thời gian tạo',
    configbutionModifier: '648 Người sửa',
    configbutionSelectstateplaceholder: '649 Vui lòng chọn trạng thái',
    configbutionStateshippedtext: '650 Đã xuất hàng',
    configbutionStatesignedtext: '651 Đã ký nhận',
    configbutionStatecheckingtext: '652 Đang kiểm nhận',
    configbutionStatestockintext: '653 Đã nhập kho',
    configbutionStatecancelapplytext: '654 Yêu cầu hủy',
    configbutionSelectplaceholder: '655 Vui lòng chọn',
    configbutionFilterdiscrepancy: '656 Xem Chưa Xử Lý Khác Hàng?',
    configbutionHasdiscrepancyrecord: '657 Có bản ghi chênh lệch không?',
    configbutionInputordernoplaceholder: '658 Vui lòng nhập số đơn',
    configbutionOrdernolabel: '659 Số đơn',
    configbutionInputexpressnoplaceholder: '660 Vui lòng nhập số vận đơn',
    configbutionExpressnolabel: '661 Số vận đơn',
    configbutionInputboxordernoplaceholder: '662 Vui lòng nhập số đơn theo thùng',
    configbutionSelectsenderplaceholder: '663 Vui lòng chọn bên giao hàng',
    configbutionInputgoodsnoplaceholder: '664 Vui lòng nhập mã hàng, nhiều mã cách nhau bằng dấu cách',
    configbutionGoodsnolabel: '665 Mã hàng',
    configbutionInputcreatorplaceholder: '666 Vui lòng nhập người tạo',
    configbutionSelectgoodsmanagerplaceholder: '667 Vui lòng chọn người phụ trách hàng hóa',
    configbutionSelectcreatetimeplaceholder: '668 Vui lòng chọn thời gian tạo',
    configbutionSelectupdatetimeplaceholder: '669 Vui lòng chọn thời gian cập nhật',
    configbutionSearchbutton: '670 Tìm kiếm',
    configbutionResetbutton: '671 Đặt lại',
    configtransSn: '672 Số đơn',
    configtransStatedesc: '673 Trạng thái',
    statedescShipmentout: '674 Đã xuất hàng (xanh dương): Cửa hàng đã nhặt hàng theo đơn trả kho và xuất kho, sẽ trừ tồn kho cửa hàng, trạng thái logistics đang trên đường. Sẽ tăng tồn kho đang về của kho.',
    statedescSigned: '675 Đã ký nhận (tím): Khi giao hàng bằng đối tác vận chuyển, thông tin logistics đã cho thấy kho đã ký nhận, chờ kho mở kiểm nhận.',
    statedescChecking: '676 Đang kiểm nhận (cam): Kho đang mở gói và kiểm nhận.',
    statedescInstock: '677 Đã nhập kho (xanh lá): Sau khi kiểm nhận hoàn tất, thao tác xác nhận nhập kho, tồn kho đang về của kho sẽ chuyển thành tồn kho thực tế được tăng.',
    statedescCancelapply: '678 Yêu cầu hủy (đỏ): Đơn hàng đã xuất hàng thực hiện yêu cầu hủy.',
    configtransIfdiscrepancy: '679 Chênh lệch nhận hàng chờ xử lý',
    configtransYes: '680 Có',
    configtransNo: '681 Không',
    configtransOutmarketname: '682 Bên giao hàng',
    configtransInmarketname: '683 Bên nhận hàng',
    configtransTotalnum: '684 Số lượng kế hoạch',
    configtransOutnum: '685 Số lượng xuất hàng',
    configtransOutpackagenum: '686 Số kiện hàng xuất',
    configtransOutnumdifference: '687 Số lượng chênh lệch xuất hàng',
    configtransInnum: '688 Số lượng nhập kho',
    configtransLogisticpackagechecknum: '689 Số kiện hàng nhập',
    configtransInnumdifference: '690 Số lượng chênh lệch nhập kho',
    configtransRemark: '691 Ghi chú',
    configtransCreateusername: '692 Người tạo',
    configtransCreatetime: '693 Thời gian tạo',
    configtransUpdatetime: '694 Thời gian cập nhật',
    configtransUpdateusername: '695 Người sửa',
    placeholderInvoicesno: '696 Vui lòng nhập số đơn',
    labelInvoicesno: '697 Số đơn',
    placeholderSelect: '698 Vui lòng chọn',
    labelIfdiscrepancy: '699 Xem Chưa Xử Lý Khác Hàng?',
    labelHasdiscrepancy: '700 Có bản ghi chênh lệch không?',
    placeholderExpressno: '701 Vui lòng nhập số vận đơn',
    labelExpressno: '702 Số vận đơn',
    placeholderState: '703 Vui lòng chọn trạng thái',
    labelState: '704 Trạng thái',
    stateShipmentout: '705 Đã xuất hàng',
    stateSigned: '706 Đã ký nhận',
    stateChecking: '707 Đang kiểm nhận',
    stateInstock: '708 Đã nhập kho',
    stateCancelapply: '709 Yêu cầu hủy',
    stateCanceled: '710 Đã hủy',
    placeholderOutmarket: '711 Vui lòng chọn bên giao hàng',
    labelOutmarket: '712 Bên giao hàng',
    placeholderGoodsno: '713 Vui lòng nhập mã hàng, nhiều mã cách nhau bằng dấu cách',
    labelGoodsno: '714 Mã hàng',
    placeholderCreateuser: '715 Vui lòng nhập người tạo',
    labelCreateuser: '716 Người tạo',
    placeholderCreatetime: '717 Vui lòng chọn thời gian tạo',
    labelCreatetime: '718 Thời gian tạo',
    placeholderUpdatetime: '719 Vui lòng chọn thời gian cập nhật',
    labelUpdatetime: '720 Thời gian cập nhật',
    btnSearch: '721 Tìm kiếm',
    btnReset: '722 Đặt lại',
    distributionStartcheck: '723 Bắt đầu kiểm nhận',
    distributionSelectpackagetitle: '724 Vui lòng chọn số kiện hàng',
    distributionSelect: '725 Chọn',
    distributionPackagesn: '726 Số kiện hàng',
    distributionExpresssn: '727 Số vận đơn của kiện hàng',
    distributionLogisticsname: '728 Đơn vị vận chuyển',
    distributionCheckstate: '729 Trạng thái kiểm nhận',
    stateUnchecked: '730 Chưa kiểm nhận',
    stateCheckingV1: '731 Đang kiểm nhận',
    stateChecked: '732 Đã kiểm nhận',
    distributionGoodsnum: '733 Số lượng hàng hóa',
    distributionConfirm: '734 Xác nhận',
    distributionPackagecheckedwarning: '735 Kiện hàng này đã được kiểm nhận, không thể chọn!',
    distributionPackagerequired: '736 Vui lòng chọn số kiện hàng',
    distributionTip: '737 Thông báo',
    distributionRfidtip: '738 Đơn này đã xuất hàng bằng chip RFID và cửa hàng đã kích hoạt chức năng nhận hàng bằng chip RFID. Vui lòng sử dụng máy kiểm kê để nhận hàng cho đơn này!',
    distributionIknow: '739 Đã hiểu',
    transferslipenterStartcheck: '740 Bắt đầu kiểm nhận',
    transferslipenterSelectpackagetitle: '741 Vui lòng chọn số kiện hàng',
    transferslipenterSelect: '742 Chọn',
    transferslipenterPackagesn: '743 Số kiện hàng',
    transferslipenterExpresssn: '744 Số vận đơn của kiện hàng',
    transferslipenterLogisticsname: '745 Đơn vị vận chuyển',
    transferslipenterCheckstate: '746 Trạng thái kiểm nhận',
    stateUncheckedV1: '747 Chưa kiểm nhận',
    stateCheckingV2: '748 Đang kiểm nhận',
    stateCheckedV1: '749 Đã kiểm nhận',
    transferslipenterGoodsnum: '750 Số lượng hàng hóa',
    transferslipenterConfirm: '751 Xác nhận',
    transferslipenterPackagecheckedwarning: '752 Kiện hàng này đã được kiểm nhận, không thể chọn!',
    transferslipenterPackagerequired: '753 Vui lòng chọn số kiện hàng',
    transferslipenterTip: '754 Thông báo',
    transferslipenterRfidtip: '755 Đơn này đã xuất hàng bằng chip RFID và cửa hàng đã kích hoạt chức năng nhận hàng bằng chip RFID. Vui lòng sử dụng máy kiểm kê để nhận hàng cho đơn này!',
    transferslipenterIknow: '756 Đã hiểu',
    allotpickupTitle: '757 Nhặt hàng',
    allotpickupReceiver: '758 Bên nhận hàng',
    allotpickupInvoiceno: '759 Số đơn',
    allotpickupSubmitbutton: '760 Hoàn thành nhặt hàng và gửi',
    allotpickupScanplaceholder: '761 Vui lòng quét mã hoặc nhập mã vạch',
    allotpickupConfirm: '762 Xác nhận',
    allotpickupNegativescan: '763 Quét âm (trừ hàng)',
    allotpickupPositivescan: '764 Quét dương (thêm hàng)',
    allotpickupShowonlyunpicked: '765 Chỉ hiển thị chưa nhặt',
    allotpickupGoodsnoplaceholder: '766 Vui lòng nhập mã hàng',
    allotpickupSearch: '767 Tìm kiếm',
    allotpickupScantrajectory: '768 Lịch sử quét mã',
    allotpickupSealpacket: '769 Đóng gói',
    allotpickupAvailabletoseal: '770 Có thể đóng gói',
    allotpickupClearpicknum: '771 Xóa số lượng nhặt hàng',
    allotpickupLastscanned: '772 Hàng hóa vừa quét mã:',
    allotpickupReceivedprefix: '773 Đã nhận',
    allotpickupPackageno: '774 Số kiện hàng',
    allotpickupPackagedcount: '775 Số lượng đóng gói',
    allotpickupEstimatedweight: '776 Trọng lượng dự kiến (kg)',
    allotpickupPacker: '777 Người đóng gói',
    allotpickupPacktime: '778 Thời gian đóng gói (tạo)',
    allotpickupAction: '779 Thao tác',
    allotpickupViewpackage: '780 Xem kiện hàng',
    allotpickupDissolvepackage: '781 Giải tán kiện hàng',
    allotpickupPrint: '782 In',
    allotpickupGoodsname: '783 Tên hàng hóa',
    allotpickupGoodsno: '784 Mã hàng',
    allotpickupMinpickwarning: '785 Vui lòng nhặt ít nhất một mặt hàng',
    allotpickupSuccess: '786 Thao tác thành công',
    allotpickupTip: '787 Thông báo',
    allotpickupClearconfirm: '788 Sau khi xóa, hàng hóa sẽ cần nhặt lại. Xác nhận xóa?',
    allotpickupCurrentavailable: '789 Số lượng có thể đóng gói hiện tại là ,',
    allotpickupConfirmseal: ' xác nhận đóng thành một kiện hàng?',
    allotpickupSealpackagedialog: '791 Đóng gói',
    allotpickupNoavailabletoseal: '792 Hiện không có số lượng nào có thể đóng gói',
    allotpickupNoneedgoodsconfirm: '793 Đơn này không cần nhặt mặt hàng này. Xác nhận tiếp tục nhặt hàng?',
    allotpickupNoneedsizeconfirm: '794 Đơn này không cần nhặt kích cỡ này. Xác nhận tiếp tục nhặt hàng?',
    allotpickupExceedquantityconfirm: '795 Mặt hàng này đã nhặt vượt số lượng. Xác nhận tiếp tục nhặt hàng?',
    allotpickupBarcodeprefix: '796 Mã vạch:',
    allotpickupConfirmbutton: '797 Xác nhận',
    allotpickupCancelbutton: '798 Hủy bỏ',
    allotpickupCancelled: '799 Đã hủy',
    checkacceptdrawerDrawertitle: '800 Nhặt hàng',
    checkacceptdrawerReceiver: '801 Bên nhận hàng',
    checkacceptdrawerDocumentno: '802 Số đơn',
    checkacceptdrawerSubmitbutton: '803 Hoàn thành nhặt hàng và gửi',
    checkacceptdrawerScanplaceholder: '804 Vui lòng quét mã hoặc nhập mã vạch',
    checkacceptdrawerConfirmbutton: '805 Xác nhận',
    checkacceptdrawerCancelbutton: '806 Hủy bỏ',
    checkacceptdrawerNegativescan: '807 Quét âm (trừ hàng)',
    checkacceptdrawerPositivescan: '808 Quét dương (thêm hàng)',
    checkacceptdrawerShowunpickedonly: '809 Chỉ hiển thị chưa nhặt',
    checkacceptdrawerSkuplaceholder: '810 Vui lòng nhập mã hàng',
    checkacceptdrawerSearchbutton: '811 Tìm kiếm',
    checkacceptdrawerScantrack: '812 Lịch sử quét mã',
    checkacceptdrawerClearpick: '813 Xóa số lượng nhặt hàng',
    checkacceptdrawerProductname: '814 Tên hàng hóa',
    checkacceptdrawerSkuno: '815 Mã hàng',
    checkacceptdrawerConfirmclear: '816 Sau khi xóa, hàng hóa sẽ cần nhặt lại. Xác nhận xóa?',
    checkacceptdrawerOperationsuccess: '817 Thao tác thành công',
    checkacceptdrawerPickatleastone: '818 Vui lòng nhặt ít nhất một mặt hàng',
    checkacceptdrawerConfirmoverpick: '819 Đơn này không cần nhặt mặt hàng này. Xác nhận tiếp tục nhặt hàng?',
    checkacceptdrawerBarcodeprefix: '820 Mã vạch:',
    checkacceptdrawerOperationcancelled: '821 Đã hủy',
    checkacceptdrawerLastscanned: '822 Hàng hóa vừa quét mã',
    checkacceptdrawerTip: '823 Thông báo',
    checkacceptdrawerColor: '824 Màu sắc',
    checkacceptdrawerSize: '825 Kích cỡ',
    checkacceptdrawerQuantity: '826 Số lượng',
    columnSn: '827 Số đơn',
    columnStatedesc: '828 Trạng thái',
    stateDraft: '829 Đơn nháp (xanh dương): Lưu tạm bản nháp đơn, không chiếm dụng tồn kho.',
    statePresubmit: '830 Gửi trước (tím): Gửi đơn trước, nhưng chưa chuyển xuống cửa hàng, sẽ chiếm dụng tồn kho của cửa hàng.',
    stateIssued: '831 Đã chuyển xuống (xanh lá): Đã gửi đơn và chuyển xuống cửa hàng, chờ cửa hàng nhặt hàng xuất kho.',
    statePicking: '832 Đang nhặt hàng (cam): Cửa hàng đã nhận chỉ thị, đang tiến hành nhặt hàng.',
    statePickcompleted: '833 Hoàn thành nhặt hàng (xanh lá): Cửa hàng đã hoàn thành nhặt hàng và gửi.',
    stateShipped: '834 Đã xuất hàng (xanh dương): Cửa hàng đã nhặt hàng theo đơn trả kho và xuất kho, sẽ trừ tồn kho cửa hàng, trạng thái logistics đang trên đường. Sẽ tăng tồn kho đang về của kho.',
    stateSignedV1: '835 Đã ký nhận (xanh lá): Khi giao hàng bằng đối tác vận chuyển, thông tin logistics đã cho thấy kho đã ký nhận, chờ kho mở kiểm nhận.',
    stateCheckingV3: '836 Đang kiểm nhận (cam): Kho đang mở gói và kiểm nhận.',
    stateStored: '837 Đã nhập kho (xanh lá): Sau khi kiểm nhận hoàn tất, thao tác xác nhận nhập kho, tồn kho đang về của kho sẽ chuyển thành tồn kho thực tế được tăng.',
    stateVoided: '838 Đã hủy (đỏ): Các trạng thái Đơn nháp, Gửi trước, Đã chuyển xuống có thể được thực hiện thao tác hủy.',
    stateVoidapplying: '839 Yêu cầu hủy (đỏ): Đơn hàng đã xuất hàng thực hiện yêu cầu hủy.',
    columnIfdiscrepancy: '840 Chênh lệch nhận hàng chờ xử lý',
    columnYes: '841 Có',
    columnNo: '842 Không',
    columnMarketname: '843 Bên giao hàng',
    columnWarehousename: '844 Bên nhận hàng',
    columnTotalnum: '845 Số lượng kế hoạch',
    columnOutnum: '846 Số lượng xuất hàng',
    columnOutpackagenum: '847 Số kiện hàng xuất',
    columnOutnumdifference: '848 Số lượng chênh lệch xuất hàng',
    columnInnum: '849 Số lượng nhập kho',
    columnInnumdifference: '850 Số lượng chênh lệch nhập kho',
    columnLogisticpackagechecknum: '851 Số kiện hàng nhập',
    columnRemark: '852 Ghi chú',
    columnCreateusername: '853 Người tạo',
    columnCreatetime: '854 Thời gian tạo',
    columnUpdatetime: '855 Thời gian cập nhật',
    columnUpdateusername: '856 Người sửa',
    placeholderSn: '857 Vui lòng nhập số đơn',
    placeholderExpressnoV1: '858 Vui lòng nhập số vận đơn',
    placeholderStateV1: '859 Vui lòng chọn trạng thái',
    labelSn: '860 Số đơn',
    labelExpressnoV1: '861 Số vận đơn',
    labelStateV1: '862 Trạng thái',
    optionsDraft: '863 Đơn nháp',
    optionsIssued: '864 Đã chuyển xuống',
    optionsPicking: '865 Đang nhặt hàng',
    optionsPickcompleted: '866 Hoàn thành nhặt hàng',
    optionsPackcompleted: '867 Hoàn thành đóng gói',
    optionsShipped: '868 Đã xuất hàng',
    optionsSigned: '869 Đã ký nhận',
    optionsChecking: '870 Đang kiểm nhận',
    optionsStored: '871 Đã nhập kho',
    optionsVoidapplying: '872 Yêu cầu hủy',
    optionsVoided: '873 Đã hủy',
    labelIfdiscrepancyV1: '874 Xem Chưa Xử Lý Khác Hàng?',
    placeholderSelectV1: '875 Vui lòng chọn',
    labelHasdiscrepancyV1: '876 Có bản ghi chênh lệch không?',
    placeholderWarehouse: '877 Vui lòng chọn bên nhận hàng',
    placeholderGoodsnoV1: '878 Vui lòng nhập mã hàng, nhiều mã cách nhau bằng dấu cách',
    labelGoodsnoV1: '879 Mã hàng',
    placeholderCreateuserV1: '880 Vui lòng nhập người tạo',
    labelCreateuserV1: '881 Người tạo',
    placeholderCreatetimeV1: '882 Vui lòng chọn thời gian tạo',
    labelCreatetimeV1: '883 Thời gian tạo',
    placeholderUpdatetimeV1: '884 Vui lòng chọn thời gian cập nhật',
    labelUpdatetimeV1: '885 Thời gian cập nhật',
    buttonQuery: '886 Tìm kiếm',
    buttonReset: '887 Đặt lại',
    columnGoodsname: '888 Tên hàng hóa',
    columnGoodsno: '889 Mã hàng',
    columnColorvalue: '890 Màu sắc',
    columnTotal: '891 Tổng hợp',
    sizeinfoUsablequantity: '892 Tồn kho khả dụng',
    sizeinfoNumber: '893 Số lượng trả hàng',
    actionsDel: '894 Xóa',
    footerTotalamount: '895 Tổng số mẫu',
    unitTotalamount: ' mẫu',
    footerTcgetnum: '897 Tổng số lượng trả kho',
    deptretreatadddialogTitle: '898 Đơn trả kho',
    deptretreatadddialogFillinfotitle: '899 Vui lòng nhập thông tin',
    deptretreatadddialogReceiverinfo: '900 Bên nhận hàng',
    deptretreatadddialogSelectwarehouse: '901 Vui lòng chọn kho',
    deptretreatadddialogRemark: '902 Ghi chú',
    deptretreatadddialogRemarkplaceholder: '903 Vui lòng nhập thông tin ghi chú',
    deptretreatadddialogAddgoodstitle: '904 Thêm chi tiết hàng hóa mới',
    deptretreatadddialogInputgoodsno: '905 Vui lòng nhập số hàng hóa',
    deptretreatadddialogSearchbtn: '906 Tìm kiếm',
    deptretreatadddialogCrosspageselect: '907 Chọn tất cả trên nhiều trang',
    deptretreatadddialogConfirmadd: '908 Xác nhận thêm',
    deptretreatadddialogAddedgoodstitle: '909 Danh sách hàng hóa đã thêm',
    deptretreatadddialogScanbarcode: '910 Quét mã hoặc nhập mã vạch',
    deptretreatadddialogConfirmbtn: '911 Xác nhận',
    deptretreatadddialogNegativescan: '912 Quét âm (trừ hàng)',
    deptretreatadddialogPositivescan: '913 Quét dương (thêm hàng)',
    deptretreatadddialogInputgoodsnofilter: '914 Vui lòng nhập mã hàng',
    deptretreatadddialogQuerybtn: '915 Tìm kiếm',
    deptretreatadddialogClearbtn: '916 Xóa',
    deptretreatadddialogViewscantrack: '917 Xem lịch sử quét mã',
    deptretreatadddialogCurrentscangoods: '918 Hàng hóa vừa quét mã',
    deptretreatadddialogGoodsno: '919 Mã hàng',
    deptretreatadddialogColor: '920 Màu sắc',
    deptretreatadddialogSize: '921 Kích cỡ',
    deptretreatadddialogQuantity: '922 Số lượng',
    deptretreatadddialogSavedraft: '923 Lưu thành bản nháp',
    deptretreatadddialogConfirmsubmit: '924 Xác nhận gửi',
    deptretreatadddialogSelectgoodsfirst: '925 Vui lòng chọn hàng hóa trước khi thêm',
    deptretreatadddialogSelectreceiver: '926 Vui lòng chọn bên nhận hàng',
    deptretreatadddialogFillretreatnum: '927 Vui lòng nhập số lượng trả kho',
    deptretreatadddialogFillremark: '928 Vui lòng nhập ghi chú',
    deptretreatadddialogOperationsuccess: '929 Thao tác thành công',
    deptretreatadddialogQuantityoutofrange: '930 Số lượng vượt quá phạm vi',
    deptretreatadddialogDeleteconfirm: '931 Xác nhận xóa bản ghi này?',
    deptretreatadddialogInputbarcode: '932 Vui lòng nhập mã vạch',
    deptretreatadddialogInputcontent: '933 Vui lòng nhập nội dung',
    deptretreatadddialogGoodsname: '934 Tên mã hàng',
    deptretreatadddialogUsablestock: '935 Tồn kho khả dụng',
    deptretreatadddialogtip: '936 Thông báo',
    deptretreatdetailsTitle: '937 Chi tiết đơn hàng',
    deptretreatdetailsStartpicking: '938 Bắt đầu nhặt hàng',
    deptretreatdetailsInvoiceinfotitle: '939 Thông tin đơn hàng',
    deptretreatdetailsCreator: '940 Người tạo',
    deptretreatdetailsSender: '941 Bên giao hàng',
    deptretreatdetailsReceiver: '942 Bên nhận hàng',
    deptretreatdetailsReturnquantity: '943 Số lượng trả hàng',
    deptretreatdetailsOutboundquantity: '944 Số lượng xuất hàng',
    deptretreatdetailsInboundquantity: '945 Số lượng nhập kho',
    deptretreatdetailsOutbounddiff: '946 Số lượng chênh lệch xuất hàng',
    deptretreatdetailsInbounddiff: '947 Số lượng chênh lệch nhập kho',
    deptretreatdetailsCreatetime: '948 Thời gian tạo',
    deptretreatdetailsUpdatetime: '949 Thời gian cập nhật',
    deptretreatdetailsLastmodifier: '950 Người sửa cuối',
    deptretreatdetailsTotaltime: '951 Tổng thời gian xử lý',
    deptretreatdetailsGoodsresponsible: '952 Người phụ trách hàng hóa',
    deptretreatdetailsRemark: '953 Ghi chú',
    deptretreatdetailsGoodslisttitle: '954 Danh sách hàng hóa',
    deptretreatdetailsShipmentinfotitle: '955 Thông tin giao hàng',
    deptretreatdetailsInvoiceno: '956 Số đơn',
    deptretreatdetailsPackageno: '957 Số kiện hàng',
    deptretreatdetailsGoodsquantity: '958 Số lượng hàng hóa',
    deptretreatdetailsSenderinfo: '959 Bên giao hàng',
    deptretreatdetailsReceiverinfo: '960 Bên nhận hàng',
    deptretreatdetailsLogisticscompany: '961 Đơn vị vận chuyển',
    deptretreatdetailsTrackingno: '962 Số vận đơn',
    deptretreatdetailsStatus: '963 Trạng thái',
    deptretreatdetailsPendingupdate: '964 Chờ cập nhật',
    deptretreatdetailsPackingcompletetime: '965 Thời gian hoàn thành đóng gói',
    deptretreatdetailsShipmenttime: '966 Thời gian giao hàng',
    deptretreatdetailsSigntime: '967 Thời gian ký nhận',
    deptretreatdetailsActions: '968 Thao tác',
    deptretreatdetailsViewpackage: '969 Xem kiện hàng',
    deptretreatdetailsLogisticstrack: '970 Lộ trình vận chuyển',
    deptretreatdetailsEditinfo: '971 Sửa thông tin',
    deptretreatdetailsPrint: '972 In',
    deptretreatdetailsDiffinfotitle: '973 Thông tin chênh lệch khi nhận hàng',
    deptretreatdetailsConsignee: '974 Người nhận hàng',
    deptretreatdetailsReceiptcompletetime: '975 Thời gian hoàn thành nhận hàng',
    deptretreatdetailsOutboundlabelquantity: '976 Số lượng nhãn xuất hàng',
    deptretreatdetailsDiscrepancy: '977 Chênh lệch',
    deptretreatdetailsSenderresponsibility: '978 Trách nhiệm bên giao',
    deptretreatdetailsReceiverresponsibility: '979 Trách nhiệm bên nhận',
    deptretreatdetailsTransportresponsibility: '980 Trách nhiệm bên vận chuyển',
    deptretreatdetailsUndetermined: '981 Chưa xác định trách nhiệm',
    deptretreatdetailsDetermined: '982 Đã xác định trách nhiệm',
    deptretreatdetailsViewdetails: '983 Xem chi tiết',
    deptretreatdetailsCancelapplicationtitle: '984 Lịch sử yêu cầu hủy',
    deptretreatdetailsApplicant: '985 Người yêu cầu',
    deptretreatdetailsApplicationtime: '986 Thời gian yêu cầu',
    deptretreatdetailsApplicationreason: '987 Lý do yêu cầu',
    deptretreatdetailsApprover: '988 Người phê duyệt',
    deptretreatdetailsApprovaltime: '989 Thời gian phê duyệt',
    deptretreatdetailsPendingapproval: '990 Chờ phê duyệt',
    deptretreatdetailsApproved: '991 Đã phê duyệt',
    deptretreatdetailsRejected: '992 Đã từ chối',
    deptretreatdetailsSelectpackagetitle: '993 Vui lòng chọn số kiện hàng',
    deptretreatdetailsSelect: '994 Vui lòng chọn',
    deptretreatdetailsConfirm: '995 Xác nhận',
    deptretreatdetailsNotcollected: '996 Chưa nhận hàng',
    deptretreatdetailsPendingshipment: '997 Chờ giao hàng',
    deptretreatdetailsIntransit: '998 Đang vận chuyển',
    deptretreatdetailsOutfordelivery: '999 Đang giao hàng',
    deptretreatdetailsDelivered: '1000 Giao hàng thành công',
    deptretreatdetailsUsepdaforpicking: '1001 Vui lòng sử dụng PDA để nhặt hàng',
    deptretreatdetailsConfirmcancelexpress: '1002 Xác nhận hủy vận đơn?',
    deptretreatdetailsCancelsuccess: '1003 Hủy thành công',
    deptretreatdetailsSelectpackageno: '1004 Vui lòng chọn số kiện hàng',
    deptretreatdetailsGoodsname: '1005 Tên hàng hóa',
    deptretreatdetailsGoodsno: '1006 Mã hàng',
    deptretreatdetailsRetailprice: '1007 Giá bán lẻ',
    dissolvepackageDialogtitle: '1008 Thông báo',
    dissolvepackageTitle: '1009 Giải tán kiện hàng',
    dissolvepackageOption: '1010 Giữ lại số lượng nhặt hàng của kiện, có thể tiếp tục nhặt hàng trước khi đóng gói.',
    dissolvepackageOptionV1: '1011 Xóa số lượng nhặt hàng của kiện, hàng hóa trong kiện này cần được nhặt lại.',
    dissolvepackageCancelbtn: '1012 Hủy bỏ',
    dissolvepackageConfirmbtn: '1013 Xác nhận',
    endpackDialogtitlecompleteaccept: '1014 Hoàn thành kiểm nhận',
    endpackDialogtitlecompletepick: '1015 Hoàn thành nhặt hàng và gửi',
    endpackWarningmessage: '1016 Dữ liệu hiện tại có chênh lệch. Xác nhận tiếp tục gửi?',
    endpackTotalquantityV1: '1017 Tổng số lượng:',
    endpackAcceptedquantity: '1018 Đã kiểm nhận:',
    endpackPickedquantity: '1019 Đã nhặt hàng:',
    endpackExcessacceptedquantity: '1020 Vượt kiểm nhận:',
    endpackExcesspickedquantity: '1021 Vượt nhặt hàng:',
    endpackUnacceptedquantity: '1022 Chưa kiểm nhận:',
    endpackUnpickedquantity: '1023 Chưa nhặt hàng:',
    endpackDifreasonlabel: '1024 Lý do nhặt hàng chênh lệch',
    endpackDifreasonplaceholder: '1025 Vui lòng nhập lý do nhặt hàng chênh lệch',
    endpackDifreasonrequired: '1026 Vui lòng điền lý do nhặt hàng chênh lệch',
    endpackCancelbtnV1: '1027 Hủy bỏ',
    endpackConfirmbtnV1: '1028 Xác nhận',
    outconfigGoodsno: '1029 Mã hàng',
    outconfigGoodscode: '1030 Mã rút gọn',
    outconfigGoodsname: '1031 Tên',
    outconfigColorvalue: '1032 Màu sắc',
    outconfigTotal: '1033 Tổng số',
    packagedetailTitle: '1034 Chi tiết kiện hàng',
    packagedetailSearchlabel: '1035 Mã hàng/Mã vạch/Mã rút gọn',
    packagedetailSearchplaceholder: '1036 Nhập và nhấn Enter để tìm kiếm',
    packageepcphDialogtitleV2: '1037 Thông báo',
    packageepcphDetailtitle: '1038 Chi tiết kiện hàng',
    packageepcphGoodslabel: '1039 Mã hàng/Mã vạch/Mã rút gọn',
    packageepcphSearchplaceholderV1: '1040 Nhập và nhấn Enter để tìm kiếm',
    packageepcphEpcsearchplaceholder: '1041 Nhập và nhấn Enter để tìm kiếm',
    packageepcphGoodstabV2: '1042 Hàng hóa',
    packageepcphTotallabelV1: '1043 Tổng cộng',
    packageepcphTotalamountV1: '1044 Tổng số mẫu',
    packageepcphTotalquantity: '1045 Tổng số lượng',
    packageepcphTablegoodsno: '1046 Mã hàng',
    packageepcphTablegoodsname: '1047 Tên hàng hóa',
    packageepcphTablecolor: '1048 Màu sắc',
    packageepcphTablesize: '1049 Kích cỡ',
    packageepcphTablenumber: '1050 Số lượng',
    packageepcphTablesum: '1051 Tổng số',
    printdocumentsTitle: '1052 In đơn hàng',
    printdocumentsPrintbtn: '1053 In',
    printdocumentsAllottitle: '1054 Đơn điều chuyển cửa hàng',
    printdocumentsReturntitle: '1055 Đơn trả kho cửa hàng',
    printdocumentsScantip: '1056 Quét mã để định vị nhanh đơn hàng',
    printdocumentsInvoicedate: '1057 Ngày đơn hàng:',
    printdocumentsInvoiceno: '1058 Số đơn hàng:',
    printdocumentsOutmarket: '1059 Cửa hàng điều chuyển đi:',
    printdocumentsReturnmarket: '1060 Cửa hàng trả hàng:',
    printdocumentsInmarket: '1061 Cửa hàng điều chuyển đến:',
    printdocumentsReturnwarehouse: '1062 Kho nhận hàng trả:',
    printdocumentsGoodsno: '1063 Mã hàng',
    printdocumentsColor: '1064 Màu sắc',
    printdocumentsSize: '1065 Kích cỡ',
    printdocumentsQuantity: '1066 Số lượng',
    printdocumentsTotalquantity: '1067 Tổng số lượng:',
    printdocumentsGoodsname: '1068 Tên hàng hóa',
    printdocumentsDistributiontitle: '1069 Đơn phân phối hàng hóa',
    printdocumentsAlloutouttitle: '1070 Đơn cửa hàng điều chuyển đi',
    printdocumentsReturntitleV2: '1071 Đơn trả hàng cửa hàng',
    printdocumentsReturnsuppliertitle: '1072 Đơn trả nguồn cung cửa hàng',
    returnpickupDrawertitle: '1073 Nhặt hàng',
    returnpickupReceiverlabel: '1074 Bên nhận hàng',
    returnpickupInvoicesnlabel: '1075 Số đơn',
    returnpickupSubmitbutton: '1076 Hoàn thành nhặt hàng và gửi',
    returnpickupScanplaceholder: '1077 Vui lòng quét mã hoặc nhập mã vạch',
    returnpickupConfirmbutton: '1078 Xác nhận',
    returnpickupNegativescan: '1079 Quét âm (trừ hàng)',
    returnpickupPositivescan: '1080 Quét dương (thêm hàng)',
    returnpickupOnlyunpicked: '1081 Chỉ hiển thị chưa nhặt',
    returnpickupGoodsnoplaceholder: '1082 Vui lòng nhập mã hàng',
    returnpickupSearchbutton: '1083 Tìm kiếm',
    returnpickupScantrajectory: '1084 Lịch sử quét mã',
    returnpickupSealpacket: '1085 Đóng gói',
    returnpickupClearbutton: '1086 Xóa số lượng nhặt hàng',
    returnpickupRecentscan: '1087 Hàng hóa vừa quét mã',
    returnpickupReceivedcount: '1088 Đã nhận',
    returnpickupPackagesn: '1089 Số kiện hàng',
    returnpickupPackagecount: '1090 Số lượng đóng gói',
    returnpickupEstimatedweight: '1091 Trọng lượng dự kiến (kg)',
    returnpickupPacker: '1092 Người đóng gói',
    returnpickupPacktime: '1093 Thời gian đóng gói (tạo)',
    returnpickupAction: '1094 Thao tác',
    returnpickupViewpackage: '1095 Xem kiện hàng',
    returnpickupDissolvepackage: '1096 Giải tán kiện hàng',
    returnpickupPrint: '1097 In',
    returnpickupClearconfirm: '1098 Sau khi xóa, hàng hóa sẽ cần nhặt lại. Xác nhận xóa?',
    returnpickupConfirmtitle: '1099 Thông báo',
    returnpickupSuccessmessage: '1100 Thao tác thành công',
    returnpickupNopackagequantity: '1101 Hiện không có số lượng nào có thể đóng gói',
    returnpickupAvailablepackage: '1102 Số lượng có thể đóng gói hiện tại là ,',
    returnpickupConfirmseal: ' , xác nhận đóng thành một kiện hàng?',
    returnpickupSealtitle: '1104 Đóng gói',
    returnpickupExceedgoodsconfirm: '1105 Đơn này không cần nhặt mặt hàng này. Xác nhận tiếp tục nhặt hàng?',
    returnpickupExceedsizeconfirm: '1106 Đơn này không cần nhặt kích cỡ này. Xác nhận tiếp tục nhặt hàng?',
    returnpickupExceednumberconfirm: '1107 Mặt hàng này đã nhặt vượt số lượng. Xác nhận tiếp tục nhặt hàng?',
    returnpickupConfirmaction: '1108 Xác nhận',
    returnpickupCancelaction: '1109 Hủy bỏ',
    returnpickupCancelledmessage: '1110 Đã hủy',
    returnpickupMinpickerror: '1111 Vui lòng nhặt ít nhất một mặt hàng',
    returnpickupGoodsname: '1112 Tên hàng hóa',
    returnpickupGoodsno: '1113 Mã hàng',
    returnpickupAvailableseal: '1114 Có thể đóng gói',
    returnpickupBarcodelabel: '1115 Mã vạch',
    tableconfigGoodsnameV2: '1116 Tên hàng hóa',
    tableconfigGoodsnowithimageV2: '1117 Mã hàng (Nhấn để xem ảnh)',
    tableconfigColorV2: '1118 Màu sắc',
    tableconfigTotalV2: '1119 Tổng hợp',
    tableconfigTotalnumber: '1120 Tổng số',
    tableconfigPicked: '1121 Đã nhặt',
    tableconfigPackaged: '1122 Đóng gói',
    tableconfigOverpicked: '1123 Vượt nhặt',
    tableconfigUnpicked: '1124 Chưa nhặt',
    tableconfigTotalitemsV2: '1125 Tổng số lượng',
    tableconfigReturnquantityV1: '1126 Số lượng trả kho',
    tableconfigOutboundquantity: '1127 Số lượng xuất hàng',
    tableconfigOutbounddifference: '1128 Chênh lệch xuất hàng',
    tableconfigInboundquantity: '1129 Số lượng nhập kho',
    tableconfigInbounddifference: '1130 Chênh lệch nhập kho',
    tableconfigTotalreturnitems: '1131 Tổng số lượng trả kho',
    tableconfigTotaloutbounddifference: '1132 Tổng số chênh lệch xuất hàng',
    tableconfigTotalinbounddifference: '1133 Tổng số chênh lệch nhập kho',
    tableconfigShortcodeV2: '1134 Mã rút gọn',
    tableconfigGoodsnoV2: '1135 Mã hàng',
    tableconfigQuantityV2: '1136 Số lượng',
    tableconfigTotaltypes: '1137 Tổng số mẫu',
    tableconfigTotalgoodscount: '1138 Tổng số hàng hóa',
    deptretreatPrintbtn: '1139 In đơn hàng',
    deptretreatStartpickbtn: '1140 Bắt đầu nhặt hàng',
    deptretreatEnterexpressbtn: '1141 Nhập thông tin vận chuyển',
    deptretreatSubmitbtn: '1142 Gửi',
    deptretreatCopybtn: '1143 Sao chép đơn hàng',
    deptretreatRollbackpickbtn: '1144 Hoàn trả nhặt hàng / Lùi lại bước nhặt hàng',
    deptretreatReorderbtn: '1145 Làm lại đơn hàng',
    deptretreatAddnewbtn: '1146 Thêm đơn trả hàng cửa hàng mới',
    deptretreatConfirmtitle: '1147 Thông báo',
    deptretreatReorderconfirm: '1148 Xác nhận làm lại đơn hàng này?',
    deptretreatSuccessmsg: '1149 Thao tác thành công',
    deptretreatSubmitconfirm: '1150 Sau khi xác nhận, đơn hàng sẽ chuyển sang trạng thái hoàn thành đóng gói. Xác nhận gửi?',
    deptretreatMarkpackcompleted: '1151 Đánh dấu là hoàn thành đóng gói',
    deptretreatCopyconfirm: '1152 Xác nhận sao chép đơn hàng này?',
    deptretreatCopyoperation: '1153 Sao chép',
    deptretreatPdapickwarning: '1154 Vui lòng sử dụng PDA để nhặt hàng',
    deptretreatrepickComfirmTip: '1155 Xác nhận chuyển đơn hàng này về trạng thái "Đang nhặt hàng" để tiếp tục?',
    deptretreatrepickTip: '1156 Thông báo',
    deptretreatrepickActionSuccess: '1157 Thao tác thành công',
    dialogconfigEdittransfertitle: '1158 Sửa đơn điều chuyển cửa hàng',
    dialogconfigAddtransfertitle: '1159 Thêm đơn điều chuyển cửa hàng mới',
    dialogconfigEditreturntitle: '1160 Sửa đơn trả kho cửa hàng',
    dialogconfigAddreturntitle: '1161 Thêm đơn trả kho cửa hàng mới',
    transferconfigColumnsn: '1162 Số đơn',
    transferconfigColumnstate: '1163 Trạng thái',
    transferconfigStatedraftdesc: '1164 Đơn nháp (xanh dương): Lưu tạm bản nháp đơn, không chiếm dụng tồn kho.',
    transferconfigStateissueddesc: '1165 Đã chuyển xuống (xanh lá): Đã gửi đơn và chuyển xuống cửa hàng, chờ cửa hàng nhặt hàng xuất kho.',
    transferconfigStatepickingdesc: '1166 Đang nhặt hàng (cam): Cửa hàng đã nhận chỉ thị, đang tiến hành nhặt hàng.',
    transferconfigStatepickeddesc: '1167 Hoàn thành nhặt hàng (xanh lá): Cửa hàng đã hoàn thành nhặt hàng và gửi.',
    transferconfigStateshippeddesc: '1168 Đã xuất hàng (xanh dương): Cửa hàng đã nhặt hàng theo đơn điều chuyển và xuất kho, sẽ trừ tồn kho cửa hàng, trạng thái logistics đang trên đường. Sẽ tăng tồn kho đang về của cửa hàng đích.',
    transferconfigStatesigneddesc: '1169 Đã ký nhận (xanh lá): Khi giao hàng bằng đối tác vận chuyển, thông tin logistics đã cho thấy cửa hàng đã ký nhận, chờ cửa hàng mở kiểm nhận.',
    transferconfigStatecheckingdesc: '1170 Đang kiểm nhận (cam): Cửa hàng đang mở gói và kiểm nhận.',
    transferconfigStatestoreddesc: '1171 Đã nhập kho (xanh lá): Sau khi kiểm nhận hoàn tất, thao tác xác nhận nhập kho, tồn kho đang về của cửa hàng sẽ chuyển thành tồn kho thực tế được tăng.',
    transferconfigStatecanceleddesc: '1172 Đã hủy (đỏ): Các trạng thái Đơn nháp, Gửi trước, Đã chuyển xuống có thể được thực hiện thao tác hủy.',
    transferconfigStatecancelapplydesc: '1173 Yêu cầu hủy (đỏ): Đơn hàng đã xuất hàng thực hiện yêu cầu hủy.',
    transferconfigColumndiscrepancy: '1174 Chênh lệch nhận hàng chờ xử lý',
    transferconfigYestext: '1175 Có',
    transferconfigNotext: '1176 Không',
    transferconfigColumnoutmarket: '1177 Bên giao hàng',
    transferconfigColumninmarket: '1178 Bên nhận hàng',
    transferconfigColumnplannum: '1179 Số lượng kế hoạch',
    transferconfigColumnoutnum: '1180 Số lượng xuất hàng',
    transferconfigColumnoutpackage: '1181 Số kiện hàng xuất',
    transferconfigColumnoutdiff: '1182 Số lượng chênh lệch xuất hàng',
    transferconfigColumndiffreason: '1183 Lý do nhặt hàng chênh lệch',
    transferconfigColumninnum: '1184 Số lượng nhập kho',
    transferconfigColumninpackage: '1185 Số kiện hàng nhập',
    transferconfigColumnindiff: '1186 Số lượng chênh lệch nhập kho',
    transferconfigColumnremark: '1187 Ghi chú',
    transferconfigColumncreator: '1188 Người tạo',
    transferconfigColumncreatetime: '1189 Thời gian tạo',
    transferconfigColumnupdatetime: '1190 Thời gian cập nhật',
    transferconfigColumnmodifier: '1191 Người sửa',
    transferconfigPlaceholdersn: '1192 Vui lòng nhập số đơn',
    transferconfigLabelsn: '1193 Số đơn',
    transferconfigPlaceholderexpress: '1194 Vui lòng nhập số vận đơn',
    transferconfigLabelexpress: '1195 Số vận đơn',
    transferconfigPlaceholderstate: '1196 Vui lòng chọn trạng thái',
    transferconfigLabelstate: '1197 Trạng thái',
    transferconfigStatedraft: '1198 Đơn nháp',
    transferconfigStateissued: '1199 Đã chuyển xuống',
    transferconfigStatepicking: '1200 Đang nhặt hàng',
    transferconfigStatepicked: '1201 Hoàn thành nhặt hàng',
    transferconfigStatepacked: '1202 Hoàn thành đóng gói',
    transferconfigStateshipped: '1203 Đã xuất hàng',
    transferconfigStatesigned: '1204 Đã ký nhận',
    transferconfigStatechecking: '1205 Đang kiểm nhận',
    transferconfigStatestored: '1206 Đã nhập kho',
    transferconfigStatecancelapply: '1207 Yêu cầu hủy',
    transferconfigStatecanceled: '1208 Đã hủy',
    transferconfigPlaceholderselect: '1209 Vui lòng chọn',
    transferconfigLabeldiscrepancy: '1210 Xem Chưa Xử Lý Khác Hàng?',
    transferconfigLabelhasdiscrepancy: '1211 Có bản ghi chênh lệch không?',
    transferconfigPlaceholderinmarket: '1212 Vui lòng chọn bên nhận hàng',
    transferconfigPlaceholdergoodsno: '1213 Vui lòng nhập mã hàng, nhiều mã cách nhau bằng dấu cách',
    transferconfigLabelgoodsno: '1214 Mã hàng',
    transferconfigPlaceholdercreator: '1215 Vui lòng nhập người tạo',
    transferconfigLabelcreatorsearch: '1216 Người tạo',
    transferconfigPlaceholdercreatetime: '1217 Vui lòng chọn thời gian tạo',
    transferconfigPlaceholderupdatetime: '1218 Vui lòng chọn thời gian cập nhật',
    transferconfigBtnsearch: '1219 Tìm kiếm',
    transferconfigBtnreset: '1220 Đặt lại',
    transferslipoutPrintdocuments: '1221 In đơn hàng',
    transferslipoutStartpicking: '1222 Bắt đầu nhặt hàng',
    transferslipoutEnterexpressinfo: '1223 Nhập thông tin vận chuyển',
    transferslipoutSubmit: '1224 Gửi',
    transferslipoutCopydocuments: '1225 Sao chép đơn hàng',
    transferslipoutRollbackpicking: '1226 Hoàn trả nhặt hàng / Lùi lại bước nhặt hàng',
    transferslipoutRedoorder: '1227 Làm lại đơn hàng',
    transferslipoutAddnewstoretransfer: '1228 Thêm đơn điều chuyển cửa hàng mới',
    transferslipoutPleaseusepdapicking: '1229 Vui lòng sử dụng PDA để nhặt hàng',
    transferslipoutConfirmredoorder: '1230 Xác nhận làm lại đơn hàng này?',
    transferslipoutOperationsuccess: '1231 Thao tác thành công',
    transferslipoutConfirmsubmitforpackcomplete: '1232 Sau khi xác nhận, đơn hàng sẽ chuyển sang trạng thái hoàn thành đóng gói. Xác nhận gửi?',
    transferslipoutMarkaspackcomplete: '1233 Đánh dấu là hoàn thành đóng gói',
    transferslipoutConfirmvoiddocuments: '1234 Xác nhận thao tác hủy đơn hàng?',
    transferslipoutVoidoperation: '1235 Hủy',
    transferslipoutConfirmcopydocuments: '1236 Xác nhận sao chép đơn hàng này?',
    transferslipoutCopyoperation: '1237 Sao chép',
    transferslipoutConfirmreturntopicking: '1238 Xác nhận chuyển đơn hàng này về trạng thái "Đang nhặt hàng" để tiếp tục?',
    transferslipoutConfirmTip: '1239 Thông báo',
    indexInvoicescenter: '1240 Trung tâm đơn hàng',
    indexReceiving: '1241 Nhận hàng',
    indexUnwarehouseinvoicescounthint: '1242 Số liệu thống kê là số lượng đơn hàng [Chưa nhập kho]',
    indexStorereceipt: '1243 Đơn nhận hàng cửa hàng',
    indexStoretransferin: '1244 Đơn điều chuyển đến cửa hàng',
    indexShipping: '1245 Xuất hàng',
    indexUnshippedinvoicescounthint: '1246 Số liệu thống kê là số lượng đơn hàng [Chưa xuất hàng]',
    indexStorereturnwarehouse: '1247 Đơn trả kho cửa hàng',
    indexStoretransferout: '1248 Đơn điều chuyển đi cửa hàng',
  },

  deptStock: {
    createApplySent:'1351 Đơn của bạn đã được gửi',
    commonConfirm:'Xác nhận',
    createUseScanner:'1353 Vui lòng thực hiện kiểm kê qua máy kiểm kê',
    createArea:'1354 * Khu vực:',
    areaPleaseSelect:'1355 Vui lòng chọn khu vực',
    createAddDetail:'1356 Thêm chi tiết',
    createCompleted:'1357 Phiếu kiểm kê này đã hoàn thành, không thể tiếp tục thêm chi tiết',
    createViewRecord:'1358 Xem lịch sử kiểm kê',
    applyStock:'Yêu cầu kiểm kê',
    addStock:'1360 Tạo phiếu kiểm kê mới',
    addStockDetail:'1361 Thêm chi tiết',
    waitCreateStock:'1362 Đang chờ hệ thống tạo phiếu kiểm kê',
    stockDate:'1363 Thời gian kiểm kê',
    stockStartDate:'1364 Ngày bắt đầu',
    stockEndDate:'1365 Ngày kết thúc',
    stockDescript:'1366 Mô tả kiểm kê',
    pleaseInput:'1367 Vui lòng nhập',
    applyIsSend:'1368 Đơn của bạn đã được gửi',
    pleaseUsePdaStock:'1369 Vui lòng thực hiện kiểm kê qua máy kiểm kê',
    area:'1370 Khu vực',
    pleaseArea:'1371 Vui lòng chọn khu vực',
    stockFinish:'1372 Phiếu kiểm kê này đã hoàn thành',
    notAddDetail:'1373 Không thể tiếp tục thêm chi tiết',
    validateSelectTime:'1374 Vui lòng chọn thời gian trước!',
    validateFillDesc:'1375 Vui lòng nhập mô tả kiểm kê trước!',
    validateFillName:'1376 Vui lòng nhập tên phiếu kiểm kê',
    validateSelectCategory:'1377 Vui lòng chọn phân loại',
    createSuccess:'1378 Tạo phiếu kiểm kê thành công',
    validateSelectArea:'1379 Vui lòng chọn khu vực',
    startInventory:'Bắt đầu kiểm kê',
    inventoryRecord:'Lịch sử kiểm kê',
    pleaseScanOrInputBarcode:'1382 Vui lòng quét mã hoặc nhập mã vạch',
    selectGoodsToAdd:'1383 Chọn hàng hóa để thêm',
    clearAll:'1384 Xóa toàn bộ',
    totalItems:'1385 Tổng số lượng chi tiết: {count} chiếc',
    submitDetails:'1386 Gửi chi tiết',
    barcodeInventory:'Kiểm kê theo mã vạch',
    barcodeQuery:'1388 Tìm kiếm mã vạch',
    pleaseInputBarCodeMultipleWithSpace:'1389 Vui lòng nhập mã vạch, nhiều mã cách nhau bằng dấu cách',
    query:'Tìm kiếm',
    sortIndex:'STT',
    leftBarCode:'1392 Mã vạch',
    leftStockNumber:'1393 Số lượng kiểm kê',
    leftAction:'1394 Thao tác',
    loadingText:'1395 Đang tải, vui lòng chờ...',
    confirmTips:'1396 Thông báo',
    addBtn:'Thêm',
    goodsCode:'1398 Mã rút gọn',
    goodsNoSummary:'1399 Tổng hợp mã hàng',
    goodsNo:'1400 Mã hàng',
    pleaseInputGoodsNoMultipleWithSpace:'1401 Vui lòng nhập mã hàng, nhiều mã cách nhau bằng dấu cách',
    inventoryDetailInfo:'Chi Tiết',
    totalInventoryItems:'1403 Tổng số lượng kiểm kê: {count} chiếc',
    remarks:'1404 Ghi chú',
    pleaseInputContent:'1405 Vui lòng nhập nội dung',
    selectToAdd:'1406 Chọn để thêm',
    barcodeGoodsNoNameCode:'1407 Mã vạch/Mã hàng/Tên hàng/Mã rút gọn',
    search:'1408 Tìm kiếm',
    selectSpecification:'1409 Chọn quy cách',
    selected:'Đã chọn',
    color:'Màu sắc',
    size:'Kích cỡ',
    code:'Mã',
    cancel:'1414 Hủy',
    confirm:'1415 Xác nhận',
    pleaseDoubleClickLockToUnlock:'1416 Vui lòng nhấp đúp vào "ổ khóa" ngoài cùng bên trái để mở khóa',
    pleaseAddDetailsFirst:'1417 Vui lòng thêm chi tiết trước khi gửi',
    confirmClearAll:'1418 Xóa toàn bộ bản ghi?',
    confirmClearDataOnSwitch:'1419 Đang kiểm kê, dữ liệu lần kiểm kê này sẽ bị xóa sau khi chuyển đổi, xác nhận?',
    positiveScan:'1420 Quét dương',
    negativeScan:'1421 Quét âm',
    positiveScanMin:'1422 Giá trị tối thiểu khi quét dương là 1, không thể giảm thêm',
    negativeScanMax:'1423 Giá trị tối đa khi quét âm là -1, không thể tăng thêm',
    inventoryQuantityCannotBeNegative:'1424 Số lượng kiểm kê không thể là số âm',
    pleaseInputPositiveInteger:'1425 Vui lòng nhập số nguyên lớn hơn 0',
    deleteCurrentEffectRight:'1426 Xóa bản ghi hiện tại sẽ thay đổi số lượng bên phải, xóa?',
    operationSuccess:'1427 Thao tác thành công!',
    submitSuccess:'1428 Gửi thành công',
  },
  stockRecord: {
    inventoryRecord:'Lịch sử kiểm kê',
    placeholderSerialNumber:'1430 Vui lòng nhập số phiếu kiểm kê',
    serialNumber:'1431 Số phiếu kiểm kê',
    placeholderSerialName:'1432 Vui lòng nhập tên phiếu kiểm kê',
    serialName:'1433 Tên phiếu kiểm kê',
    placeholderCreateTime:'1434 Vui lòng chọn thời gian tạo',
    // createTime:'1435 Thời gian tạo',
    // userName:'1437 Người tạo',
    placeholderUserName:'1436 Vui lòng nhập tên người tạo',
    placeholderSelect:'1438 Vui lòng chọn',
    mode:'1439 Phương thức kiểm kê',
    modeScan:'1440 Kiểm kê quét mã',
    modeRfid:'1441 Kiểm kê RFID',
    state:'1442 Trạng thái',
    inProgress:'1443 Đang kiểm kê',
    invalid:'1444 Đã hủy',
    submitted:'1445 Đã gửi',
    reviewing:'1446 Duyệt hạch toán',
    posted:'1447 Đã hạch toán',
    btnSearch:'1448 Tìm kiếm',
    btnReset:'1449 Đặt lại',
    loadingText:'1450 Vui lòng chờ, hệ thống đang tải...',
    deptName:'1451 Tên bộ phận',
    inventoryName:'1452 Tên phiếu kiểm kê',
    seq:'1453 Mã bản ghi',
    typeDesc:'1454 Loại kiểm kê',
    tableMode:'1455 Phương thức kiểm kê',
    tableState:'1456 Trạng thái',
    userName:'1457 Người tạo',
    createTime:'1458 Thời gian tạo',
    finishTime:'1459 Thời gian hoàn thành kiểm kê',
    reviewTime:'1460 Thời gian duyệt',
    detailCount:'1461 Số lượng phiếu chi tiết',
    goodsNoCount:'1462 Số lượng mẫu mã',
    goodsCount:'1463 Số lượng hàng hóa',
    unrecognizedCount:'1464 Số lượng không thể nhận dạng',
    tableAction:'1465 Thao tác',
    invalidate:'Hủy Bỏ',
    restore:'Khôi Phục',
    resetOne:'Đánh Lại Mục',
    finish:'Hoàn Thành',
    diffDetail:'Chi tiết chênh lệch',
    compareDiff:'Chênh Lệch',
    viewDetail:'Xem chi tiết',
    invalidateContent:'1473 Hủy phiếu kiểm kê này?',
    finishConfirm:'1474 Đánh dấu hoàn thành phiếu kiểm kê này? Sau khi hoàn thành sẽ không thể thêm phiếu chi tiết.',
    confirmRestore:'1475 Khôi phục phiếu kiểm kê này về trạng thái bình thường?',
    messageSuccess:'1476 Thao tác thành công',
    messageError:'1477 Thông báo thao tác thất bại (Giữ chỗ thông báo lỗi gốc)',
  },
  stockDetail: {
    inventoryTitle:'1478 Phiếu kiểm kê',
    inventoryInventoryName:'1479 Tên phiếu kiểm kê',
    inventoryCreateTime:'1480 Thời gian tạo',
    inventoryTypeDesc:'1481 Loại kiểm kê',
    inventoryFinishTime:'1482 Thời gian hoàn thành kiểm kê',
    inventoryDeptName:'1483 Cửa hàng',
    inventoryReviewTime:'1484 Thời gian phê duyệt',
    inventoryStateDesc:'1485 Trạng thái',
    inventoryUserName:'1486 Người tạo',
    inventoryTotal:'1487 Tổng hợp kiểm kê',
    inventoryDetail:'1488 Phiếu chi tiết',
    pleaseInput:'1489 Vui lòng nhập',
    queryGoodsNo:'1490 Mã hàng',
    chooseGoodsNo:'1491 Vui lòng chọn mã hàng',
    queryCreateUser:'1492 Người tạo',
    placeholderUserName:'1493 Vui lòng nhập tên người tạo',
    queryButton:'1494 Tìm kiếm',
    summaryTotal:'1495 Tổng hợp',
    summaryInventoryNumber:'1496 Số lượng kiểm kê',
    summaryInventoryPrice:'1497 Thành tiền kiểm kê',
    summaryPageTotal:'1498 Tổng hợp trang hiện tại',
    detailSerialNumber:'1499 Mã chi tiết',
    detailCreateUserName:'1500 Người tạo',
    detailCreateTime:'1501 Thời gian tạo',
    detailState:'1502 Trạng thái',
    detailNormal:'1503 Bình thường',
    detailVoided:'1504 Đã hủy',
    detailRemarks:'1505 Ghi chú',
    detailGoodsName:'1506 Tên hàng hóa',
    detailColor:'1507 Màu sắc',
    detailSize:'1508 Kích cỡ',
    detailTagPrice:'1509 Giá treo thẻ',
    recoverInvoice:'1510 Khôi phục phiếu này',
    voidInvoice:'1511 Hủy phiếu này',
    finishInvoice:'1512 Hoàn thành kiểm kê',
    detailVoid:'1513 Hủy',
    detailRecove:'1514 Khôi phục',
    confirmRecover:'1515 Xác nhận khôi phục phiếu kiểm kê này',
    confirmVoid:'1516 Xác nhận hủy phiếu kiểm kê này',
    confirmFinish:'1517 Xác nhận đánh dấu phiếu kiểm kê này là đã hoàn thành',
    confirmDetailVoid:'1518 Xác nhận hủy phiếu chi tiết này',
    confirmDetailRecove:'1519 Xác nhận khôi phục phiếu chi tiết này',
    confirmTitle:'1520 Thông báo',
    messageSuccess:'1521 Thao tác thành công',
    messageError:'1522 Thao tác thất bại',
    messageLoading:'1523 Vui lòng chờ, hệ thống đang tải...',
    messageEmpty:'1524 Phiếu kiểm kê này chưa có dữ liệu kiểm kê',
  },
  stockDiffer: {
    belongInventory:'1525 Đơn kiểm kê thuộc về',
    stockDifferTitle:'1526 Sự khác biệt trong kiểm kê',
    accountTitle:'1527 Tổng hợp',
    stockTotal:'1528 Tổng số lượng kiểm kê',
    inventoryTotal:'1529 Tổng số lượng tồn kho',
    summaryPageTotal:'1530 Tổng hợp trang này',
    summaryInventoryPrice:'1531 Tổng số tiền kiểm kê',
    inventorySerial:'1532 Số phiếu kiểm kê',
    totalDifference:'1533 Tổng số chênh lệch',
    totalDifferencePrice:'1534 Tổng tiền chênh lệch',
    totalCompensate:'1535 Tổng tiền bồi thường',
    pageTotalDifference:'1536 Tổng số chênh lệch trang hiện tại',
    pageTotalDifferencePrice:'1537 Tổng tiền chênh lệch trang hiện tại',
    pageTotalCompensate:'1538 Tiền bồi thường trang hiện tại',
    pleaseSelect:'1539 Vui lòng chọn',
    differenceType:'1540 Loại chênh lệch',
    hasDifference:'1541 Có chênh lệch',
    noDifference:'1542 Không có chênh lệch',
    selectIsChange:'1543 Có sửa đổi không',
    isYse:'1544 Có',
    isNo:'1545 Không',
    materialNo:'1546 Mã hàng',
    enterMaterialNo:'1547 Nhập mã hàng để tìm kiếm mờ',
    styleCategory:'1548 Phân loại kiểu dáng',
    styleType:'1549 Phân loại phong cách',
    timeCategory:'1550 Phân loại thời gian',
    scanArea:'1551 Khu vực quét',
    query:'1552 Tìm kiếm',
    reset:'1553 Đặt lại',
    area:'1554 Khu vực',
    firstStyleCategory:'1555 Phân loại kiểu dáng cấp 1',
    secondStyleCategory:'1556 Phân loại kiểu dáng cấp 2',
    thirdStyleCategory:'1557 Phân loại kiểu dáng cấp 3',
    firstStyleType:'1558 Phân loại phong cách cấp 1',
    secondStyleType:'1559 Phân loại phong cách cấp 2',
    thirdStyleType:'1560 Phân loại phong cách cấp 3',
    firstTimeCategory:'1561 Phân loại thời gian cấp 1',
    secondTimeCategory:'1562 Phân loại thời gian cấp 2',
    thirdTimeCategory:'1563 Phân loại thời gian cấp 3',
    goodsName:'1564 Tên hàng hóa',
    inventoryQuantity:'1565 Số lượng kiểm kê',
    stockQuantity:'1566 Số lượng tồn kho',
    retailPrice:'1567 Giá bán lẻ',
    price:'1568 Giá',
    compensatePriceType:'1569 Loại giá bồi thường',
    tagPrice:'1570 Giá treo thẻ',
    compensateFormula:'1571 Công thức bồi thường',
    compensateAmount:'1572 Tiền bồi thường',
    differenceQuantity:'1573 Số lượng chênh lệch',
    allColor: 'Tất Cả',
    stockAccount: 'SL',
    saveChange: '3404 Lưu Thay Đổi',
    viewChange : '3405 Xem Thay Đổi',
    placeholderNumberTips: '3406 Vui Lòng Nhập Số Hợp Lệ',
    youNotChangeData: '3407 Bạn Chưa Thay Đổi Dữ Liệu Nào',
    saveSuccessTip: '3408 Lưu Thay Đổi Thành Công',
  },
  stockSingle: {
    singleRediscTitle:'1574 Kiểm kê lại từng mẫu',
    singleRediscInventoryOrderPrefix:'1575 Phiếu kiểm kê',
    singleRediscScanPlaceholder:'Vui lòng quét mã hoặc nhập mã vạch',
    singleRediscConfirm:'Xác nhận',
    singleRediscNegativeScan:'1578 Quét âm (Giảm)',
    singleRediscPositiveScan:'1579 Quét dương (Tăng)',
    singleRediscSelectDiffGoods:'1580 Chọn hàng hóa có chênh lệch kiểm kê',
    singleRediscManualAddPlaceholder:'1581 Nhập mã hàng / mã rút gọn / mã vạch để thêm thủ công',
    singleRediscAddDirectly:'1582 Thêm trực tiếp',
    singleRediscTotalQuantity:'1583 Tổng số lượng',
    singleRediscSubmit:'1584 Xác nhận gửi',
    singleRediscDeleteFirst:'1585 Vui lòng xóa mẫu hiện tại trước khi chọn',
    singleRediscSelectOrAddFirst:'1586 Vui lòng chọn hàng hóa có chênh lệch kiểm kê hoặc thêm thủ công',
    singleRediscTips:'1587 Thông báo',
    singleRediscBarcodeNotFound:'1588 Mã vạch này không tìm thấy cho mã hàng hiện tại',
    singleRediscConfirmDelete:'1589 Bạn có muốn xóa bản ghi này không?',
    singleRediscEnterInfo:'1590 Vui lòng nhập mã hàng / mã rút gọn / mã vạch',
    singleRediscAddGoodsFirst:'1591 Bạn chưa thêm hàng hóa nào, vui lòng thêm trước',
    singleRediscQuantityCannotBeZero:'1592 Số lượng kiểm kê lại lần này không thể là 0',
    singleRediscSubmitSuccess:'1593 Gửi thành công',
    selectInventoryDiffProduct: '3468 Chọn sản phẩm có sự khác biệt trong kiểm kê',
    styleCategory: '3469 Phân loại kiểu dáng',
    pleaseSelectStyleCategory: '3470 Vui lòng chọn phân loại kiểu dáng',
    styleType: '3471 Phân loại phong cách',
    pleaseSelectStyleType: '3472 Vui lòng chọn phân loại phong cách',
    timeCategory: '3473 Phân loại thời gian',
    pleaseSelectTimeCategory: '3474 Vui lòng chọn phân loại thời gian',
    productNoOrShortCode: '3475 Mã sản phẩm/Mã ngắn',
    pleaseInputProductNoOrShortCode: '3476 Vui lòng nhập mã sản phẩm/Mã ngắn',
    query: '3477 Tra cứu',
    cancel: '3478 Hủy',
    confirm: '3479 Xác nhận',
    productNo: '3480 Mã sản phẩm',
    productName: '3481 Tên sản phẩm',
    shortCode: '3482 Mã ngắn',
    color: '3483 Màu sắc',
    inventoryQuantity: '3484 Số lượng kiểm kê',
    stockQuantity: '3485 Số lượng tồn kho',
    diffQuantity: '3486 Số lượng khác biệt',
    retailPrice: '3487 Giá bán lẻ',
    total: '3488 Tổng cộng',
    recheckQuantity: 'Kiểm kê lại',
    originalCheckQuantity: 'Kiểm kê gốc',
    delete: '3491 Xóa',
  },
  differDetail: {
    diffDetails: '3492 Chi tiết sự khác biệt',
    pleaseWaitLoading: '3493 Vui lòng chờ, đang tải...',
    inventoryOrderName: '3494 Tên phiếu kiểm kê',
    inventoryOrderType: '3495 Loại phiếu kiểm kê',
    storeName: '3496 Tên cửa hàng',
    status: '3497 Trạng thái',
    createTime: '3498 Thời gian tạo',
    completeInventoryTime: '3499 Thời gian hoàn thành kiểm kê',
    auditTime: '3500 Thời gian duyệt',
    creator: '3501 Người tạo',
    totalInventoryQuantity: '3502 Tổng số lượng kiểm kê',
    totalStockQuantity: '3503 Tổng số lượng tồn kho',
    totalDiffQuantity: '3504 Tổng số lượng khác biệt',
    totalCompensationAmount: '3505 Tổng số tiền bồi thường',
    productNo: '3506 Mã sản phẩm',
    pleaseSelectProductNo: '3507 Vui lòng chọn mã sản phẩm',
    query: '3508 Tra cứu',
    productName: '3509 Tên sản phẩm',
    styleCategory: '3510 Phân loại kiểu dáng',
    timeCategory: '3511 Phân loại thời gian',
    color: '3512 Màu sắc',
    unitPrice: '3513 Đơn giá',
    diffQuantity: '3514 Số lượng khác biệt',
    compensationAmount: '3515 Số tiền bồi thường',
    beforeInventory: 'Kiểm kê',
    adjustmentQuantity: 'Điều chỉnh',
    currentPageTotalDiffQuantity: '3518 Tổng số khác biệt trên trang',
    currentPageTotalCompensationAmount: '3519 Tổng tiền bồi thường trên trang',
  },
  performance: {
    title: '1594 Lịch thành tích',
    separator: '1595 đến',
    startPlaceholder: '1596 Ngày bắt đầu',
    endPlaceholder: '1597 Ngày kết thúc',
    query: '1598 Tra cứu',
    deptSales: '1599 Thành tích cửa hàng',
    totalSales: '1600 Tổng thành tích',
    customerUnitPrice: '1601 Đơn giá khách hàng',
    unitPrice: '1602 Đơn giá sản phẩm',
    joinRate: '1603 Tỷ lệ mua kèm',
    challengeTarget: '1604 Mục tiêu',
    totalIncome: '1604 Tổng doanh thu',
    userSales: '1605 Thành tích người tư vấn',
    viewMonthPerformance: '1606 Hiệu suất tháng này',
    monthSelectorLabel: '1607 Chọn tháng:',
    monthSelectorPlaceholder: '1608 Vui lòng chọn tháng',
    salse: '{name}~{year}Năm{month}Tháng Kết quả kinh doanh',
    viewTeamSales: '1610 Xem thành tích đơn công',
    viewDeptSales: '1611 Xem thành tích cửa hàng',
    monday: '1612 Thứ Hai',
    tuesday: '1613 Thứ Ba',
    wednesday: '1614 Thứ Tư',
    thursday: '1615 Thứ Năm',
    friday: '1616 Thứ Sáu',
    saturday: '1617 Thứ Bảy',
    sunday: '1618 Chủ Nhật',
    dailySales: '1619 Thành tích:',
    loadingText: '1620 Vui lòng chờ, đang tải...',
    publicTitle: '1621 Thành tích đơn công',
    close: '1622 Đóng',
    labelName: '1623 Tên',
    placeholderName: '1624 Vui lòng nhập tên',
    innerSn: '1625 Số đơn',
    placeholderInnerSn: '1626 Vui lòng nhập số đơn',
    labelDate: '1627 Ngày',
    placeholderStartDate: '1628 Thời gian bắt đầu',
    placeholderEndDate: '1629 Thời gian kết thúc',
    reset: '1630 Đặt lại',
    search: '1631 Tra cứu',
    date: '1632 Ngày',
    ruleName: '1633 Tên quy tắc đơn công',
    // innerSn: '1634 Số đơn',
    orderPrice: '1635 Tổng thành tích đơn công',
    realName: '1636 Tên',
    postName: '1637 Chức vụ khi phân phối',
    proportion: '1638 Phần chia khi phân phối',
    userAmount: '1639 Thành tích được phân phối cá nhân',
    summary: '1640 Tổng hợp',
  },
  musicPlayer: {
    title: '1336 Bộ phát nhạc Cửa hàng',
    noSongName: '1337 Chưa có tên bài hát',
    noSongListName: '1338 Chưa có tên danh sách phát',
    noSinger: '1339 Chưa có ca sĩ',
    playlist: '1340 Danh sách phát',
    audioLoadError: '1341 Sự cố tải âm thanh',
    audioPlayError: '1342 Sự cố phát âm thanh',
    noPlayableMusic: '1343 Hiện tại không có nhạc có thể phát',
    noSongs: '1344 Chưa có bài hát',
    doublePlayer: '1345 Nhấp đúp tên bài hát để bắt đầu phát',
    musicName: '1346 Tên bài hát',
    singList: '1347 Danh sách phát',
    singer: '1348 Ca sĩ',
    duration: '1349 Thời lượng',
    invalid: '1350 Bài hát này đã hết hạn',
  },
  salesRecord: {
    salesRecord:'2927 Bản ghi bán hàng',
    hangRecord:'2928 Bản ghi đơn hàng tạm giữ',
    loadingText:'2929 Vui lòng chờ, hệ thống đang tải...',
    afterSales:'2930 Dịch vụ sau bán hàng',
    goodsInfo:'Thông tin sản phẩm',
    afterSalesGoodsInfo:'2932 Thông tin sản phẩm của đơn dịch vụ sau bán hàng',
    totalItems:'2933 Tổng số lượng: {count}sản phẩm',
    totalAmount:'2934 Tổng tiền',
    original:'2935 Gốc',
    originalGoodsInfo:'2936 Thông tin sản phẩm của đơn hàng này trước khi phát sinh dịch vụ sau bán hàng',
    collapse:'2937 Thu gọn',
    expand:'2938 Mở rộng',
    latest:'2939 Mới nhất',
    latestGoodsInfo:'2940 Thông tin sản phẩm của đơn hàng này sau khi đã phát sinh dịch vụ sau bán hàng',
    documentInfo:'Thông tin đơn hàng',
    orderAmount:'2942 Tổng tiền phải trả（Bao VAT）',
    taxPrice:'2942 Thuế VAT',
    retailAmount:'2943 Tiền bán lẻ',
    receivedAmount:'2944 Tiền đã thu',
    activityAmount:'2945 Tiền khuyến mãi',
    changeAmount:'2946 Tiền điều chỉnh',
    salesStatus:'2947 Trạng thái bán hàng',
    cancelled:'2948 Đã hủy',
    pendingPayment:'2949 Chờ thanh toán',
    paying:'Đang thanh toán',
    paid:'2951 Đã thanh toán',
    pendingApproval:'2952 Chờ phê duyệt',
    pending:'2953 Đã tạm dừng',
    invalidated:'2954 Đã vô hiệu',
    storeName:'2955 Tên cửa hàng',
    giftInfo:'2956 Thông tin quà tặng',
    documentSource:'2957 Nguồn đơn hàng',
    mobile:'2958 Điện thoại',
    client:'2959 Máy tính',
    orderNature:'2960 Tính chất đơn hàng',
    salesOrderNo:'2961 Số đơn bán hàng',
    originalSalesOrderNo:'2962 Số đơn bán hàng gốc',
    externalOrderNo:'2963 Số đơn bên ngoài',
    performanceMethod:'2964 Phương thức doanh số',
    personalPerformance:'2965 Doanh số cá nhân',
    teamPerformance:'2966 Doanh số tổ',
    distribution:'2967 Phân phối',
    salesperson:'2968 Nhân viên bán hàng',
    creationTime:'2969 Thời gian tạo',
    teamMembers:'2970 Nhân viên tổ',
    createOrderCashier:'2971 Quầy thu ngân tạo đơn',
    endOrderCashier:'2972 Quầy thu ngân kết thúc đơn',
    promotionInfo:'Thông tin khuyến mãi',
    promotion:'2974 Khuyến mãi',
    promotionName:'2975 Tên khuyến mãi',
    promotionType:'2976 Loại khuyến mãi',
    promotionNo:'2977 Mã khuyến mãi',
    discountAmount:'2978 Số tiền giảm trừ',
    promotionDetails:'2979 Chi tiết đơn khuyến mãi',
    viewDetails:'2980 Xem chi tiết',
    memberInfo:'2981 Thông tin thành viên',
    memberNickname:'2982 Biệt danh thành viên',
    memberCardNo:'2983 Số thẻ thành viên:',
    totalConsumptionAmount:'2984 Tổng tiền đã tiêu',
    unitPrice:'2985 Giá mỗi sản phẩm',
    cardOpeningTime:'2986 Thời gian mở thẻ',
    totalConsumptionCount:'2987 Tổng số lần tiêu dùng',
    memberPoints:'2988 Điểm thành viên',
    phoneNumber:'2989 Số điện thoại',
    cardIssuingStore:'2990 Cửa hàng mở thẻ',
    averageConsumptionAmount:'2991 Số tiền tiêu dùng trung bình',
    memberBalance:'2992 Số dư thành viên',
    paymentInfo:'Thông tin thanh toán',
    paymentMethod:'2994 Phương thức thanh toán',
    paymentAmount:'2995 Số tiền thanh toán',
    paymentStatus:'2996 Trạng thái thanh toán',
    created:'2997 Đã tạo',
    cancelledPay:'2998 Đã hủy',
    pendingPay:'2999 Đang thanh toán',
    updateTime:'3000 Thời gian cập nhật',
    paymentVoucherNo:'3001 Số chứng từ thanh toán',
    serialNumber:'3002 Số giao dịch',
    couponName:'3003 Tên phiếu giảm giá',
    couponType:'3004 Loại phiếu giảm giá',
    couponSource:'3005 Nguồn phiếu giảm giá',
    couponDiscountAmount:'3006 Số tiền giảm giá',
    operation:'3007 Thao tác',
    receiptPreview:'Xem trước hóa đơn',
    approvalInfo:'3009 Thông tin phê duyệt',
    approvalNo:'3010 Mã phê duyệt',
    processType:'3011 Loại quy trình',
    status:'3012 Trạng thái',
    withdrawn:'3013 Đã rút lại',
    approved:'3014 Đã thông qua',
    rejected:'3015 Đã từ chối',
    pendingReview:'3016 Chờ duyệt',
    initiator:'3017 Người khởi tạo',
    submissionTime:'3018 Thời gian gửi',
    lastUpdateTime:'Thông tin sản phẩm mới nhất',
    approver:'3020 Người phê duyệt',
    rejectionReason:'3021 Lý do từ chối',
    approvalDetails:'3022 Chi tiết phê duyệt',
    afterSalesInfo:'Thông tin sau bán hàng',
    afterSalesType:'3024 Loại dịch vụ sau bán hàng',
    afterSalesOrderNo:'3025 Số đơn sau bán hàng',
    afterSalesTime:'3026 Thời gian sau bán hàng',
    goodsAmount:'3027 Tiền hàng',
    pendingEffect:'3028 Chờ hiệu lực',
    effective:'3029 Đã hiệu lực',
    invalid:'3030 Đã hết hiệu lực',
    remarks:'3031 Ghi chú',
    logisticsInfo:'3032 Thông tin vận chuyển',
    recipient:'3033 Người nhận',
    recipientPhone:'3034 Số ĐT người nhận',
    receivingAddress:'3035 Địa chỉ giao hàng',
    orderMethod:'3036 Cách thức đặt hàng',
    jdAutoOrder:'3037 Đặt tự động JD',
    manualOrder:'3038 Đặt thủ công',
    logisticsStatus:'3039 Trạng thái vận chuyển',
    packaged:'3040 Đã đóng gói',
    shipped:'3041 Đang vận chuyển',
    signed:'3042 Đã nhận hàng',
    courierCompany:'3043 Hãng vận chuyển',
    trackingNumber:'3044 Số vận đơn',
    cancel:'3045 Hủy',
    modify:'3046 Sửa',
    logisticsTracking:'3047 Vận Chuyển',
    customOrderInfo:'3048 Thông tin đặt hàng của khách',
    customOrderNo:'3049 Số đơn đặt hàng của khách',
    customOrderType:'3050 Loại đặt hàng của khách',
    deliveryStore:'3051 Cửa hàng giao hàng',
    viewOrderDetails:'3052 Xem chi tiết',
    printReceipt:'3053 In hóa đơn',
    continuePayment:'3054 Tiếp tục thanh toán',
    cancelOrder:'3055 Hủy đơn hàng',
    returnRefund:'3056 Trả hàng/Hoàn tiền',
    fullRefund:'3057 Trả toàn bộ đơn',
    openCollectMoney:'3058 Quầy thu ngân',
    hasReviewingNotOperate:'3059 Có yêu cầu phê duyệt đang xử lý, không thể thao tác nút',
    confirmReturn:'3060 Xác nhận trả hàng',
    cancelReturn:'3061 Hủy trả hàng',
    sendToCustomer:'3062 Gửi hàng cho khách',
    outOfStockOrder:'3063 Đặt hàng thiếu hàng',
    deleteHang:'3064 Xóa',
    sureHang:'3065 Xác nhận lấy đơn',
    hangDeleteContent:'3066 Sau khi xóa sẽ không thể khôi phục bản ghi đơn hàng tạm giữ, xác nhận xóa?',
    hangUseOtherThreeCoupon:'3067 Đã sử dụng phiếu giảm giá bên thứ ba, khi xóa đơn tạm giữ hệ thống sẽ thử hủy phiếu giảm giá trước. Nếu hủy phiếu giảm giá thất bại (quá hạn), khách hàng cần liên hệ kênh bên thứ ba để hoàn phiếu.',
    hangDeleteTips:'3068 Nhắc nhở xóa',
    getHangDataConfirm:'3069 Xác nhận trích xuất dữ liệu đơn hàng này',
    getHangDataTip:'3070 Nhắc nhở lấy đơn',
    noOrderData:'3071 Chưa có dữ liệu chi tiết đơn hàng',
    close:'3072 Đóng',
    confirmClose:'3073 Xác nhận đóng?',
    tips:'3074 Thông báo',
    operationSuccess:'3075 Thao tác thành công',
    operationFailed:'3076 Thao tác thất bại',
    confirmModifyOrder:'3077 Xác nhận sửa đổi đơn hàng? Sau khi xác nhận, đơn này sẽ bị hủy và thông tin sản phẩm sẽ được chuyển đến quầy thu ngân.',
    confirmReturnGoods:'3078 Xác nhận trả hàng?',
    confirmCancelReturn:'3079 Hủy trả hàng?',
    confirmCancelExpress:'3080 Xác nhận hủy đơn vận chuyển này',
    expressCancelSuccess:'3081 Hủy đơn vận chuyển thành công',
    orderMatchedShipped:'3082 Đã có đơn đặt hàng của khách khớp thành công và đã giao hàng, vui lòng xử lý kho hàng thích hợp sau khi nhận hàng trong thao tác đơn đặt hàng của khách.',
    pleaseCloseCustomOrder:'3083 Vui lòng đóng đơn đặt hàng của khách trước.',
  },
  salsesOrder: {
    saleOrderNo:'3084 Mã đơn hàng',
    placeholderEnterSaleOrderNo:'3085 số đơn bán hàng',
    goodsNoOrBarcode:'3086 Mã hàng/Mã vạch',
    placeholderEnterGoodsNoOrBarcode:'3087 Mã hàng/Mã vạch',
    date:'3088 Ngày',
    to:'3089 đến',
    startDate:'3090 Ngày bắt đầu',
    endDate:'3091 Ngày kết thúc',
    orderNature:'3092 Loại đơn hàng',
    placeholderSelect:'3093 Vui lòng chọn',
    performanceMethod:'3094 Hình thức thành tích',
    salesman:'3095 Nhân viên bán hàng',
    memberPhone:'3096 Số điện thoại thành viên',
    placeholderEnterMemberPhone:'3097 Số điện thoại thành viên',
    documentSource:'3098 Nguồn đơn',
    sourceMobile:'3099 Ứng dụng di động',
    sourceClient:'3100 Máy tính client',
    orderStatus:'3101 Trạng thái đơn hàng',
    statusCancelled:'Đã hủy',
    statusPendingPayment:'Chờ thanh toán',
    statusCompleted:'Đã hoàn thành',
    statusInvalidated:'Đã vô hiệu',
    pendingConfirmation:'Chờ xác nhận',
    paymentMethod:'3107 Phương thức thanh toán',
    participatePromotion:'3108 Tham gia khuyến mãi',
    afterSalesOccurred:'3109 Đã phát sinh hậu mãi',
    approvalOccurred:'3110 Đã phát sinh phê duyệt',
    defectiveSalesOrder:'3111 Đơn bán hàng lỗi',
    asideYes:'3112 Có',
    asideNo:'3113 Không',
    asideCollapse:'3114 Thu gọn',
    asideExpand:'3115 Mở rộng',
    asideReset:'3116 Đặt lại',
    asideConfirm:'3117 Xác nhận',
    noDocumentRecords:'3118 Không tìm thấy dữ liệu đơn hàng',
    confirmTitle:'3119 Thông báo',
    hangingOrderDeletedCouponRevoked:'3120 Xóa đơn treo thành công và phiếu giảm giá đã được thu hồi.',
    hangingOrderDeletedCouponExpired:'3121 Xóa đơn treo thành công, phiếu giảm giá đã hết hạn không thể thu hồi, cần đến kênh tương ứng để hoàn trả.',
    operationSuccess:'3122 Thao tác thành công',
    // defectiveSalesOrder:'3123 Đơn bán hàng lỗi',
    approval:'3124 Phê duyệt',
    withdrawn:'3125 Đã rút lại',
    approved:'3126 Đã thông qua',
    rejected:'3127 Đã từ chối',
    pendingApproval:'3128 Chờ phê duyệt',
    originalSalesOrder:'3129 Đơn bán hàng gốc',
    individualPerformance:'3130 Thành tích cá nhân',
    teamPerformance:'3131 Thành tích tổ',
    distribution:'3132 Phân phối',
    totalQuantity:'3133 Tổng số lượng',
    createTime:'3134 Thời gian tạo',
    teamMembers:'3135 Thành viên tổ',
    // salesman:'3136 Nhân viên bán hàng',
    afterSalesCount:'3137 Số lần phát sinh hậu mãi',
    approvalCount:'3138 Số lần phát sinh phê duyệt',
    amountReceivable:'3139 Số tiền phải thu',
    amountReceived:'3140 Số tiền thực thu',
    orderUnit:'cái',
    copySuccess:'3142 Sao chép thành công!',
  },
  cancelOrder: {
    cancelTitle:'3143 Hủy đơn hàng',
    paySome:'3144 Đơn hàng đã được thanh toán một phần',
    cancelSureTitle:'3145 Xác nhận hủy?',
    notPayTips:'3146 Đơn hàng chưa thanh toán xong, xác nhận hủy?',
    cancelTextTips:'3147 Đơn hàng có sử dụng phiếu giảm giá của bên thứ ba. Sau khi hủy đơn, hệ thống sẽ thử thu hồi phiếu giảm giá trước. Nếu thu hồi thất bại (quá thời hạn), khách hàng cần tự liên hệ kênh thứ ba để hoàn phiếu.',
    cancelBtn:'3148 Hủy bỏ',
    sureBtn:'3149 Xác nhận',
    cancelSuccess:'3150 Hủy đơn hàng thành công, và phiếu giảm giá đã được thu hồi.',
    notRebackCoupon:'3151 Hủy đơn hàng thành công, phiếu giảm giá đã quá hạn không thể thu hồi, cần đến kênh tương ứng để thực hiện hoàn phiếu.',
    tips:'3152 Thông báo',
    canceTips:'3153 Đơn hàng đã bị hủy',
  },
  changePrice: {
    title:'Đơn xin điều chỉnh giá',
    submitter:'3172 Người gửi',
    selectPrompt:'3173 Vui lòng chọn',
    submitTime:'3174 Thời gian gửi',
    selectDateTime:'3175 Chọn ngày giờ',
    shopName:'3176 Tên cửa hàng',
    originalPrice:'3177 Giá gốc',
    newPrice:'3178 Giá sau điều chỉnh',
    changeAmount:'3179 Chênh lệch giá',
    remark:'3180 Ghi chú',
    inputPrompt:'3181 Vui lòng nhập',
    priceChangedGoods:'3182 Hàng hóa điều chỉnh giá',
    addPrice:'Tăng {money}',
    miniPrice:'Giảm {money}',
    applicationInfo:'3185 Thông tin đơn đăng ký',
    cancel:'3186 Hủy bỏ',
    confirm:'3187 Xác nhận',
    operationInProgress:'3188 Thao tác đang được thực hiện, không thể đóng',
    selectSubmitter:'3189 Vui lòng chọn người nộp đơn',
    fillApprovalRemark:'3190 Vui lòng điền ghi chú phê duyệt',
    submitSuccess:'3191 Đơn xin điều chỉnh giá đã được gửi',
  },
  returnGoods: {
    title:'3192 Trả hàng',
    priceTips:'Giá trả hàng mặc định của hàng hóa sẽ được lấy giá thấp nhất giữa giá bán đơn gốc và giá bán hiện tại.  Trong trường hợp đặc biệt, có thể thay đổi giá trả hàng theo quy trình phê duyệt.',
    loading:'Vui lòng chờ, hệ thống đang tải...',
    noGoodsImage:'Chưa có hình ảnh',
    barCodeCount:'{count} chiếc',
    goodsNoCount:'Tổng{count}mẫu',
    addBuy:'Mua thêm',
    gift:'Quà tặng',
    activity:'Khuyến mãi',
    partialDiscount:'Tỷ lệ giảm giá khi trả một phần',
    partialPriceType:'Giá trả khi trả một phần',
    couponReturnTotal:'Tổng giá trị voucher hoàn lại',
    infoTitle:'3204 Thông tin trả hàng',
    originalOrder:'3205 Đơn bán hàng gốc',
    salesman:'3206 Nhân viên bán hàng',
    publicOrder:'3207 Đơn công',
    member:'3208 Thành viên:',
    originalLatestAmount:'3209 Giá trị mới nhất của đơn gốc',
    salesQuantity:'3210 Số lượng đã bán',
    defaultReturnTotal:'3211 Tổng giá trả hàng mặc định',
    returnQuantity:'3212 Số lượng trả hàng',
    refundAmount:'3213 Số tiền hoàn lại',
    returnReason:'3214 Vui lòng mô tả lý do trả hàng',
    pleaseInput:'3215 Vui lòng nhập',
    confirmReturn:'3216 Xác nhận trả hàng',
    returnNotBigBuy:'3217 Số lượng trả hàng không được lớn hơn số lượng đã mua',
    returnNotMiniOne:'3218 Số lượng trả hàng không được nhỏ hơn 1',
    returnOneBuy:'3219 Số lượng trả hàng không thể là 0 và không được lớn hơn số lượng đã mua',
    confirmCancelPriceChange:'3220 Xác nhận hủy điều chỉnh giá',
    tip:'3221 Thông báo',
    selectGoodsTip:'3222 Vui lòng chọn sản phẩm cần trả lại',
    fillReasonTip:'3223 Vui lòng điền lý do trả hàng',
    priceChangeExceedTip:'3224 Giá điều chỉnh của các sản phẩm dưới đây vượt quá phạm vi cho phép, vui lòng nhấp [Xác nhận] để gửi yêu cầu điều chỉnh giá!',
    priceChangeReminder:'3225 Nhắc nhở điều chỉnh giá',
    confirmInfoTip:'3226 Vui lòng đảm bảo thông tin trả hàng chính xác, sau khi xác nhận sẽ tạo ra hồ sơ hậu mãi!',
    attention:'3227 Lưu ý:',
    publicOrderTip:'3228 Đơn bán hàng công sẽ giảm thành tích theo tỷ lệ chia sẻ ban đầu.',
    memberOrderTip:'3229 Việc trả hàng từ đơn bán hàng cho thành viên sẽ làm giảm điểm tích lũy của thành viên.',
    thirdPartyCouponTip:'3230 Giá trị mua coupon của bên thứ ba đã được bao gồm trong giá trả hàng, vui lòng không xử lý trùng lặp yêu cầu hoàn tiền từ bên thứ ba để tránh hoàn tiền thêm.',
    confirmReturnTitle:'3231 Xác nhận trả hàng',
    allTitle:'3232 Xác nhận trả hàng?',
    allCancel:'3233 Hủy',
    moneyUnit:'3234 VNĐ',
    allVipPayAndOther:'Đơn này sử dụng phương thức thanh toán kết hợp và bao gồm thanh toán bằng số dư thành viên, chỉ cho phép trả toàn bộ đơn theo giá bán gốc, cần hoàn tiền mặt',
    allHasCoupon:'Bao gồm hoàn lại voucher khuyến mãi',
    allVipPay:'Đã thanh toán bằng số dư thành viên',
    allBackVip:'Sẽ được hoàn lại vào số dư thành viên',
    allSure:'3239 Xác nhận',
  },
  exchangeGoods: {
    loadingText:'3240 Xin vui lòng chờ, hệ thống đang tải...',
    goodsImage:'3241 Hình ảnh sản phẩm',
    noGoodsImage:'3242 Chưa có hình ảnh',
    goodsNo:'3243 Mã hàng',
    goodsBarCode:'3244 Mã vạch',
    goodsColor:'3245 Màu sắc',
    goodsSize:'3246 Kích cỡ',
    goodsNumber:'3247 Số lượng',
    goodsNoCount:'3248 Số kiện',
    goodsType:'3249 Loại',
    goodsInfo:'3250 Thông tin sản phẩm',
    goodsAttr:'3251 Màu sắc/Kích cỡ',
    addBuy:'Mua thêm',
    gift:'Quà tặng',
    activity:'Khuyến mãi',
    unitPrice:'3255 Đơn giá',
    amountPrice:'3256 Tổng tiền',
    operation:'3257 Thao tác',
    exchange:'3258 Đổi hàng',
    noSelectedGoods:'3259 Chưa chọn sản phẩm đổi',
    exchangeGoods:'3260 Sản phẩm đổi',
    promotionActivity:'3261 Chương trình khuyến mãi:',
    scanToAdd:'3262 Vui lòng quét hoặc nhập mã vạch để thêm sản phẩm',
    confirm:'3263 Xác nhận',
    addManually:'3264 Thêm thủ công',
    replacementGoods:'3265 Thay thế sản phẩm',
    delete:'3266 Xóa',
    reasonDesc:'3267 * Vui lòng mô tả lý do đổi hàng:',
    pleaseInput:'3268 Vui lòng nhập',
    reselectGoods:'3269 Chọn lại sản phẩm đổi',
    confirmExchange:'3270 Xác nhận đổi hàng',
    promotionEnd:'3271 Khuyến mãi cho sản phẩm này đã kết thúc, không hỗ trợ đổi hàng',
    tips:'3272 Thông báo',
    gotIt:'3273 Đã hiểu',
    sameColorSizeError:'3274 Không thể đổi sang sản phẩm cùng màu và kích cỡ',
    quantityExceedError:'3275 Số lượng đổi không được vượt quá số lượng sản phẩm ban đầu',
    maxQuantityError:'3276 Đã đạt số lượng đổi tối đa, không thể thêm nữa',
    confirmDelete:'3277 Bạn có chắc muốn xóa sản phẩm thay thế này không?',
    confirmReselect:'3278 Xác nhận chọn lại sản phẩm đổi',
    noAddedGoods:'3279 Bạn chưa thêm sản phẩm đổi nào',
    pleaseAddGoods:'3280 Vui lòng thêm sản phẩm cần đổi',
    pleaseFillReason:'3281 Vui lòng điền lý do đổi hàng',
    promotionExchange:'3282 Đổi hàng khuyến mãi',
    colorCodeExchange:'3283 Đổi hàng (màu sắc/kích cỡ)',
    chooseAttr:'3284 Chọn thông số',
    pleaseInputGoodsNoCode:'3285 Nhập mã hàng/mã rút gọn',
    searchGoods:'3286 Tìm kiếm',
    pleaseInputValueSearch:'3287 Vui lòng nhập mã hàng hoặc mã rút gọn để tìm kiếm',
    attrStock:'3288 Tồn kho: {count} chiếc',
    attCancel:'3289 Hủy',
    attrSure:'3290 Xác nhận',
    selectChangeColorSize:'3291 Chọn màu sắc/kích cỡ đổi',
    selectColorSize:'3292 Chọn màu sắc/kích cỡ',
    attrMiniNumber:'3293 Số lượng tối thiểu là 1, không thể giảm thêm',
    goodsNoStock:'3294 Hàng tồn kho hiện tại không đủ, vui lòng chọn sản phẩm khác',
    pleaseExchangeColorSize:'3295 Vui lòng chọn màu sắc/kích cỡ muốn đổi',
    notChangeNormalAttr:'3296 Không thể đổi sang sản phẩm cùng màu sắc và kích cỡ',
    currentMaxGoodsCount:'3297 Số lượng đổi tối đa hiện tại là {count}',
  },
  gridManage: {
    columnType:'3298 Loại hình',
    columnGoodsInfo:'3299 Thông tin hàng hóa',
    noGoodsImage:'Chưa có hình ảnh',
    badGoods:'Hàng lỗi',
    gave:'Quà tặng',
    addBuy:'Mua thêm',
    activity:'Khuyến mãi',
    writeOff:'Xác nhận thanh toán',
    goodsName:'3306 Tên hàng hóa',
    goodsImages:'3307 Hình ảnh hàng hóa',
    tagImages:'3308 Hình ảnh thẻ treo',
    notUploadImg:'3309 Hình ảnh chưa tải lên',
    goodsNo:'3310 Mã hàng',
    goodsBarCode:'3311 Mã vạch',
    columnAttr:'3312 Màu sắc / Kích cỡ',
    goodsStock:'3313 Tồn kho khả dụng',
    tagPrice:'3314 Giá thẻ treo',
    discount:'3315 Giảm giá',
    number:'3316 Số lượng',
    showOrRechoose:'3317 Xem/Chọn lại hàng',
    originalPrice:'3318 Giá bán gốc',
    agoRealPrice:'3319 Đơn giá trước sửa',
    realPrice:'3320 Đơn giá sau sửa',
    beforeTotalPrice:'3321 Tổng giá trước sửa',
    afterTotalPrice:'3322 Tổng giá sau sửa',
    realPriceUnit:'3323 Giá bán thực tế (đơn vị)',
    alreadyChangePrice:'Đã sửa giá',
    autoRepairPrice:'3325 Bù giá tự động',
    retailPrice:'3326 Giá bán lẻ',
    initRealPrice:'3327 Giá gốc',
    totalPrice:'3328 Số tiền',
    columnAction:'3329 Thao tác',
    rebackWriteOff:'3330 Hủy xác nhận thanh toán',
    actionDelete:'3331 Xóa',
    rightshowStock:'3332 Xem tồn kho',
    rightDelect:'3333 Xóa',
    accountPrice:'3334 Tổng số tiền',
    currentSellPrice:'3335 Giá bán lẻ hiện tại',
    fixedRetreatPrice:'3336 Giá trả hàng mặc định',
    partReturnPrice:'3337 Tỷ lệ giảm giá trả hàng một phần',
    retreatPrice:'3338 Giá trả hàng',
    retreatNumber:'3339 Số lượng trả hàng',
    totalRetreatPrice:'3340 Số tiền trả hàng',
    showGoods:'3341 Xem hàng hóa',
    sellNumber:'3342 Số lượng bán',
    suggestPrice:'3343 Giá đề xuất (đơn vị)',
  },
  print: {
    printing:'3154 Máy in đang in',
    printFinishClick:'3155 Sau khi in xong, nhấn vào nút Hoàn tất in bên dưới',
    finishPrint:'3156 Hoàn tất in',
    clickEnter:'3157 Nhấn Enter để đóng',
    printTitle:'3158 In biên lai',
    printInvoiceNo:'3159 Mã chứng từ',
    printCount:'3160 Số bản in',
    printContent:'3161 Nội dung in',
    printAllLabel:'3162 Tổng đơn',
    printOneFace:'3163 In lần lượt nhãn gói hàng',
    printOneOut:'3164 In lần lượt nhãn thùng ngoài',
    printDevice:'3165 Máy in',
    pleaseSelectPrint:'3166 Vui lòng chọn máy in',
    printCancel:'3167 Hủy bỏ',
    printSure:'3168 Xác nhận in',
    printSetTitle:'3169 Cài đặt in',
    notPackagePickUp:'3170 {invoice} Hiện chứng từ này không có gói hàng nào, vui lòng nhặt hàng, đóng gói tạo gói hàng trước khi in.',
  },
  auditDetail: {
    title:'3344 Chi tiết phê duyệt',
    loadingText:'3345 Vui lòng chờ, hệ thống đang tải...',
    priceChangeApply:'3346 Đơn đề nghị điều chỉnh giá',
    badGoodsApply:'3347 Đơn đề nghị hàng lỗi',
    voidApply:'3348 Đơn đề nghị hủy bỏ',
    submitter:'3349 Người gửi',
    submitTime:'3350 Thời gian gửi',
    shopName:'3351 Tên cửa hàng',
    originalPrice:'3352 Giá gốc',
    afterPrice:'3353 Số tiền sau điều chỉnh',
    priceChange:'3354 Chênh lệch số tiền',
    remark:'3355 Ghi chú',
    couponInfo:'3356 Thông tin phiếu giảm giá',
    couponInfoSource:'3357 Nguồn:',
    couponInfoType:'3358 Loại phiếu giảm giá:',
    validityPeriod:'3359 Hiệu lực:',
    to:'3360 đến',
    changeGoodsList:'3361 Mặt hàng được điều chỉnh giá trong đơn',
    badGoodsList:'3362 Danh sách hàng lỗi',
    voidList:'3363 Danh sách hàng hủy',
    changeBefore:'3364 Tổng giá trị trước điều chỉnh',
    changeAfter:'3365 Tổng giá trị sau điều chỉnh',
  },
  promotion: {
    title:'3366 Chi tiết đơn khuyến mãi',
    loadingText:'3367 Vui lòng chờ, hệ thống đang tải...',
    activityInfo:'3368 Thông tin đơn khuyến mãi',
    activityName:'3369 Tên chương trình KM',
    type:'3370 Loại khuyến mãi',
    activityNo:'3371 Mã số khuyến mãi',
    effectiveType:'3372 Loại hiệu lực',
    shortTerm:'3373 Ngắn hạn',
    longTerm:'3374 Dài hạn',
    discountAmount:'3375 Số tiền giảm trừ',
    realAmount:'3376 Số tiền thực thanh toán',
    totalAmount:'3377 Tổng số tiền',
    startTime:'3378 Thời gian đặt hàng',
    goodsList:'3379 Danh sách mặt hàng trong đơn KM',
    goodsImage:'3380 Hình ảnh sản phẩm',
    noImage:'Chưa có hình ảnh',
    goodsName:'3382 Tên mặt hàng',
    barCode:'3383 Mã vạch',
    goodsNo:'3384 Mã hàng',
    retailPrice:'3385 Giá',
    attr:'3386 Màu sắc / Kích cỡ',
  },
  sendToCustomer: {
    sendToCustomer: '3438 Gửi hàng đến khách',
    storeTypeFranchise: '3439 Kết nối liên doanh',
    storeTypeDirect: '3440 Cửa hàng trực tiếp',
    documentNo: '3441 Số chứng từ',
    sender: '3442 Bên gửi',
    receiver: '3443 Bên nhận',
    fillReceiverInfo: '3444 Điền thông tin người nhận',
    inputMethod: '3445 Phương thức nhập liệu',
    jdAutoOrder: '3446 Đặt hàng tự động JD',
    manualOrder: '3447 Đặt hàng thủ công',
    estimatedWeight: '3448 Trọng lượng dự kiến: {weight} kg',
    calcByProductWeight: '3449 Tính theo khối lượng sản phẩm trong dữ liệu',
    jdExpressCondition: '3450 Nếu trọng lượng hiện tại < {weight} kg, sẽ gửi bằng JD Express',
    logisticsNo: '3451 Số vận đơn logistics',
    scanOrInputLogisticsNo: '3452 Vui lòng quét hoặc nhập số vận đơn',
    expressCompany: '3453 Công ty logistics',
    pleaseSelect: '3454 Vui lòng chọn',
    contactProductCenterForHelp: '3455 Nếu có thắc mắc, vui lòng liên hệ trung tâm sản phẩm để xử lý',
    cancel: '3456 Hủy',
    confirm: '3457 Xác nhận',
    receiverName: '3458 Tên người nhận',
    phoneNumber: '3459 Số điện thoại',
    provinceCityArea: '3460 Tỉnh/Thành phố/Quận huyện',
    detailedAddress: '3461 Địa chỉ chi tiết',
    pleaseInput: '3462 Vui lòng nhập',
    autoParse: '3463 Phân tích tự động',
    changeReceiverInfo: '3464 Chỉnh sửa thông tin người nhận',
    pleaseFillReceiverInfo: '3465 Vui lòng điền thông tin bên nhận',
    pleaseFillLogisticsNo: '3466 Vui lòng điền số vận đơn logistics',
    pleaseSelectLogisticsCompany: '3467 Vui lòng chọn công ty logistics',
  },
  payment: {
    invoiceTitle: '3531 Tạo hóa đơn',
    personalType: '3532 Cá nhân',
    enterpriseType: '3533 Doanh nghiệp/Tổ chức',
    personalName: '3534 Tên cá nhân',
    idCardNo: '3535 Số CMND/CCCD',
    enterpriseName: '3536 Tên doanh nghiệp',
    taxCode: '3537 Mã số thuế',
    address: '3538 Địa chỉ',
    inputPrompt: '3539 Vui lòng nhập',
    confirmBtn: '3540 Xác nhận',
    nameRequiredPrompt: '3541 Vui lòng nhập tên cá nhân',
    enterpriseNameRequiredPrompt: '3542 Vui lòng nhập tên doanh nghiệp',
    taxCodeRequiredPrompt: '3543 Vui lòng nhập mã số thuế',
    emailInputValidFormat: 'Vui lòng nhập định dạng email hợp lệ',
    emailAddress: '3544 Địa chỉ email',
  },

  //登录
  login:{
    minimize:'1249 Thu nhỏ',
    close:'1250 Đóng',
    welcomeTitle:'1251 Chào mừng đăng nhập vào ứng dụng YY',
    inputPhone:'1252 Vui lòng nhập số điện thoại người dùng',
    inputPassword:'1253 Vui lòng nhập mật khẩu đăng nhập',
    rememberPassword:'1254 Nhớ mật khẩu',
    loginBtn:'1255 Đăng nhập',
    scanCodeTip:'1256 Vui lòng sử dụng APP quét mã QR bên dưới, nhấp vào "Xác nhận ủy quyền" để đăng nhập',
    scanSuccessTip:'1257 Quét mã thành công, vui lòng nhấp vào "Xác nhận ủy quyền" trên điện thoại',
    authorizing:'1258 Đang ủy quyền...',
    qrcodeExpired:'1259 Mã QR đã hết hạn',
    loginFail:'1260 Đăng nhập thất bại',
    refreshQrcode:'1261 Làm mới mã QR',
    qrcodeExpireTime:'1262 Thời gian hết hạn mã QR:',
    multiCashierTip:'1263 Đã thiết lập nhiều quầy thu ngân, vui lòng chọn quầy thu ngân tương ứng với thiết bị thu ngân hiện tại',
    rememberSelection:'1264 Nhớ lựa chọn trên máy này',
    confirmEnter:'1265 Xác nhận và vào',
    envSetting:'1266 Cài đặt môi trường ứng dụng',
    inputPasswordTip:'1267 Vui lòng nhập mật khẩu',
    envSelect:'1268 Chọn môi trường:',
    prodEnv:'1269 Môi trường chính thức',
    preEnv:'1270 Môi trường thử nghiệm công khai',
    confirm:'1271 Xác định',
    validPhone:'1272 Vui lòng nhập số điện thoại hợp lệ',
    inputPasswordRequired:'1273 Vui lòng nhập mật khẩu',
    correctDevPassword:'1274 Vui lòng nhập mật khẩu nhà phát triển chính xác',
    envSwitchError:'1275 Lỗi khi chuyển đổi môi trường',
    selectCashier:'1276 Vui lòng chọn một quầy thu ngân để vào',
    switchLanguage:'3388 切换语言',
    languageSwitchSuccess:'3392 Chuyển đổi ngôn ngữ thành công!',
  },
  //首页
  home:{
    yyPartnerHome:'1277 YY Trang Chủ',
    quit:'1278 Đăng xuất',
    navScanCode:'1279 Quét mã chấm công',
    remoteHelp:'1280 Hỗ trợ từ xa',
    refreshPage:'1281 Làm mới trang',
    minimize:'1282 Thu nhỏ',
    close:'1283 Đóng',
    workbenchTitle:'1284 Bàn làm việc',
    workbenchViewMore:'1285 Xem thêm',
    todoTitle:'1286 Công việc chờ xử lý',
    todoAll:'1287 Tất cả công việc chờ',
    todoTransferOrder:'1288 Đơn hàng xuất',
    todoCustomerOrder:'1289 Đơn hàng khách hàng',
    todoEnterOrderNo:'1290 Vui lòng nhập mã đơn',
    todoSearch:'1291 Tìm kiếm',
    todoLastRefreshTime:'1292 Thời gian làm mới lần trước:',
    todoRefresh:'1293 Làm mới',
    tableType:'1294 Loại',
    tableInvoiceNo:'1295 Mã đơn',
    tableInvoiceDate:'1296 Ngày đơn',
    tableRelatedStore:'1297 Cửa hàng/kho liên quan',
    tableOverdueDays:'1298 Số ngày quá hạn',
    enterpriseWindowTitle:'1299 Cửa sổ doanh nghiệp',
    newsReadCount:'1300 Lần đọc',
    performanceBoardTitle:'1301 Bảng hiển thị thành tích',
    performanceTodayDiff:'1302 Chênh lệch thành tích hôm nay (đồng)',
    performanceToday:'1303 Hôm nay',
    performanceTodayTarget:'1304 Mục tiêu thử thách hôm nay',
    performanceTodayAchieve:'1305 Hoàn thành thực tế',
    performanceMonthDiff:'1306 Chênh lệch thành tích tháng nay (đồng)',
    performanceMonth:'1307 Tháng nay',
    performanceMonthTarget:'1308 Mục tiêu thử thách tháng nay',
    performanceMonthAchieve:'1309 Hoàn thành thực tế',
    salesStaffTitle:'1310 Nhân viên bán hàng',
    salesStaffSerialNumber:'1311 STT',
    salesStaffName:'1312 Tên nhân viên bán hàng',
    salesStaffPerformance:'1313 Thành tích nhân viên bán hàng (đồng)',
    scanCodeTitle:'1314 Quét mã chấm công',
    scanCodeCurrentDate:'1315 Ngày hiện tại:',
    scanCodeCurrentTime:'1316 Thời gian hiện tại:',
    scanCodeScanToCheckIn:'1317 Quét mã này để chấm công, mã QR间隔',
    secondRefs:'1318 giây làm mới',
    scanCodeLoading:'1319 Đang tải...',
    weekMonday:'1320 Thứ Hai',
    weekTuesday:'1321 Thứ Ba',
    weekWednesday:'1322 Thứ Tư',
    weekThursday:'1323 Thứ Năm',
    weekFriday:'1324 Thứ Sáu',
    weekSaturday:'1325 Thứ Bảy',
    weekSunday:'1326 Chủ Nhật',
    messageLoadTimeout:'1327 Thời gian tải quá lâu, vui lòng đóng cửa sổ quét mã chấm công và mở lại',
    messageConfirm:'1328 Xác nhận',
    messagePrompt:'1329 Thông báo',
    confirmCloseApp:'1330 Hành động này sẽ đóng ứng dụng. Bạn có chắc chắn muốn đóng không?',
    messageConfirm2:'1331 Xác nhận',
    confirmCancel:'1332 Hủy',
    newsDetailTitle:'1333 Thông báo tin nhắn',
    updateCheckUpdate:'1334 (Liên quan đến kiểm tra cập nhật, không có nội dung tiếng Trung rõ ràng)',
    updateNewVersion:'1335 (Liên quan đến cập nhật phiên bản, không có nội dung tiếng Trung rõ ràng)',
    searchPlaceholder:'3391 Hãy nhập tên tìm kiếm chức năng',
    searchGoods:'3529 Tìm kiếm',
    searchPlaceholder2:'3530 Nhập tiêu đề/tiêu đề phụ/từ khóa/bộ phận'
  },
  //公共组件
  components:{
    updateModuleCurrentBaseVersion:'1641 Phiên bản Base hiện tại: V',
    updateModuleUpgradeToLatestVersion:'1642 Nâng cấp lên phiên bản Base mới nhất:',
    updateModuleReleaseTime:'1643 Thời gian phát hành:',
    updateModuleDownloadNow:'1644 Tải xuống ngay',
    updateModuleDownloadLater:'1645 Tạm thời không tải',
    updateModuleOpenFolder:'1646 Mở thư mục',
    updateModuleDownloadCompleteMsg:'1647 Phiên bản mới đã tải xuống xong, nhấp vào nút "Mở thư mục" để cài đặt phiên bản mới',
    settingCenter:'1648 Trung tâm cài đặt',
    versionInfo:'1649 Thông tin phiên bản',
    voiceCall:'1650 Thoại thoại',
    logFeedback:'1651 Phản hồi nhật ký',
    baseVersion:'1652 Phiên bản Base',
    appVersion:'1653 Phiên bản ứng dụng',
    checkUpdate:'1654 Kiểm tra cập nhật',
    connectionStatus:'1655 Trạng thái kết nối',
    normal:'1656 Bình thường',
    disconnected:'1657 Chưa kết nối',
    reconnect:'1658 Kết nối lại',
    microphoneDevice:'1659 Thiết bị micrô',
    openLogDir:'1660 Mở thư mục chứa nhật ký',
    noUpdate:'1661 Tạm thời chưa có cập nhật',
    scanPayTitle:'1662 Thu tiền quét mã',
    scanPayStepWaiting:'1663 Đang chờ tiền vào tài khoản',
    scanPayStepSuccess:'1664 Nhận tiền thành công',
    scanPayStepCanceled:'1665 Đã hủy',
    scanPayStepDescriptionPrefix:'1666 thứ',
    scanPayStepDescriptionSuffix:'1667 Thu bút: ¥',
    scanPayTipScanCode:'1668 Vui lòng quét mã thanh toán của khách hàng',
    scanPayBtnConfirm:'1669 Xác nhận',
    scanPayPaymentFailed:'1670 Thanh toán thất bại, vui lòng đóng hoặc tiếp tục thanh toán',
    scanPayBtnCancelPayment:'1671 Hủy thanh toán',
    scanPayPaymentWaiting:'1672 Gửi thành công, vui lòng chờ số tiền vào tài khoản',
    scanPayPaymentReminder:'1673 Vui lòng nhắc khách hàng nhập mật khẩu thanh toán, nếu không có thể thanh toán thất bại!!! Vui lòng chú ý theo dõi kết quả thanh toán.',
    scanPayConfirmCloseAgain:'1674 Lần thanh toán này chưa thành công, xác nhận đóng?',
    scanPayConfirmCloseNormal:'1675 Sau khi đóng, có thể xem trong lịch sử bán hàng và khởi tạo thanh toán lại',
    scanPayConfirmTitle:'1676 Thông báo',
    returnRequestDrawerTitle:'1677 Đơn xin trả hàng',
    returnRequestApplyInfoTitle:'1678 Thông tin đơn đăng ký',
    returnRequestFormSubmitUser:'1679 Người gửi',
    returnRequestFormPlaceholderSelect:'1680 Vui lòng chọn',
    returnRequestFormSubmitTime:'1681 Thời gian gửi',
    returnRequestFormShop:'1682 Cửa hàng',
    returnRequestFormSalesOrderNo:'1683 Số đơn bán hàng',
    returnRequestFormUseMemberContact:'1684 Thông tin liên hệ có dùng thông tin thành viên không?',
    returnRequestFormYes:'1685 Có',
    returnRequestFormNo:'1686 Không',
    returnRequestFormContactName:'1687 Tên người liên hệ',
    returnRequestFormPlaceholderContactName:'1688 Vui lòng nhập tên khách hàng',
    returnRequestFormPhone:'1689 Số điện thoại',
    returnRequestFormPlaceholderPhone:'1690 Vui lòng nhập số điện thoại',
    returnRequestFormRemark:'1691 Ghi chú',
    returnRequestFormPlaceholderRemark:'1692 Vui lòng nhập ghi chú',
    returnRequestGoodsInfoTitle:'1693 Thông tin hàng hóa',
    returnRequestButtonsCancel:'1694 Hủy',
    returnRequestButtonsConfirm:'1695 Xác nhận',
    returnRequestMessagesErrorSelectSubmitUser:'1696 Vui lòng chọn người nộp đơn',
    returnRequestMessagesErrorEnterPhone:'1697 Vui lòng nhập số điện thoại liên hệ',
    returnRequestMessagesErrorEnterContactName:'1698 Vui lòng nhập tên người liên hệ',
    returnRequestMessagesSuccessApply:'1699 Đăng ký thành công',
    returnRequestTableProductInfo:'1700 Thông tin sản phẩm',
    returnRequestTableColorSize:'1701 Màu sắc / Kích cỡ',
    returnRequestTableTagPrice:'1702 Giá thẻ',
    returnRequestTablePurchasePrice:'1703 Giá mua (Đơn giá)',
    returnRequestTableReturnPrice:'1704 Giá trả lại',
    returnRequestTableSalesQuantity:'1705 Số lượng bán',
    returnRequestTableReturnReason:'1706 Lý do trả hàng',
    returnRequestTableReturnQuantity:'1707 Số lượng trả lại',
    returnRequestTablePromotion:'1708 Khuyến mãi',
    returnRequestTableNoImage:'Không có hình ảnh',
    returnRequestTableItemNo:'1710 Mã hàng:',
    returnRequestTableBarcode:'1711 Mã vạch:',
    settlementTitle:'Thanh toán',
    settlementSalesman:'1713 Nhân viên bán hàng:',
    settlementMember:'1714 Thành viên:',
    settlementGoodsTotalPrice:'1715 Tổng giá hàng hóa',
    settlementPromotionDiscount:'1716 Ưu đãi khuyến mãi',
    settlementReduce:'Giảm',
    settlementCouponWriteOff:'1718 Xác nhận sử dụng coupon',
    settlementFinalTotalPrice:'1719 Tổng giá cuối cùng',
    settlementParticipatedPromotions:'1720 Chương trình khuyến mãi đã tham gia',
    settlementCollapse:'1721 Thu gọn',
    settlementExpand:'1722 Mở rộng',
    settlementPiece:'{count} Cái',
    settlementGift:'1724 Quà tặng',
    settlementAdditionalPurchase:'Mua thêm',
    settlementPromotion:'Khuyến mãi',
    settlementTotal:'1727 chung',
    settlementItem:'chung {count} khoản',
    settlementOriginalPrice:'1729 Giá gốc',
    settlementDiscount:'1730 Ưu đãi',
    settlementAfterDiscount:'1731 Sau ưu đãi',
    settlementUsedCoupons:'1732 Xác nhận coupon đã sử dụng',
    settlementTagPrice:'1733 Giá thẻ',
    settlementOriginal:'1734 Giá gốc',
    settlementTagDiscount:'1735 Ưu đãi giá thẻ',
    settlementNeedMakeUp:'1736 Cần bù chênh lệch',
    settlementNoRefund:'1737 Không hoàn lại chênh lệch',
    settlementNoPaymentMethod:'1738 Cửa hàng hiện tại chưa liên kết phương thức thanh toán',
    settlementOrderAmount:'1739 Giá trị đơn này',
    settlementAlreadyPaid:'1740 Đã thanh toán',
    settlementNeedToReceive:'1741 Cần thu thêm',
    settlementAmountReceived:'1742 Số tiền thực thu',
    settlementConfirmCollection:'1743 Xác nhận thu tiền',
    settlementChangeTool:'1744 Công cụ tính tiền thừa',
    settlementReceivedAmount:'1745 Số tiền thực thu',
    settlementChangeAmount:'1746 Số tiền thối lại',
    settlementScanCouponCode:'1747 Vui lòng quét mã coupon của khách hàng, hỗ trợ nhập thủ công',
    settlementSwitchToEnglish:'1748 Khi quét mã vui lòng chuyển bàn phím sang chế độ tiếng Anh',
    settlementTiktokVerificationNote:'1749 Việc quét mã này chỉ để kiểm tra mã coupon của khách có hiệu lực không! Để xác nhận dùng coupon, vui lòng sử dụng ứng dụng Douyin LaiKe để hoàn tất xác nhận sử dụng thực tế.',
    settlementSource:'1750 Nguồn:',
    settlementDouyin:'1751 tiktop',
    settlementDelete:'1752 Xóa',
    settlementValidityPeriod:'1753 Hiệu lực đến:',
    settlementSplitDetails:'1754 Chi tiết tách đơn',
    settlementPaymentCount:'1755 Số lần thu tiền',
    settlementPaymentAmount:'1756 Số tiền thanh toán',
    settlementOperation:'1757 Thao tác',
    settlementTime:'1758 Lần thu tiền',
    settlementAvailableSplitAmount:'1759 Số tiền có thể tách:',
    settlementAdd:'1760 Thêm mới',
    settlementSelected:'1761 Đã chọn',
    settlementSplit:'1762 Tách',
    settlementAvailableBalance:'1763 Số dư khả dụng:',
    settlementEnterCorrectAmount:'1764 Vui lòng nhập số tiền chính xác',
    settlementInsufficientBalance:'1765 Số dư không đủ, số dư thành viên hiện tại chỉ có đồng',
    settlementFillAmountFirst:'1767 Vui lòng nhập số tiền trước',
    settlementEnterValidAmount:'1768 Vui lòng nhập một số tiền hợp lệ lớn hơn 0',
    settlementChoosePaymentMethod:'1769 Vui lòng chọn ít nhất một phương thức thu tiền',
    settlementCheckAmount:'1770 Vui lòng kiểm tra số tiền có chính xác không',
    settlementCheckNegativeAmount:'1771 Vui lòng kiểm tra số tiền có chính xác không, vui lòng bỏ chọn các phương thức thu tiền có số tiền nhỏ hơn 0 đồng',
    settlementScanTiktokCoupon:'1772 Vui lòng quét mã coupon của khách hàng để thêm coupon',
    settlementCheckOrderStatus:'1773 Vui lòng vào Lịch sử bán hàng để kiểm tra trạng thái đơn hàng, nếu không có đơn hàng này vui lòng in đơn lại.',
    settlementPrompt:'1774 Thông báo',
    paymentSuccessful:'1775 Thanh toán thành công!',
    settlementStepDescriptionPrefix:'1776 thứ',
    orderCardDefectiveSalesOrder:'1777 Phiếu bán hàng hàng lỗi',
    orderCardApproval:'1778 Phê duyệt',
    orderCardReviewStateWithdrawn:'1779 Đã rút lại',
    orderCardReviewStateApproved:'1780 Đã thông qua',
    orderCardReviewStateRejected:'1781 Đã từ chối',
    orderCardReviewStatePending:'1782 Chờ phê duyệt',
    orderCardSalesOrderNo:'1783 Số đơn bán hàng:',
    orderCardDocumentSource:'1784 Nguồn đơn:',
    orderCardSourceMobile:'1785 Điện thoại',
    orderCardSourceClient:'1786 Máy tính khách',
    orderCardOrderNature:'1787 Loại đơn hàng:',
    orderCardOriginalSalesOrder:'1788 Đơn bán hàng gốc:',
    orderCardPerformanceMethod:'1789 Phương thức doanh số:',
    orderCardBrokeragePersonal:'1790 Doanh số cá nhân',
    orderCardBrokerageTeam:'1791 Doanh số nhóm',
    orderCardBrokerageDistribution:'1792 Phân phối',
    orderCardTotalPieces:'1793 Tổng số lượng:',
    orderCardCreateTime:'1794 Thời gian tạo:',
    orderCardTeamMembers:'1795 Nhân viên nhóm',
    orderCardSalesman:'1796 Nhân viên bán hàng',
    orderCardAfterSalesCount:'1797 Số lần phát sinh hậu mãi:',
    orderCardReviewCount:'1798 Số lần phát sinh phê duyệt:',
    orderCardReceivableAmount:'1799 Số tiền phải thu:',
    orderCardActualReceivedAmount:'1800 Số tiền thực thu:',
    orderCardCopySuccess:'1801 Sao chép thành công!',
    maskLayerPageLocked:'1802 Trang hiện tại đã bị khóa',
    maskLayerUnlockTip:'1803 Nhập mật khẩu chính xác để mở khóa',
    maskLayerEnterPassword:'1804 Vui lòng nhập mật khẩu',
    maskLayerConfirm:'1805 Xác nhận',
    maskLayerClickToUnlock:'1806 Nhấn để mở khóa',
    maskLayerEnterUnlockPwd:'1807 Vui lòng nhập mật khẩu mở khóa',
    maskLayerCorrectUnlockPwd:'1808 Vui lòng nhập mật khẩu mở khóa chính xác',
    newsDetailTitleSuffix:'1809 -- Chi tiết',
    commonConfirmFirst:'1810 Xác nhận',
    flowStepsTitle:'1811 Quy trình phê duyệt',
    flowStepsStepTypeApprove:'1812 Phê duyệt',
    flowStepsStepTypeExecuteOnly:'1813 Chỉ thực thi',
    flowStepsStepTypeCcOnly:'1814 Chỉ CC',
    flowStepsReviewTypeOrSign:'1815 Hoặc ký',
    flowStepsReviewTypeAllSign:'1816 Ký tất cả',
    flowStepsReviewUsersCount:'1817 người phê duyệt',
    flowApprovalProcess:'1818 Quy trình phê duyệt',
    flowStateUnreviewed:'1819 Chưa duyệt',
    flowStateApproved:'1820 Đã duyệt',
    flowStateRejected:'1821 Từ chối duyệt',
    flowReviewTypeAllSign:'1822 Ký tất cả',
    flowReviewTypeOrSign:'1823 Hoặc ký',
    flowUserStateWithdrawn:'1824 Đã rút lại',
    flowUserStateUntreated:'1825 Chưa xử lý',
    flowUserStateAgreed:'1826 Đã đồng ý',
    flowUserStateRejected:'1827 Đã từ chối',
    flowUserStateExecuted:'1828 Đã thực thi',
    dragErrorMissingName:'1829 Thiếu tên liên kết cấu hình `name`',
    dragErrorMissingProp:'1830 Thiếu thuộc tính liên kết cấu hình `name`',
    dialogOrderNote:'1831 Ghi chú toàn đơn:',
    dialogShowPendingAndPaid:'1832 Chỉ hiển thị đơn hàng chờ thanh toán và đã thanh toán trong vòng phút',
    dialogWithinMinutes:'1833 Đơn hàng trong phút',
    checkAudioDialogTitle:'1834 Thông báo',
    checkAudioDialogNoMicPermissionMsg:'1835 Hệ thống phát hiện quyền micrô chưa được bật, vui lòng vào cài đặt hệ thống để bật micrô!',
    checkAudioDialogViewWin10Guide:'1836 Xem cách bật trên hệ thống Win10?',
    checkAudioDialogViewWin11Guide:'1837 Xem cách bật trên hệ thống Win11?',
    checkAudioDialogContactItHint:'1838 Không biết cách kiểm tra? Vui lòng liên hệ chuyên viên IT',
    checkAudioDialogRefreshAfterSetup:'1839 Tôi đã cài đặt, làm mới hệ thống',
    checkAudioDialogHowToEnableTitle:'1840 Làm thế nào để bật micrô',
    commonConfirmSecond:'1841 Xác nhận',
    consumingTime:'1842 Thời gian thực hiện:',
    statusIssued:'1843 Đã ban hành',
    statusShipped:'1844 Đã xuất hàng',
    statusLogisticsToStore:'1845 Logistics đến cửa hàng',
    statusLogisticsToWarehouse:'1846 Logistics đến kho',
    statusStored:'1847 Đã nhập kho',
    selectUserPlaceholder:'1848 Vui lòng chọn người dùng',
    selectAreaPlaceholder:'1849 Vui lòng chọn khu vực',
    buttonReset:'1850 Đặt lại',
    buttonQuery:'1851 Truy vấn',
    // buttonAddStoreInfo:'1852 Thêm mới thông tin cửa hàng',
    // buttonAddAccountInfo:'1853 Thêm mới thông tin tài khoản',
    // buttonAddSalesPromotion:'1854 Thêm mới khuyến mãi',
    filterCollapse:'1855 Thu gọn',
    filterExpand:'1856 Mở rộng',
    buttonAddStoreInfo:'1857 Thêm mới thông tin cửa hàng',
    buttonAddAccountInfo:'1858 Thêm mới thông tin tài khoản',
    buttonAddSalesPromotion:'1859 Thêm mới khuyến mãi',
    supplierNameLabel:'1860 Tên nhà cung cấp:',
    supplierCodeLabel:'1861 Mã số:',
    supplierFullNameLabel:'1862 Tên đầy đủ nhà cung cấp:',
    supplierDefaultType:'1863 Vật tư đồng phục',
    supplierType1:'1864 Gia công',
    supplierType2:'1865 Thành phẩm',
    supplierType3:'1866 Vải',
    supplierType4:'1867 Phụ liệu',
    supplierType5:'1868 Thẻ bài',
    supplierType6:'1869 Vật tư hành chính',
    supplierType7:'1870 Vật tư quảng cáo',
    entrepotNameLabel:'1871 Tên:',
    entrepotCodeLabel:'1872 Mã số:',
    entrepotAddressLabel:'1873 Địa chỉ:',
    searchFormFilter:'1874 Lọc',
    searchFormCollapse:'1875 Nhấn để thu gọn',
    searchFormStartTime:'1876 Thời gian bắt đầu',
    searchFormEndTime:'1877 Thời gian kết thúc',
    searchFormConfirm:'1878 Xác nhận',
    searchFormReset:'1879 Đặt lại',
    searchFormPleaseSelect:'1880 Vui lòng chọn',
    searchFormPleaseInput:'1881 Vui lòng nhập',
    searchFormTo:'1882 đến',
    invoiceFormInvoiceNo:'1883 Số chứng từ:',
    printCopies:'1884 Số bản in:',
    printContent:'1885 <i>*</i>Nội dung in:',
    printTotalOrder:'1886 Tổng đơn',
    printPackageWaybillOneByOne:'1887 In lần lượt nhãn gói hàng',
    printPackageOuterBillOneByOne:'1888 In lần lượt đơn thùng ngoài',
    printPrinter:'1889 <i>*</i>Máy in:',
    commonSelectPrinter:'1890 Vui lòng chọn máy in',
    commonCancel:'1891 Hủy',
    printConfirmPrint:'1892 Xác nhận in',
    printPrinting:'1893 Máy in đang in',
    printSetting:'1894 Cài đặt in',
    printErrorNoPackage:'1895 Hiện tại trong chứng từ không có gói hàng, vui lòng nhặt hàng và đóng gói để tạo gói hàng trước khi in.',
    printDialogPackageNo:'1896 Mã gói hàng:',
    printDialogPrintCopies:'1897 Số bản in:',
    printDialogPrintContent:'1898 Nội dung in:',
    printDialogPackageDetail:'1899 Đơn chi tiết gói hàng',
    printDialogPackageOuter:'1900 Đơn thùng ngoài gói hàng',
    printDialogPrinter:'1901 Máy in:',
    printDialogSelectPrinter:'1902 Vui lòng chọn máy in',
    cancel:'1903 Hủy',
    printDialogConfirmPrint:'1904 Xác nhận in',
    printDialogPrinting:'1905 Máy in đang in',
    printDialogPrintSetting:'1906 Cài đặt in',
    supplierName:'1907 Tên nhà cung cấp:',
    supplierCode:'1908 Mã số:',
    supplierFullName:'1909 Tên đầy đủ nhà cung cấp:',
    supplierTypeProcessing:'1910 Gia công',
    supplierTypeFinishedProduct:'1911 Thành phẩm',
    supplierTypeFabric:'1912 Vải',
    supplierTypeAccessory:'1913 Phụ liệu',
    supplierTypeHangtag:'1914 Thẻ bài',
    supplierTypeAdministrativeMaterial:'1915 Vật tư hành chính',
    supplierTypeAdvertisingMaterial:'1916 Vật tư quảng cáo',
    supplierTypeWorkwearMaterial:'1917 Vật tư đồng phục',
    optionEntrepotName:'1918 Tên:',
    optionEntrepotCode:'1919 Mã số:',
    optionEntrepotAddress:'1920 Địa chỉ:',
    messageDialogBatchResultTitle:'1921 Kết quả thao tác hàng loạt',
    messageDialogBatch:'1922 Hàng loạt',
    messageDialogOperationResult:'1923 Kết quả thao tác',
    messageDialogSuccess:'1924 Thành công',
    messageDialogFailure:'1925 Thất bại',
    messageDialogTotal:'1926 Tổng cộng',
    messageDialogOrderNumber:'1927 Số đơn',
    messageDialogResult:'1928 Kết quả',
    messageDialogReason:'1929 Lý do',
    messageDialogRemark:'1930 Ghi chú',
    storeDialogTitle:'1931 Chọn cửa hàng',
    storeDialogFilterCondition:'1932 Điều kiện lọc',
    storeDialogFormMarketingName:'1933 Tên cửa hàng',
    storeDialogFormMarketingNamePlaceholder:'1934 Vui lòng nhập tên cửa hàng, nhiều tên cách nhau bằng dấu cách',
    storeDialogFormCode:'1935 Mã cửa hàng',
    storeDialogFormCodePlaceholder:'1936 Vui lòng nhập mã số, nhiều mã cách nhau bằng dấu cách',
    storeDialogFormOperatingState:'1937 Tình trạng kinh doanh',
    storeDialogOperatingStateNormal:'1938 Kinh doanh bình thường',
    storeDialogOperatingStateTemporary:'1939 Kinh doanh tạm thời',
    storeDialogOperatingStateClosed:'1940 Đóng cửa ngừng kinh doanh',
    storeDialogOperatingStateNotOpened:'1941 Chưa khai trương',
    storeDialogButtonsReset:'1942 Đặt lại',
    storeDialogButtonsSearch:'1943 Truy vấn',
    storeDialogUnselectedStore:'1944 Chưa chọn cửa hàng',
    storeDialogTotalFormat:'1945 Tổng {count}',
    storeDialogTableCode:'1946 Mã số',
    storeDialogTableName:'1947 Tên cửa hàng',
    storeDialogModeMultiple:'1948 Chế độ chọn nhiều',
    storeDialogModeSingle:'1949 Chế độ chọn một',
    storeDialogButtonsSelectAll:'1950 Chọn tất cả',
    storeDialogButtonsMoveRight:'1951 Chuyển sang phải',
    storeDialogButtonsMoveLeft:'1952 Chuyển sang trái',
    storeDialogButtonsDeselectAll:'1953 Chọn tất cả',
    storeDialogSelectedStore:'1954 Cửa hàng đã thêm',
    storeDialogButtonsCancel:'1955 Hủy',
    storeDialogButtonsConfirm:'1956 Xác nhận',
    storeDialogErrorsSingleSelectLimit:'1957 Chế độ chọn một, chỉ có thể chọn một dữ liệu',
    storeDialogErrorsSelectFirst:'1958 Vui lòng chọn dữ liệu trước',
    goodsNoDialogTitle:'1959 Chọn mã hàng',
    goodsNoDialogFilterCondition:'1960 Điều kiện lọc',
    goodsNoDialogFormGoodsName:'1961 Tên hàng hóa',
    goodsNoDialogFormPlaceholderGoodsName:'1962 Vui lòng nhập tên hàng hóa, nhiều tên cách nhau bằng dấu cách',
    goodsNoDialogFormGoodsNo:'1963 Mã hàng',
    goodsNoDialogFormPlaceholderGoodsNo:'1964 Vui lòng nhập mã hàng, nhiều mã cách nhau bằng dấu cách',
    goodsNoDialogFormYear:'1965 Năm',
    goodsNoDialogFormQuarter:'1966 Mùa',
    goodsNoDialogFormStyleCategory:'1967 Phân loại kiểu dáng',
    goodsNoDialogFormStyleType:'1968 Phân loại phong cách',
    goodsNoDialogButtonsReset:'1969 Đặt lại',
    goodsNoDialogButtonsSearch:'1970 Truy vấn',
    goodsNoDialogUnselectedTitle:'1971 Chưa chọn mã hàng',
    goodsNoDialogUnselectedTotal:'1972 Tổng {count}',
    goodsNoDialogTableColumnsGoodsNo:'1973 Mã hàng',
    goodsNoDialogTableColumnsGoodsName:'1974 Tên hàng hóa',
    goodsNoDialogButtonsSelectAllRight:'1975 Chọn tất cả',
    goodsNoDialogButtonsMoveRight:'1976 Chuyển sang phải',
    goodsNoDialogButtonsMoveLeft:'1977 Chuyển sang trái',
    goodsNoDialogButtonsSelectAllLeft:'1978 Chọn tất cả',
    goodsNoDialogSelectedTitle:'1979 Mã hàng đã thêm',
    goodsNoDialogSelectedTotal:'1980 Tổng {count}',
    goodsNoDialogFooterCancel:'1981 Hủy',
    goodsNoDialogFooterConfirm:'1982 Xác nhận',
    goodsNoDialogErrorsSingleSelectLimit:'1983 Chế độ chọn một, chỉ có thể chọn một dữ liệu',
    goodsNoDialogErrorsSelectFirst:'1984 Vui lòng chọn dữ liệu trước',
    warehouseDialogTitle:'1985 Chọn kho',
    warehouseDialogFilterCondition:'1986 Điều kiện lọc',
    warehouseDialogFormWarehouseName:'1987 Tên kho',
    warehouseDialogFormPlaceholderWarehouseName:'1988 Vui lòng nhập tên kho, nhiều tên cách nhau bằng dấu cách',
    warehouseDialogFormWarehouseCode:'1989 Mã kho',
    warehouseDialogFormPlaceholderWarehouseCode:'1990 Vui lòng nhập mã kho, nhiều mã cách nhau bằng dấu cách',
    warehouseDialogFormType:'1991 Loại',
    warehouseDialogFormState:'1992 Trạng thái',
    warehouseDialogFormEnableStatus:'1993 Tình trạng kích hoạt',
    warehouseDialogButtonsReset:'1994 Đặt lại',
    warehouseDialogButtonsSearch:'1995 Truy vấn',
    warehouseDialogUnselectedWarehouse:'1996 Chưa chọn kho',
    warehouseDialogTotalPrefix:'1997 Tổng {count}',
    warehouseDialogTableColumnsCode:'1998 Mã số',
    warehouseDialogTableColumnsName:'1999 Tên',
    warehouseDialogTableColumnsStatus:'2000 Trạng thái',
    warehouseDialogStatusEnabled:'2001 Kích hoạt',
    warehouseDialogStatusDisabled:'2002 Vô hiệu hóa',
    warehouseDialogModeMultiple:'2003 Chế độ chọn nhiều',
    warehouseDialogModeSingle:'2004 Chế độ chọn một',
    warehouseDialogButtonsCheckAll:'2005 Chọn tất cả',
    warehouseDialogButtonsShiftRight:'2006 Chuyển sang phải',
    warehouseDialogButtonsShiftLeft:'2007 Chuyển sang trái',
    warehouseDialogButtonsRemoveAll:'2008 Làm trống',
    warehouseDialogSelectedWarehouse:'2009 Kho đã thêm',
    warehouseDialogButtonsCancel:'2010 Hủy',
    warehouseDialogButtonsConfirm:'2011 Xác nhận',
    warehouseDialogMessagesSingleSelectLimit:'2012 Chế độ chọn một, chỉ có thể chọn một dữ liệu',
    warehouseDialogMessagesSelectFirst:'2013 Vui lòng chọn dữ liệu trước',
    warehouseDialogTypeListPhysical:'2014 Kho thực',
    warehouseDialogTypeListWorkwear:'2015 Kho đồng phục',
    warehouseDialogTypeListAdministrative:'2016 Kho vật tư hành chính',
    warehouseDialogTypeListCloud:'2017 Kho đám mây',
    warehouseDialogTypeListVirtual:'2018 Kho ảo',
    warehouseDialogStateListAll:'2019 Tất cả',
    warehouseDialogStateListNormal:'2020 Bình thường',
    warehouseDialogStateListDeleted:'2021 Xóa',
    warehouseDialogEnableListYes:'2022 Có',
    warehouseDialogEnableListNo:'2023 Không',
    basicSelectorNoData:'2024 Không có tùy chọn phù hợp',
    basicSelectorLoading:'2025 Đang tải...',
    basicSelectorNoMore:'2026 Không còn nữa',
    stockTopMenuCashierLabel:'2027 Quầy thu ngân:',
    stockTopMenuLockWithF2:'2028 Khóa (F2)',
    stockTopMenuRefreshPage:'2029 Làm mới trang',
    stockTopMenuMinimize:'2030 Thu nhỏ',
    stockTopMenuClose:'2031 Đóng',
    stockTopMenuPrompt:'2032 Thông báo',
    stockTopMenuCloseWindowConfirm:'2033 Thao tác này sẽ đóng cửa sổ hiện tại, xác nhận đóng?',
    stockTopMenuConfirm:'2034 Xác nhận',
    stockTopMenuCancel:'2035 Hủy',
    stockTopMenuUserCancelLog:'2036 Người dùng nhấn hủy',
    stockTopMenuTranslante:'3390 Dịch thuật',
    zDialogRefresh: '3393 Làm mới',
    zDialogMinimize: '3394 Thu nhỏ',
    zDialogMaximize: '3395 Phóng to',
    zDialogClose: '3396 Đóng',
    zDialogTips: '3397 Nhắc nhở',
    zDialogConfirm: '3398 Xác nhận',
    zDialogCancel: '3399 Hủy',
    zDialogConfirmCloseMessage: '3400 Xác nhận đóng?',
    zDialogConfirmExitMessage: '3401 Nội dung lần gửi này sẽ không được lưu, có thoát không?',
    sizeGroupTableSizeGroup: '3409 Nhóm kích cỡ',
    sizeGroupTableSelectDate: '3410 Chọn ngày',
    sizeGroupTableOperation: '3411 Thao tác',
    sizeGroupTableTotal: '3412 Tổng cộng',
    sizeGroupTableTotalAmount: '3413 Tổng số mẫu',
    sizeGroupTableUnitPiece: 'mẫu',
    sizeGroupTableTotalPieces: '3414 Tổng số lượng',
    sizeGroupTableUnitItem: 'chiếc',
    sizeGroupTableTotalPrice: '3415 Tổng giá',
    sizeGroupTableTransferTotalPieces: '3416 Tổng số lượng điều chuyển',
    sizeGroupTableReturnWarehouseTotalPieces: '3417 Tổng số lượng trả kho',
    sizeGroupTableDistributionTotalPieces: '3418 Tổng số lượng cung cấp',
    sizeGroupTablePurchaseTotalPrice: '3419 Tổng giá mua hàng',
    sizeGroupTableTagTotalPrice: '3420 Tổng giá nhãn',
    sizeGroupTableTransferTotalPrice: '3421 Tổng giá điều chuyển',
    sizeGroupTableReturnWarehouseTotalPrice: '3422 Tổng giá trả kho',
    sizeGroupTableDistributionTotalPrice: '3423 Tổng giá cung cấp',
    sizeGroupTableRetailTotalPrice: '3424 Tổng giá bán lẻ',
    sizeGroupTableReceived: '3425 Đã nhận',
    sizeGroupTableNotReceived: '3426 Chưa nhận',
    sizeGroupTableShipmentDifferenceTotal: '3427 Tổng chênh lệch xuất',
    sizeGroupTableStorageDifferenceTotal: '3428 Tổng chênh lệch nhập',
    sizeGroupTableOutboundDifferenceTotal: '3429 Tổng chênh lệch xuất kho',
    sizeGroupTableAdjustTotalPieces: '3430 Tổng số lượng điều chỉnh',
    sizeGroupTableTakenQuantity: '3431 Số đã nhận',
    sizeGroupTableNotTakenQuantity: '3432 Số chưa nhận',
    sizeGroupTableStorageQuantity: '3433 Số nhập kho',
    sizeGroupTableReturnSupplierQuantity: '3434 Số trả NCC',
    sizeGroupTableReturnSupplierAmount: '3435 Giá trị trả NCC',
    sizeGroupTablePicked: '3436 Đã nhặt',
    sizeGroupTableNotPicked: '3437 Chưa nhặt',
  },
  //时段目标
  timeTargetFollow:{
    curPosition:'2037 Theo dõi mục tiêu theo khung thời gian',
    elementLoadingText:'2038 Vui lòng chờ một chút, đang tải dữ liệu...',
    tipsAnalysisFocusTime:'2039 Phân tích các khung thời gian quan trọng của nghiệp tích hàng ngày',
    tipsFocusYesterdayGap:'2040 Chú ý đến khoảng cách so với cùng khung thời gian hôm qua',
    tipsStrengthenTargetFocus:'2041 Liên tục tăng cường sự chú ý đến mục tiêu của bản thân',
    tipRowDingTalkNotice:'2042 Mỗi ngày chụp màn hình định thời gửi đến DingTalk <Nhóm DingTalk của cửa hàng>, độ trễ không được quá 30 phút',
    dateRowLabel:'2043 Ngày',
    datePickerPlaceholder:'2044 Chọn ngày',
    buttonSave:'2045 Lưu',
    noDataText:'2046 Không tìm thấy dữ liệu nghiệp tích',
    messageCannotModifyExceptToday:'2047 Chỉ có thể chỉnh sửa nghiệp tích của ngày hiện tại',
    messageModifyBeforeSave:'2048 Vui lòng chỉnh sửa nghiệp tích trước khi lưu',
    messageOperationSuccess:'2049 Thao tác thành công',
  },
  //补打标签
  reLabel:{
    title:'2050 In lại nhãn',
    searchSpuCode:'2051 Mã sản phẩm / Mã tắt',
    searchPlaceholderSpu:'2052 Vui lòng nhập mã sản phẩm hoặc mã tắt',
    searchGoodsName:'2053 Tên sản phẩm',
    searchPlaceholderTitle:'2054 Vui lòng nhập tên sản phẩm',
    btnReset:'2055 Đặt lại',
    btnSearch:'2056 Tìm kiếm',
    tableSpu:'2057 Mã sản phẩm',
    tableGoodsCode:'2058 Mã tắt',
    tableTitle:'2059 Tên sản phẩm',
    tableColor:'2060 Màu sắc',
    previewGoodsImage:'2061 Hình ảnh sản phẩm',
    previewPrintPreview:'2062 Xem trước in',
    previewSelectSize:'2063 Vui lòng chọn size sản phẩm',
    btnPrintTag:'2064 In nhãn',
    confirmCloseTitle:'2065 Thông báo',
    confirmCloseMessage:'2066 Thao tác này sẽ đóng cửa sổ hiện tại, bạn có chắc chắn muốn đóng?',
    confirmConfirm:'2067 Xác nhận',
    confirmCancel:'2068 Hủy',
    errorSelectSize:'2069 Vui lòng chọn size cần in',
  },
  //会员相关
  vipModule:{
    promotionDetailTitle:'2070 Chi tiết khuyến mãi',
    promotionInfoTitle:'2071 Thông tin đơn khuyến mãi',
    promotionNameLabel:'2072 Tên khuyến mãi：',
    promotionTypeLabel:'2073 Loại khuyến mãi：',
    promotionNoLabel:'2074 Mã khuyến mãi：',
    promotionEffectiveTypeLabel:'2075 Loại hiệu lực：',
    promotionShortTerm:'2076 Ngắn hạn',
    promotionLongTerm:'2077 Dài hạn',
    promotionDeductAmountLabel:'2078 Số tiền giảm trừ：',
    promotionActualPayLabel:'2079 Số tiền thực thanh toán：',
    promotionTotalAmountLabel:'2080 Tổng số tiền：',
    promotionOrderTimeLabel:'2081 Thời gian đặt hàng：',
    promotionGoodsListTitle:'2082 Danh sách hàng hóa đơn khuyến mãi',
    promotionGoodsImageLabel:'2083 Hình ảnh hàng hóa',
    promotionNoImageText:'2084 Chưa có hình ảnh',
    promotionGoodsNameLabel:'2085 Tên hàng hóa',
    promotionBarCodeLabel:'2086 Mã vạch',
    promotionGoodsNoLabel:'2087 Mã hàng',
    promotionPriceLabel:'2088 Giá',
    promotionAttrLabel:'2089 Màu sắc / Kích cỡ',
    couponDetailTitle:'2090 Chi tiết phiếu giảm giá',
    couponInfoTitle:'2091 Thông tin phiếu giảm giá',
    couponTypeLabel:'2092 Loại phiếu giảm giá：',
    couponSourceLabel:'2093 Nguồn phiếu giảm giá：',
    couponDiscountAmountLabel:'2094 Số tiền ưu đãi：',
    couponNameLabel:'2095 Tên phiếu giảm giá：',
    couponVerifyTimeLabel:'2096 Thời gian xác nhận sử dụng：',
    couponOrderMinCountLabel:'2097 Số lượng tối thiểu toàn đơn：',
    couponTagPriceDenominationLabel:'2098 Mệnh giá giá treo thẻ：',
    couponDescriptionLabel:'2099 Ghi chú phiếu giảm giá：',
    couponGoodsTitle:'2100 Hàng hóa dùng phiếu giảm giá',
    couponGoodsNoLabel:'2101 Mã hàng',
    couponGoodsNameLabel:'2102 Tên hàng hóa',
    couponQuantityLabel:'2103 Số lượng',
    couponTagPriceLabel:'2104 Giá treo thẻ',
    couponSingleDiscountLabel:'2105 Khấu trừ ưu đãi trên mỗi sản phẩm',
    couponActualPriceLabel:'2106 Giá bán thực tế',
    couponColorSizeLabel:'2107 Màu sắc / Kích cỡ',
    couponGiftsTitle:'2108 Quà tặng',
    couponNoGoodsImageText:'2109 Mã hàng này chưa có hình ảnh',
    createVipDialogTitle:'2110 Tạo hội viên',
    createVipNickNameLabel:'2111 Biệt danh hội viên',
    createVipNickNamePlaceholder:'2112 Vui lòng nhập biệt danh hội viên',
    createVipNickNameRequired:'2113 Vui lòng điền tên hội viên',
    createVipRealNameLabel:'2114 Tên thật',
    createVipRealNamePlaceholder:'2115 Vui lòng nhập tên thật',
    createVipPhoneLabel:'2116 Số điện thoại',
    createVipPhonePlaceholder:'2117 Vui lòng nhập số điện thoại',
    createVipPhoneRequired:'2118 Vui lòng điền số điện thoại',
    createVipSexLabel:'2119 Giới tính',
    createVipSexMale:'2120 Nam',
    createVipSexFemale:'2121 Nữ',
    createVipSexRequired:'2122 Vui lòng chọn giới tính',
    createVipDeptIdLabel:'2123 Gắn với cửa hàng',
    createVipDeptIdPlaceholder:'2124 Vui lòng chọn giới tính',
    createVipAssistantUserIdLabel:'2125 Nhân viên tư vấn phát thẻ',
    createVipAssistantUserIdPlaceholder:'2126 Vui lòng chọn nhân viên tư vấn phát thẻ',
    createVipBirthdayLabel:'2127 Ngày tháng năm sinh',
    createVipBirthdayPlaceholder:'2128 Vui lòng chọn ngày tháng năm sinh',
    createVipBirthdayCalendarTypeLabel:'2129 Loại lịch sinh nhật',
    createVipBirthdayCalendarSolar:'2130 Dương lịch',
    createVipBirthdayCalendarLunar:'2131 Âm lịch',
    createVipIdNumLabel:'2132 Số CMND/CCCD',
    createVipIdNumPlaceholder:'2133 Vui lòng nhập số CMND/CCCD',
    createVipCoatSizeLabel:'2134 Kích cỡ áo',
    createVipCoatSizePlaceholder:'2135 Vui lòng nhập kích cỡ áo',
    createVipWaistlineLabel:'2136 Kích cỡ vòng eo',
    createVipWaistlinePlaceholder:'2137 Vui lòng nhập kích cỡ vòng eo',
    createVipHeightLabel:'2138 Chiều cao (cm)',
    createVipHeightPlaceholder:'2139 Vui lòng nhập chiều cao',
    createVipWeightLabel:'2140 Cân nặng (kg)',
    createVipWeightPlaceholder:'2141 Vui lòng nhập cân nặng',
    createVipShoeSizeLabel:'2142 Cỡ giày',
    createVipShoeSizePlaceholder:'2143 Vui lòng nhập cỡ giày',
    createVipCancelBtn:'2144 Hủy bỏ',
    createVipConfirmBtn:'2145 Xác nhận',
    createVipInvalidPhoneMsg:'2146 Vui lòng nhập SĐT',
    createVipCreateSuccessMsg:'2147 Tạo hội viên thành công',
    integralTitle:'2148 Đổi điểm',
    integralGiftNameGoodsNoLabel:'2149 Tên quà tặng / Mã hàng',
    integralSearchPlaceholder:'2150 Quét thẻ treo hoặc nhập mã hàng để tra cứu',
    integralQueryBtn:'2151 Tra cứu',
    integralSelectEnlargeTip:'2152 Chọn quà tích điểm, nhấn ảnh bên phải để phóng to xem.',
    integralSingleLimitTip:'2153 Mỗi lần chỉ được đổi tối đa {num} cái',
    integralCommonLabel:'Điểm',
    integralNotInExchangeTimeTip:'2155 Đầu cuối POS không trong thời gian đổi điểm',
    integralNoDataText:'2156 Chưa có dữ liệu',
    integralPleaseSelectText:'2157 Vui lòng chọn',
    integralMemberScanCodePlaceholder:'2158 Vui lòng quét mã hội viên',
    integralMemberPhoneOrCodePlaceholder:'2159 Nhập SĐT hoặc quét mã thành viên',
    integralMemberPhonePlaceholder:'2160 Vui lòng nhập số điện thoại',
    integralConfirmBtn:'2161 Xác nhận',
    integralMemberShowCodeTip:'2162 Trên WeChat Chính thức, mở [Trung tâm Thành viên] để hiện mã thành viên.',
    integralMemberNameLabel:'2163 Tên hội viên',
    integralMemberPhoneLabel:'2164 Số điện thoại',
    integralMemberBalanceLabel:'2165 Số dư',
    integralReselectBtn:'2166 Chọn lại',
    integralGoodsNameLabel:'2167 Tên hàng hóa：',
    integralSizeLabel:'2168 Kích cỡ：',
    integralColorLabel:'2169 Màu sắc：',
    integralExchangeQuantityLabel:'2170 Số lượng đổi：',
    integralStockLabel:'2171 Tồn kho：',
    integralSelectGiftFirstTip:'2172 Vui lòng chọn quà tặng tích điểm trước',
    integralTotalLabel:'2173 Tổng cộng：',
    integralRemainingAfterExchangeLabel:'2174 Còn lại sau đổi：',
    integralConfirmExchangeBtn:'2175 Xác nhận đổi',
    integralDialogTipTitle:'2176 Thông báo',
    integralMemberRestrictedMsg:'2177 Xin lỗi, tư cách hội viên tạm thời bị hạn chế, không thể sử dụng. Chúng tôi đề nghị bạn liên hệ IT để tìm hiểu cụ thể và giải quyết vấn đề.',
    integralOkBtn:'2178 Xác nhận',
    integralPleaseScanMemberError:'2179 Vui lòng quét mã hội viên trước',
    integralPleaseSelectGiftError:'2180 Vui lòng chọn quà tặng trước',
    integralSingleLimitError:'2181 Quà tặng hiện tại mỗi lần chỉ được đổi tối đa {num} cái',
    integralConfirmExchangeMsg:'2182 Xác nhận đổi quà tặng?',
    integralExchangeSuccessMsg:'2183 Đổi thành công',
    integralPositiveIntegerError:'2184 Vui lòng nhập số nguyên lớn hơn hoặc bằng 1',
    integralMinQuantityError:'2185 Số lượng tối thiểu là 1, không thể giảm thêm',
    integralExchangeDateTip:'2186 Ngày đổi quà tặng đã chọn hiện tại là {start} ~ {end}',
    integralPageSize100Label:'2187 100 dòng / trang',
    integralPageSize200Label:'2188 200 dòng / trang',
    integralPageSize300Label:'2189 300 dòng / trang',
    integralPageSize400Label:'2190 400 dòng / trang',
    integralPageSize500Label:'2191 500 dòng / trang',
    memberRechargeTitle:'2192 Nạp tiền vào số dư hội viên',
    chooseAssistantText:'2193 Chọn nhân viên bán hàng',
    salesmanLabel:'2194 Nhân viên bán hàng：',
    chooseMemberText:'2195 Vui lòng chọn hội viên',
    memberNameLabel:'2196 Tên hội viên：',
    phoneLabel:'2197 Số điện thoại：',
    memberCardNumberLabel:'2198 Số thẻ hội viên：',
    availableBalanceLabel:'2199 Số dư khả dụng',
    occupiedBalanceLabel:'2200 Số dư chiếm dụng',
    switchMemberBtn:'2201 Chuyển hội viên',
    noRechargeTemplateText:'2202 Cửa hàng chưa thiết lập mẫu nạp tiền',
    giveText:'2203 tặng',
    pointsLabel:'2204 điểm tích lũy',
    noPaymentMethodText:'2205 Cửa hàng chưa liên kết phương thức thanh toán',
    selectedLabel:'2206 Đã chọn',
    splitBtn:'2207 Tách',
    yuanUnit:'2208 VND',
    changeToolTitle:'2209 Công cụ tính tiền thừa',
    receivedAmountLabel:'2210 Số tiền thực thu',
    changeAmountLabel:'2211 Số tiền thừa',
    splitDetailsTitle:'2212 Chi tiết tách',
    paymentTimesLabel:'2213 Lần thu tiền',
    paymentAmountLabel:'2214 Số tiền thanh toán',
    operationLabel:'2215 Thao tác',
    paymentTimesPrefix:'2216 thứ',
    paymentTimesSuffix:'2217 thu tiền lần hai',
    deleteSplitBtn:'2218 Xóa',
    splitableAmountLabel:'2219 Số tiền có thể tách：',
    addSplitBtn:'2220 Thêm mới',
    totalCollectionLabel:'2221 Tổng thu：',
    confirmPaymentBtn:'2222 Xác nhận thu tiền',
    correctAmountError:'2223 Vui lòng điền số tiền chính xác',
    fillAmountFirstError:'2224 Vui lòng điền số tiền trước',
    validAmountError:'2225 Vui lòng nhập số tiền hợp lệ lớn hơn 0',
    chooseAssistantError:'2226 Vui lòng chọn nhân viên bán hàng',
    chooseMemberError:'2227 Vui lòng chọn hội viên cần nạp tiền',
    chooseTemplateError:'2228 Vui lòng chọn một mẫu nạp tiền',
    choosePaymentError:'2229 Vui lòng chọn ít nhất một phương thức thanh toán',
    checkAmountError:'2230 Vui lòng kiểm tra số tiền có chính xác không',
    cancelInvalidPaymentError:'2231 Hãy bỏ chọn các phương thức thanh toán có số tiền nhỏ hơn hoặc bằng 0 VND',
    changeToolCash:'2232 tiền mặt',
    orderDetailTitle:'2233 Chi tiết',
    orderDetailGoodsInfoTitle:'2234 Thông tin hàng hóa',
    orderDetailTotalItemsLabel:'2235 Tổng số lượng：',
    orderDetailUnitPieceLabel:'2236 chiếc',
    orderDetailOrderInfoTitle:'2237 Thông tin chứng từ',
    orderDetailTotalAmountLabel:'2238 Giá trị đơn hàng：',
    orderDetailRetailAmountLabel:'2239 Giá bán lẻ：',
    orderDetailReceivedAmountLabel:'2240 Số tiền đã thu：',
    orderDetailActivityAmountLabel:'2241 Giá trị khuyến mãi：',
    orderDetailChangeAmountLabel:'2242 Chênh lệch số tiền：',
    orderDetailSaleStatusLabel:'2243 Tình trạng bán hàng：',
    orderDetailStatusCanceled:'2244 Đã hủy',
    orderDetailStatusPendingPayment:'2245 Chờ thanh toán',
    orderDetailStatusPaying:'2246 Đang thanh toán',
    orderDetailStatusPaid:'2247 Đã thanh toán',
    orderDetailStatusPendingApproval:'2248 Chờ phê duyệt',
    orderDetailStatusInvalid:'2249 Đã vô hiệu',
    orderDetailStoreNameLabel:'2250 Tên cửa hàng：',
    orderDetailGiftInfoLabel:'2251 Thông tin quà tặng：',
    orderDetailSourceLabel:'2252 Nguồn chứng từ：',
    orderDetailSourceMobile:'2253 Điện thoại',
    orderDetailSourceClient:'2254 Máy khách',
    orderDetailOrderTypeLabel:'2255 Loại đơn hàng：',
    orderDetailSaleNoLabel:'2256 Số đơn bán hàng：',
    orderDetailOriginalSaleNoLabel:'2257 Số đơn bán hàng gốc：',
    orderDetailOuterNoLabel:'2258 Số đơn bên ngoài：',
    orderDetailPerformanceMethodLabel:'2259 Phương thức hiệu suất：',
    orderDetailPerformancePersonal:'2260 Thành tích cá nhân',
    orderDetailPerformanceTeam:'2261 Thành tích tổ nhóm',
    orderDetailPerformanceDistribution:'2262 Phân phối',
    orderDetailSalesmanLabel:'2263 Nhân viên bán hàng：',
    orderDetailCreateTimeLabel:'2264 Thời gian tạo：',
    orderDetailTeamMembersLabel:'2265 Thành viên tổ nhóm：',
    orderDetailCreateTerminalLabel:'2266 Quầy thu ngân tạo đơn：',
    orderDetailEndTerminalLabel:'2267 Quầy thu ngân kết thúc đơn：',
    orderDetailPromotionInfoTitle:'2268 Thông tin khuyến mãi',
    orderDetailPromotionNameLabel:'2269 Tên khuyến mãi',
    orderDetailPromotionTypeLabel:'2270 Loại khuyến mãi',
    orderDetailPromotionNoLabel:'2271 Mã khuyến mãi',
    orderDetailPromotionDiscountAmountLabel:'2272 Số tiền giảm trừ',
    orderDetailPromotionDetailLabel:'2273 Xem chi tiết đơn khuyến mãi',
    orderDetailViewDetailBtn:'2274 Xem chi tiết',
    orderDetailPaymentInfoTitle:'2275 Thông tin thu tiền',
    orderDetailPaymentMethodLabel:'2276 Phương thức thu tiền',
    orderDetailPaymentAmountLabel:'2277 Số tiền thu',
    orderDetailPaymentStatusLabel:'2278 Tình trạng thanh toán',
    orderDetailPaymentStatusCreated:'2279 Đã tạo',
    orderDetailPaymentStatusPaid:'2280 Đã thanh toán',
    orderDetailPaymentStatusCanceled:'2281 Đã hủy',
    orderDetailPaymentStatusPaying:'2282 Đang thanh toán',
    // orderDetailCreateTimeLabel:'2283 Thời gian tạo',
    orderDetailUpdateTimeLabel:'2284 Thời gian cập nhật',
    orderDetailPaymentVoucherNoLabel:'2285 Số chứng từ thanh toán',
    orderDetailPaymentSerialNoLabel:'2286 Số giao dịch',
    orderDetailCouponNameLabel:'2287 Tên phiếu giảm giá',
    orderDetailCouponTypeLabel:'2288 Loại phiếu giảm giá',
    orderDetailCouponSourceLabel:'2289 Nguồn phiếu giảm giá',
    orderDetailCouponAmountLabel:'2290 Số tiền phiếu giảm giá',
    orderDetailTableOperationLabel:'2291 Thao tác',
    scanPayTitle:'2292 Thu tiền bằng mã QR',
    scanPayWaitReceipt:'2293 Chờ tiền về tài khoản',
    scanPaySuccessReceipt:'2294 Nhận tiền thành công',
    scanPayCancelled:'2295 Đã hủy',
    scanPayPaymentItem:'2296 thứ',
    scanPayPaymentItem2:'2297 Thu bút: ¥',
    scanPayScanTip:'2298 Vui lòng quét mã thanh toán của khách hàng',
    scanPayConfirmBtn:'2299 Xác nhận',
    scanPayPayFailed:'2300 thứ',
    scanPayPayFailed2:'2301 Bút thanh toán thất bại, xin hãy tắt hoặc tiếp tục thanh toán',
    scanPayCancelPayBtn:'2302 Hủy thanh toán',
    scanPayWaitPayResult:'2303 thứ',
    scanPayWaitPayResult2:'2304 Bút ĐÃ GỬI, VUI LÒNG CHỜ SỐ TIỀN VỀ',
    scanPayPayAttentionTip:'2305 Lưu ý nhắc khách hàng nhập mật khẩu thanh toán, nếu không có thể thanh toán thất bại!!! Vui lòng chú ý kết quả thanh toán.',
    scanPayCloseTip:'2306 Sau khi đóng, có thể xem trong lịch sử nạp tiền hội viên và khởi tạo thanh toán lại',
    scanPayTipTitle:'2307 Thông báo',
    scanPayPayingWaitMsg:'2308 Đơn hàng hiện tại đang được thanh toán, vui lòng tiếp tục chờ',
    vipTitle:'2309 Hội viên',
    vipCreateBtn:'2310 Tạo hội viên',
    vipViewRechargeRecordBtn:'2311 Xem lịch sử nạp tiền hội viên của cửa hàng này',
    vipIntegralExchangeBtn:'2312 Đổi điểm',
    vipViewQrcodeBtn:'2313 Xem mã QR hội viên cửa hàng',
    vipSearchPlaceholder:'2314 Vui lòng nhập {title}',
    vipSearchPhoneLabel:'2315 Số điện thoại',
    vipSearchVipNameLabel:'2316 Tên hội viên',
    vipSearchCardNumberLabel:'2317 Số thẻ',
    vipSearchBtn:'2318 Tìm kiếm',
    vipSearchQuickLabel:'2319 Tìm kiếm nhanh：',
    vipSearchBirthdayThisMonthLabel:'2320 Người sinh nhật tháng này',
    vipInfoAvailableBalanceLabel:'2321 Số dư có sẵn',
    vipInfoOccupiedBalanceLabel:'2322 Tuyển dụng',
    vipInfoIntegralLabel:'2323 Điểm',
    vipRechargeBtn:'2324 Nạp tiền vào số dư',
    vipFormMemberInfoTitle:'2325 Thông tin hội viên',
    vipFormNicknameLabel:'2326 Biệt danh hội viên:',
    vipFormRealNameLabel:'2327 Tên thật:',
    vipFormPhoneLabel:'2328 Số điện thoại:',
    vipFormGenderLabel:'2329 Giới tính:',
    vipFormBoundStoreLabel:'2330 Cửa hàng liên kết:',
    vipFormGuideLabel:'2331 Nhân viên tư vấn phát thẻ:',
    vipFormBirthdayLabel:'2332 Sinh nhật:',
    vipFormIdCardLabel:'2333 Số CMND/CCCD:',
    vipFormIndustryLabel:'2334 Ngành nghề:',
    vipFormCoatSizeLabel:'2335 Kích cỡ áo:',
    vipFormTrousersSizeLabel:'2336 Kích cỡ quần:',
    vipFormShoeSizeLabel:'2337 Kích cỡ giày:',
    vipFormCardNoLabel:'2338 Số thẻ hội viên:',
    vipFormAveragePriceLabel:'2339 Giá trung bình mỗi sản phẩm:',
    vipFormAverageConsumptionLabel:'2340 Mức chi tiêu trung bình:',
    vipSaveMemberBtn:'2341 Lưu thông tin hội viên',
    vipNoDataText:'2342 Vui lòng chọn hội viên',
    vipRecordConsumptionLabel:'2343 Lịch sử tiêu dùng',
    vipRecordBalanceLabel:'2344 Chi tiết số dư',
    vipRecordIntegralLabel:'2345 Chi tiết điểm',
    vipRecordIntegralExchangeLabel:'2346 Lịch sử đổi điểm',
    vipFilterTypeLabel:'2347 Loại',
    vipFilterBillNoLabel:'2348 Số chứng từ',
    vipFilterGoodsNoLabel:'2349 Mã hàng',
    vipFilterMultiGoodsNoLabel:'2350 Nhiều mã hàng cách nhau bằng dấu cách',
    vipFilterExchangeTimeLabel:'2351 Thời gian đổi',
    vipFilterTimeRangeLabel:'2352 Phạm vi thời gian',
    vipFilterStartDateLabel:'2353 Ngày bắt đầu',
    vipFilterEndDateLabel:'2354 Ngày kết thúc',
    vipFilterResetBtn:'2355 Đặt lại',
    vipFilterConfirmBtn:'2356 Xác nhận',
    vipQrcodeTitle:'2357 Xem mã QR hội viên cửa hàng',
    vipQrcodeDownloadBtn:'2358 Tải hình ảnh',
    vipDialogTipTitle:'2359 Thông báo',
    vipDialogLimitTipMsg:'2360 Xin lỗi, tư cách hội viên tạm thời bị hạn chế, không thể sử dụng. Chúng tôi đề nghị bạn liên hệ IT để tìm hiểu cụ thể và giải quyết vấn đề.',
    vipDialogConfirmBtn:'2361 Xác nhận',
    vipGridBillNoLabel:'2362 Số chứng từ',
    vipGridTimeLabel:'2363 Thời gian',
    vipGridQuantityLabel:'2364 Số lượng',
    vipGridAmountLabel:'2365 Số tiền',
    vipGridBeforeTransactionLabel:'2366 Trước giao dịch',
    vipGridCurrentLabel:'2367 Lần này',
    vipGridAfterTransactionLabel:'2368 Sau giao dịch',
    vipGridGoodsNameLabel:'2369 Tên hàng hóa',
    vipPhoneLabel:'2370 Số điện thoại：',
    vipDialogNot:'2371 Không xác định',
    vipDialogChoose:'2372 Vui lòng chọn hội viên trước',
    vipDialogSave:'2373 Lưu thông tin thành công',
    vipDialogNotMag:'2374 Hàng hóa hiện tại chưa có ảnh xem trước',
    vipDialogNotNo:'2375 Tạm thời không thể xem đơn hàng cửa hàng khác',
    vipDialogBoy:'2376 Nam',
    vipDialogGirl:'2377 Nữ',
    vipRechargeDialogTitle:'2378 Lịch sử nạp tiền hội viên',
    vipRechargeNewVipLabel:'2379 Hội viên mới (người)',
    vipRechargeRechargeTimesLabel:'2380 Số lần nạp tiền (giao dịch)',
    vipRechargeRechargeAmountLabel:'2381 Số tiền nạp (VND)',
    vipRechargeTimeRangeLabel:'2382 Phạm vi thời gian',
    vipRechargeStartDateLabel:'2383 Ngày bắt đầu',
    vipRechargeEndDateLabel:'2384 Ngày kết thúc',
    vipRechargeVipNameLabel:'2385 Tên hội viên',
    vipRechargePhoneLabel:'2386 Số điện thoại',
    vipRechargePleaseEnterText:'2387 Vui lòng nhập',
    vipRechargeStatusLabel:'2388 Tình trạng',
    vipRechargeResetBtn:'2389 Đặt lại',
    vipRechargeConfirmBtn:'2390 Xác nhận',
    vipRechargeMemberNameLabel:'2391 Tên hội viên',
    vipRechargeOrderNoLabel:'2392 Số chứng từ',
    vipRechargeAmountLabel:'2393 Số tiền',
    vipRechargeBeforeRechargeLabel:'2394 Trước khi nạp',
    vipRechargeAfterRechargeLabel:'2395 Sau khi nạp',
    vipRechargeUnpaidAmountLabel:'2396 Chờ thanh toán',
    vipRechargePaidAmountLabel:'2397 Đã thanh toán',
    vipRechargePaymentMethodLabel:'2398 Cách',
    vipRechargeTimeLabel:'2399 Thời gian',
    vipRechargeStateLabel:'2400 Tình trạng',
    vipRechargeUnpaidLabel:'2401 Chưa thanh toán',
    vipRechargePartialPaymentLabel:'2402 Thanh toán một phần',
    vipRechargePaidLabel:'2403 Đã thanh toán',
    vipRechargeCancelledLabel:'2404 Đã hủy',
    vipRechargeOperationLabel:'2405 Thao tác',
    vipRechargeContinuePaymentBtn:'2406 Tiếp tục thanh toán',
    vipRechargeCancelPaymentBtn:'2407 Hủy thanh toán',
    vipRechargeConfirmCancelMsg:'2408 Xác nhận hủy bỏ bản ghi nạp tiền này?',
    vipRechargePromptTitle:'2409 Thông báo',
    vipRechargeAmountChangedMsg:'2410 Giá trị chứng từ hiện tại đã thay đổi',
    vipRechargeSuccessLabel:'2411 Thành công',
    vipRechargeErrorLabel:'2412 Lỗi',
    vipRechargeCloseBtn:'2413 Đóng',
    membershipStatus:'3545 Tình trạng thành viên',
    normal:'3546 bình thường',
    blacklist:'3547 Kéo đen',
    abnormal:'3548 bất thường',
    requiredPoints:'3549 Điểm cần thiết',
    exchangeQuantity:'3550 Số lượng trao đổi',
    totalConsumptionPoints:'3551 Tổng số điểm tiêu thụ',
    exchangeStore:'3552 Đổi cửa hàng',
    pageSummarizes:'3553 Tóm tắt trang này',
  },
  //收银台
  deptCollectMoney:{
    indexLoadingText:'2414 Vui lòng chờ, hệ thống đang tải...',
    indexNoDataText:'2415 Trang hiện tại chưa có dữ liệu sản phẩm',
    verifiedTicket:'2416 Phiếu đã xác nhận sử dụng',
    ticketCount:'2417 Tờ',
    viewTicket:'2418 Nhấp để xem',
    promotionActivity:'2419 Khuyến mãi',
    activityType:'2420 Loại hoạt động',
    viewGift:'2421 Xem quà tặng',
    chooseGift:'2422 Chọn quà tặng',
    viewAddPurchase:'2423 Xem mua thêm',
    chooseAddPurchase:'2424 Chọn mua thêm',
    activityName:'2425 Tên chương trình',
    viewGoods:'2426 Xem sản phẩm',
    clearAction:'2427 Xóa',
    tabSell:'2428 Bán',
    tabExchange:'2429 Đổi',
    tabGift:'2430 Quà',
    scanPlaceholder:'2431 QuÃét mÃǎ dÃé thém (Nhán dé tap trung)',
    scanTip:'2432 Khi quét mã vui lòng chuyển sang bàn phím tiếng Anh',
    goodsNoPlaceholder:'2433 Nhập thủ công mã hàng/mã tắt',
    searchText:'2434 Tìm kiếm',
    spuGoodsNo:'2435 Mã hàng',
    spuGoodsName:'2436 Tên sản phẩm',
    spuClose:'2437 Đóng',
    goodsColor:'2438 Màu sắc',
    goodsSize:'2439 Kích cỡ',
    salesQuery:'2440 Tra cứu bán hàng',
    goodsQuery:'2441 Tra cứu sản phẩm',
    defectiveSale:'2442 Bán hàng lỗi',
    vipFunction:'2443 Chức năng hội viên',
    hangOrder:'2444 Tạm dừng/lấy đơn',
    customOrder:'2445 Lịch sử đặt hàng',
    priceAdjust:'2446 Thông báo điều chỉnh giá',
    stockCard:'2447 Thẻ kho',
    ticketVerify:'2448 Xác nhận sử dụng voucher',
    timeTarget:'2449 Mục tiêu theo ca',
    exchangeTitle:'2450 Đang thực hiện đổi hàng',
    exchangeDesc:'2451 Tới cửa hàng khác để đổi chỉ được phép đổi hàng, “đổi” tính theo giá hàng mới nhất của cửa hàng mình. Đánh 1 “đổi” giá trị 100, chiếc tiếp theo đánh “bán” nếu giá trị 80 thì “bán” được coi là giá trị 100; nếu “bán” giá trị lớn hơn hoặc bằng 100 thì không bị ảnh hưởng.',
    exchangeTotalPrice:'2452 Tổng số tiền đổi hàng：',
    exchangeTotalNum:'2453 Tổng số：',
    personalPerformance:'2454 Thành tích cá nhân',
    chooseShopGuide:'2455 Vui lòng chọn nhân viên bán hàng',
    chooseTeam:'2456 Chọn nhân viên tổ',
    selectedTeam:'2457 Đã chọn nhân viên tổ:',
    publicOrderClosed:'2458 Chia đơn chưa kích hoạt',
    publicOrderOpened:'2459 Chia đơn đã kích hoạt',
    viewPublicOrderMembers:'2460 Xem thành viên tham gia chia đơn',
    vipName:'2461 Tên hội viên',
    vipPhone:'2462 Số điện thoại',
    vipBalance:'2463 Số dư',
    vipIntegral:'2464 Điểm',
    vipReselect:'2465 Chọn lại',
    vipScanCode:'2466 Vui lòng quét mã thành viên',
    vipInputPhone:'2467 Vui lòng nhập số điện thoại',
    vipScanOrPhone:'2468 Nhập SĐT hoặc quét mã',
    vipTip:'2469 Mở hội viên trên WeChat OA, hiển thị mã',
    withTaxPrice: 'Giá bán lẻ',
    priceSalesCount:'số lượng',
    taxPrice: 'Thuế VAT',
    priceReceivable:'Tổng tiền phải trả（Bao VAT）',
    priceTagTotal:'Tổng giá thẻ',
    priceTagDiscount:'2473 Khấu trừ giá niêm yết',
    priceCouponDiscount:'2474 Voucher đã khấu trừ',
    paySettle:'2475 Thanh toán',
    payQuick:'2476 Thanh toán nhanh',
    dialogTip:'2477 Thông báo',
    dialogVipRestrict:'2478 Xin lỗi, thành viên này đang bị giới hạn tạm thời và không thể sử dụng được, chúng tôi khuyên bạn nên liên hệ với IT để biết rõ hơn về tình trạng này và khắc phục.',
    performanceIndividual:'2479 Thành tích cá nhân',
    dialogConfirm:'2480 Xác nhận',
    inputGoodsNoOrShortCode:'2481 Vui lòng nhập mã hàng hoặc mã tắt để tra cứu',
    noGoodsNoInfo:'2482 Không tìm thấy thông tin mã hàng',
    chooseGoodsNo:'2483 Vui lòng chọn mã hàng',
    salesRecordWindowName:'2484 Lịch sử bán hàng',
    timeQuantumWindowName:'2485 Thành tích theo ca',
    performanceCalendarWindowName:'2486 Lịch thành tích',
    customerOrderWindowName:'2487 Lịch sử đặt hàng',
    priceAdjustmentNoticeWindowName:'2488 Thông báo điều chỉnh giá',
    timeTargetFollowWindowName:'2489 Theo dõi mục tiêu theo ca',
    cannotAddDefectiveGoods:'2490 Danh sách hàng hiện tại không thể thêm hàng lỗi, vui lòng xóa đi rồi mới thêm vào',
    hangOrderWithCouponTip:'2491 Đơn hàng này đang sử dụng phiếu ghi nợ, nếu để đơn hàng treo quá lâu sẽ tự động xóa lịch sử treo đơn, cần lấy đơn hàng ngay nếu không sẽ bị xóa và phiếu ghi nợ không thể hủy hoặc tiếp tục in đơn hàng được qua hệ thống quầy thu ngân. Bạn có chắc chắn treo đơn?',
    confirmHangOrder:'2492 Xác nhận tạm giữ đơn?',
    hangOrderConfirmTitle:'2493 Xác nhận tạm giữ đơn',
    operationSuccess:'2494 Thao tác thành công',
    cannotModifyShopGuide:'2495 Sau khi mở đơn chung, không được phép thay đổi nhân viên bán hàng',
    onlyAddDefectiveGoods:'2496 Hiện tại đang bán hàng lỗi, chỉ được thêm hàng lỗi',
    scanTagOrInputBarcode:'2497 Vui lòng quét thẻ treo hoặc nhập mã vạch',
    noGoodsInfo:'2498 Không tìm thấy thông tin sản phẩm',
    cannotModifyDefectiveGiftGoods:'2499 Hàng lỗi, quà tặng, hàng mua thêm không được phép thay đổi số lượng, giá cả và màu sắc/kích thước',
    inputValidQuantity:'2500 Vui lòng nhập số lượng hợp lệ',
    confirmCancelPriceChange:'2501 Xác nhận hủy thay đổi giá?',
    tipText:'2502 Thông báo',
    inputAmountGreaterThanZero:'2503 Vui lòng nhập số tiền lớn hơn 0',
    inputValidAmount:'2504 Vui lòng nhập số tiền hợp lệ',
    promotionCannotChangePrice:'2505 Sản phẩm hiện tại đang tham gia khuyến mãi, vui lòng hủy khuyến mãi ở góc dưới bên trái trước khi thay đổi giá',
    cannotModifyDefectiveGoods:'2506 Hàng lỗi, quà tặng, hàng mua thêm không được phép thay đổi số lượng, giá cả và màu sắc/kích thước',
    confirmDeleteRecord:'2507 Xóa bản ghi này?',
    confirmCancelVerification:'2508 Xác nhận hủy bỏ xác nhận thanh toán?',
    cancelVerificationTip:'2509 Cảnh báo khi hủy',
    clearAfterCancelTicket:'2510 Hiện có phiếu đã xác nhận thanh toán, vui lòng hủy xác nhận thanh toán trước khi làm trống',
    confirmClearGoodsList:'2511 Làm trống danh sách sản phẩm?',
    operateSuccessText:'2512 Thao tác thành công',
    promotionConflictWithTicket:'2513 Khuyến mãi này xung đột với phiếu đã xác nhận thanh toán và không thể chọn',
    selectActivityFirst:'2514 Vui lòng chọn chương trình khuyến mãi trước',
    activityMutualExclusion:'2515 Chương trình hiện tại xung đột với chương trình đã chọn và không thể chọn',
    addGoodsFirst:'2516 Vui lòng thêm sản phẩm trước',
    defectiveCannotChangePrice:'2517 Hiện tại đang bán hàng lỗi, không được phép thay đổi giá',
    exchangeNoRefund:'2518 Đổi hàng không hỗ trợ hoàn tiền, vui lòng đề xuất sản phẩm thay thế có giá trị tương đương hoặc cao hơn!',
    addExchangeGoodsFirst:'2519 Vui lòng thêm sản phẩm cần đổi trước!',
    publicOrderClosedTip:'2520 Đơn chung của cửa hàng hiện đã đóng, vui lòng thiết lập lại',
    selectShopGuideFirst:'2521 Vui lòng chọn nhân viên bán hàng',
    priceChangeOverLimit:'2522 Giá trị sản phẩm vượt quá phạm vi cho phép điều chỉnh, vui lòng gửi yêu cầu thay đổi giá. Mã sản phẩm cần yêu cầu thay đổi giá:',
    priceChangeLimitTitle:'2523 Số tiền điều chỉnh vượt quá giới hạn cho phép',
    settlementCompleted:'2524 Hoàn tất thanh toán!',
    paySuccessText:'2525 Thanh toán thành công',
    clearPinkerTicketFirst:'2526 Hiện có phiếu giảm giá Pinkle đã xác nhận thanh toán, vui lòng hủy xác nhận trước khi chọn lại hội viên',
    defectiveCannotVerifyTicket:'2527 Hiện tại đang bán hàng lỗi, không thể xác nhận coupon, vui lòng làm trống và thao tác lại.',
    orderPriceModifyTitle:'2528 Thay đổi giá toàn bộ đơn hàng',
    orderPriceTotalAmount:'2529 Tổng tiền đơn hàng',
    orderPriceModifyAmount:'2530 Số tiền điều chỉnh',
    orderPriceEnterModifyAmount:'2531 Vui lòng nhập số tiền điều chỉnh',
    orderPriceCancel:'2532 Hủy bỏ',
    orderPriceConfirm:'2533 Xác nhận',
    orderPriceEnterPriceMsg:'2534 Vui lòng nhập số tiền điều chỉnh',
    chooseSpecificationTitle:'2535 Chọn quy cách',
    loadingText:'2536 Vui lòng chờ, hệ thống đang tải...',
    // noImageText:'2537 Tạm thời chưa có hình ảnh',
    goodsInfoArticleNo:'2538 Mã sản phẩm:',
    goodsInfoBarCode:'2539 Mã vạch:',
    goodsInfoStock:'2540 Tồn kho:',
    goodsInfoPiece:'2541 Cái',
    operationCancel:'2542 Hủy bỏ',
    operationConfirm:'2543 Xác nhận',
    messagePleaseChooseSize:'2544 Vui lòng chọn kích cỡ trước',
    messagePleaseChooseColor:'2545 Vui lòng chọn màu sắc trước',
    messageMinNumber:'2546 Số lượng tối thiểu là 1, không thể giảm thêm',
    messageStockInsufficient:'2547 Hàng hóa hiện tại không đủ tồn kho',
    messageEnterValidNumber:'2548 Vui lòng nhập số nguyên lớn hơn hoặc bằng 1',
    messagePleaseSelectColor:'2549 Vui lòng chọn màu sắc',
    messagePleaseSelectSize:'2550 Vui lòng chọn kích cỡ',
    complimentariesTitle:'2551 Thông tin quà tặng',
    complimentariesSearchPlaceholder:'2552 Vui lòng nhập mã hàng, mã vạch hoặc quét thẻ',
    complimentariesQueryBtn:'2553 Tra cứu',
    complimentariesNoImage:'Không có hình',
    complimentariesGoodsNoLabel:'2555 Mã hàng：',
    complimentariesBarCodeLabel:'2556 Mã vạch：',
    complimentariesCancelBtn:'2557 Hủy bỏ',
    complimentariesConfirmBtn:'2558 Xác nhận',
    complimentariesErrorReachLimit:'2559 Quà tặng đã chọn đã đạt đến giới hạn trên của hoạt động',
    complimentariesErrorCannotReduce:'2560 Số lượng hiện tại là 0, không thể giảm thêm',
    complimentariesErrorMaxGift:'2561 Hoạt động hiện tại chỉ có thể chọn tối đa {count} món quà tặng',
    changePriceTitle:'2562 Đơn xin điều chỉnh giá',
    changePriceApplyInfo:'2563 Thông tin đơn đăng ký',
    changePriceSubmitUser:'2564 Người gửi',
    changePricePleaseSelect:'2565 Vui lòng chọn',
    changePriceSubmitTime:'2566 Thời gian gửi',
    changePriceShopName:'2567 Tên cửa hàng',
    changePriceOriginalPrice:'2568 Giá gốc',
    changePriceAlteredAmount:'2569 Số tiền sau chỉnh sửa',
    changePriceChangeAmount:'2570 Số tiền thay đổi',
    changePriceRemarks:'2571 Ghi chú',
    changePricePleaseEnterRemarks:'2572 Vui lòng nhập ghi chú',
    changePricePriceChangedGoods:'2573 Hàng hóa điều chỉnh giá',
    changePriceType:'2574 Loại',
    changePriceNoImage:'2575 Chưa có hình ảnh',
    changePriceGoodsInfo:'2576 Thông tin hàng hóa',
    changePriceItemNo:'2577 Mã hàng：',
    changePriceBarcode:'2578 Mã vạch：',
    changePriceColorSize:'2579 Màu sắc / Kích cỡ',
    changePriceAvailableStock:'2580 Tồn kho khả dụng：',
    changePriceTagPrice:'2581 Giá treo thẻ',
    changePriceDiscount:'2582 Giảm giá',
    changePriceQuantity:'2583 Số lượng',
    changePriceBeforeAlterPrice:'2584 Đơn giá trước chỉnh sửa',
    changePriceAfterAlterPrice:'2585 Đơn giá sau chỉnh sửa',
    changePriceBeforeTotalPrice:'2586 Tổng giá trước chỉnh sửa',
    changePriceAfterTotalPrice:'2587 Tổng giá sau chỉnh sửa',
    changePriceCancel:'2588 Hủy bỏ',
    changePriceConfirm:'2589 Xác nhận',
    changePricePleaseSelectApplicant:'2590 Vui lòng chọn người nộp đơn',
    changePricePleaseFillApprovalRemarks:'2591 Vui lòng điền ghi chú phê duyệt',
    changePricePriceChangeApplicationSubmitted:'2592 Đơn xin điều chỉnh giá đã được gửi',
    changePriceIncrease:'2593 Tăng',
    changePriceDecrease:'2594 Giảm',
    changePriceConfirmDeleteCoupon:'2595 Bạn có muốn xóa phiếu giảm giá này không?',
    changePricePrompt:'2596 Nhắc nhở',
    orderRemarkTitle:'2597 Ghi chú toàn đơn',
    orderRemarkPlaceholder:'2598 Vui lòng nhập ghi chú',
    commonCancel:'2599 Hủy bỏ',
    commonConfirm:'2600 Xác nhận',
    goodsQuery_title:'Tra cứu hàng',
    goodsQuery_scanBarcodeLabel:'2602 Quét mã vạch thẻ tra cứu',
    goodsQuery_scanPlaceholder:'2603 Vui lòng quét',
    goodsQuery_goodsNoOrCodeLabel:'2604 Mã hàng / Mã rút gọn',
    goodsQuery_inputPlaceholder:'2605 Vui lòng nhập',
    goodsQuery_styleCategoryLabel:'2606 Phân loại kiểu dáng',
    goodsQuery_yearLabel:'2607 Năm',
    goodsQuery_selectPlaceholder:'2608 Vui lòng chọn',
    goodsQuery_quarterLabel:'2609 Mùa',
    goodsQuery_spring:'2610 Mùa xuân',
    goodsQuery_summer:'2611 Mùa hè',
    goodsQuery_autumn:'2612 Mùa thu',
    goodsQuery_winter:'2613 Mùa đông',
    goodsQuery_allSeason:'2614 Quanh năm',
    goodsQuery_styleClassificationLabel:'2615 Phân loại phong cách',
    goodsQuery_sizeLabel:'2616 Kích cỡ',
    goodsQuery_colorLabel:'2617 Màu sắc',
    goodsQuery_colorTip:'2618 Có thể tra cứu chính xác theo màu trên thẻ treo, hoặc tra cứu mờ theo từ khóa màu sắc, ví dụ nhập "đen" sẽ tìm các màu có chứa "đen"',
    goodsQuery_searchBtn:'2619 Tìm ⏎',
    goodsQuery_resetBtn:'2620 Đặt lại',
    goodsQuery_goodsListLabel:'2621 Danh sách hàng',
    goodsQuery_showStockLabel:'2622 Hiển thị tồn kho：',
    goodsQuery_stockLabel:'2623 Tồn kho',
    goodsQuery_occupyStockLabel:'2624 Kho Ðǎ Đặt',
    goodsQuery_usableStockLabel:'2625 Kho Có Sẵn',
    goodsQuery_onlyAdjustedLabel:'2626 Chỉ xem có điều giá',
    goodsQuery_onlyHasStockLabel:'2627 Chỉ xem có [tồn kho]',
    goodsQuery_onlyNegativeStockLabel:'2628 Chỉ xem [tồn kho] âm',
    goodsQuery_filterResetBtn:'2629 Đặt lại',
    goodsQuery_loadingText:'2630 Vui lòng chờ, đang tải...',
    goodsQuery_noStockDataText:'2631 Chưa có dữ liệu tồn kho',
    goodsQuery_noImageText:'2632 Chưa có hình ảnh',
    goodsQuery_adjustPriceLabel:'Điều chỉnh giá',
    goodsQuery_goodsNoColonLabel:'2634 Mã hàng：',
    goodsQuery_colorColonLabel:'2635 Màu sắc：',
    goodsQuery_tagPriceLabel:'2636 Giá treo thẻ',
    goodsQuery_retailPriceLabel:'2637 Giá bán lẻ',
    goodsQuery_currentSellingPriceLabel:'2638 Giá bán hiện tại：',
    goodsQuery_adjustEffectiveDateLabel:'2639 Ngày hiệu lực điều chỉnh giá：',
    goodsQuery_correspondingBarcodeLabel:'2640 Mã vạch tương ứng：',
    goodsQuery_totalLabel:'2641 Tổng cộng',
    goodsQuery_otherShopsLabel:'2642 Cửa hàng khác',
    goodsQuery_stockAccountCardLabel:'2643 Thẻ kế toán tồn kho',
    goodsQuery_addToCashierLabel:'2644 Thêm vào quầy thu ngân',
    goodsQuery_otherShopsStockTitle:'Cửa hàng khác [Tồn sẵn]',
    goodsQuery_enterShopNamePlaceholder:'2646 Vui lòng nhập tên cửa hàng',
    goodsQuery_shopSearchBtn:'2647 Tìm kiếm',
    goodsQuery_showOnlyHasStockLabel:'2648 Chỉ hiển thị có tồn kho',
    goodsQuery_barcodeColonLabel:'2649 Mã vạch：',
    goodsQuery_noDataText:'2650 Chưa có dữ liệu',
    goodsQuery_shopNameColonLabel:'2651 Tên cửa hàng：',
    goodsQuery_distanceColonLabel:'2652 Khoảng cách cửa hàng：',
    goodsQuery_contactPhoneColonLabel:'2653 Số điện thoại liên hệ：',
    goodsQuery_availableStockLabel:'2654 Tồn sẵn',
    goodsQuery_selectSizeTip:'2655 Vui lòng chọn kích cỡ',
    goodsQuery_all:'2656 Tổng cộng',
    noImage:'2657 Chưa có hình ảnh',
    gift:'2658 Quà tặng',
    addBuy:'2659 Mua thêm',
    promotion:'2660 Khuyến mãi',
    goodsNo:'2661 Mã hàng：',
    barcode:'2662 Mã vạch：',
    quantity:'2663 Số lượng：',
    salesInquiryTitle:'2664 Tra cứu bán hàng',
    salesInquiryTabsTodayFlow:'2665 Doanh thu trong ngày',
    salesInquiryTabsYesterdayFlow:'2666 Doanh thu hôm qua',
    salesInquiryTabsTodayPerformance:'2667 Thành tích trong ngày',
    salesInquiryTabsYesterdayPerformance:'2668 Thành tích hôm qua',
    salesInquiryTabsHistorySales:'2669 Lịch sử bán hàng',
    salesInquiryTableSalesOrderNo:'2670 Số đơn bán hàng',
    salesInquiryTableName:'2671 Họ tên',
    salesInquiryTableQuantity:'2672 Số lượng',
    salesInquiryTableAmount:'2673 Số tiền',
    salesInquiryTableSalesTime:'2674 Thời gian bán hàng',
    salesInquiryTableOrderCount:'2675 Số đơn',
    salesInquiryTableTotalAmount:'2676 Số tiền',
    salesInquiryTablePublicOrder:'2677 Đơn công',
    salesInquiryTablePerformanceTotal:'2678 Tổng thành tích',
    salesInquiryTableDate:'2679 Ngày tháng',
    salesInquiryTotalCash:'2680 Tiền mặt',
    salesInquiryTotalLkl:'2681 Lakala',
    salesInquiryTotalScan:'2682 Quét mã',
    salesInquiryTotalMember:'2683 Thành viên',
    salesInquiryTotalTotalAmount:'2684 Tổng số tiền',
    salesInquirySummaryTotal:'2685 Tổng cộng',
    salesInquiryMessageError:'2686 Lỗi',
    salesUserListTitle:'2741 Chọn nhân viên bán hàng',
    salesUserListSearchPlaceholder:'2742 Tìm kiếm NV bán hàng',
    salesUserListCurrentSalesperson:'2743 NV bán hàng hiện tại：',
    salesUserListNoData:'2744 Chưa có nhân viên',
    salesUserListCancel:'2745 Hủy',
    salesUserListConfirm:'2746 Xác nhận',
    salesUserListErrorVipSingle:'2747 Vui lòng chọn một nhân viên bán hàng',
    salesUserListErrorMultiRequired:'2748 Vui lòng chọn từ hai NV trở lên. Nếu chỉ có một, hãy chọn tính hiệu quả cá nhân.',
    salesUserListCode:'2749 Số hiệu：',
    saleBadGoodsTitle:'2750 Bán hàng lỗi',
    saleBadGoodsWarning:'2751 Lưu ý: Hàng lỗi sau khi bán sẽ không được trả lại hoặc đổi.',
    saleBadGoodsStateApproved:'2752 Đã phê duyệt',
    saleBadGoodsStatePending:'2753 Chờ phê duyệt',
    saleBadGoodsStateCancelled:'2754 Đã hủy',
    saleBadGoodsLabelGoodsName:'2755 Tên hàng hóa',
    saleBadGoodsPlaceholderGoodsName:'2756 Nhập tên hàng hóa',
    saleBadGoodsLabelBarcodeOrGoodsNo:'2757 Mã vạch / Mã hàng',
    saleBadGoodsPlaceholderBarcodeOrGoodsNo:'2758 Nhập mã vạch / mã hàng',
    saleBadGoodsButtonSearch:'2759 Truy vấn',
    saleBadGoodsButtonApplyQrcode:'2760 Mã QR yêu cầu hàng lỗi',
    saleBadGoodsNoImage:'2761 Chưa có hình ảnh',
    saleBadGoodsLabelSaleableQuantity:'2762 Số lượng có thể bán：',
    saleBadGoodsLabelApplyQuantity:'2763 Số lượng yêu cầu：',
    saleBadGoodsLabelSellingPrice:'2764 Giá bán：',
    saleBadGoodsLabelTagPrice:'2765 Giá treo thẻ：',
    saleBadGoodsButtonAddToCashier:'2766 Thêm vào quầy thu ngân',
    saleBadGoodsButtonCancel:'2767 Hủy',
    saleBadGoodsStatusCancelled:'2768 Đã hủy',
    saleBadGoodsStatusApproving:'2769 Đang phê duyệt',
    saleBadGoodsLabelReviewer:'2770 Người phê duyệt：',
    saleBadGoodsEmptyStateTitle:'2771 Quét mã để chuyển nhanh đến trang yêu cầu hàng lỗi',
    saleBadGoodsEmptyStateDesc:'2772 Nhanh tay quét mã thử nào!',
    saleBadGoodsQrcodeDialogTitle:'2773 Mã QR yêu cầu hàng lỗi',
    saleBadGoodsMessageMaxSaleableQuantity:'2774 Số lượng hàng lỗi tối đa có thể bán hiện tại: {count} chiếc',
    saleBadGoodsConfirmCancel:'2775 Xác nhận đánh dấu hàng lỗi này là hủy, sau khi hủy sẽ xóa hàng lỗi này',
    saleBadGoodsConfirmTitle:'2776 Nhắc nhở',
    stockAccountCardTitle:'2777 Thẻ kho',
    stockAccountCardFormGoodsNo:'2778 Mã hàng',
    stockAccountCardFormSn:'2779 Số chứng từ',
    stockAccountCardFormInvoicesType:'2780 Loại chứng từ',
    stockAccountCardFormDateRange:'2781 Phạm vi ngày',
    stockAccountCardPlaceholderInput:'2782 Vui lòng nhập',
    stockAccountCardPlaceholderSelect:'2783 Vui lòng chọn',
    stockAccountCardPlaceholderStartDate:'2784 Ngày bắt đầu',
    stockAccountCardPlaceholderEndDate:'2785 Ngày kết thúc',
    stockAccountCardButtonQuery:'2786 Truy vấn',
    stockAccountCardTableInvoicesDate:'2787 Ngày biến động',
    stockAccountCardTableInvoicesType:'2788 Loại chứng từ',
    stockAccountCardTableSn:'2789 Số chứng từ',
    stockAccountCardTableGoodsNo:'2790 Mã hàng',
    stockAccountCardTableGoodsName:'2791 Tên hàng hóa',
    stockAccountCardTableColor:'2792 Màu sắc',
    stockAccountCardTableOutUnitCode:'2793 Mã đơn vị xuất kho',
    stockAccountCardTableOutUnitName:'2794 Tên đơn vị xuất kho',
    stockAccountCardTableInUnitCode:'2795 Mã đơn vị nhập kho',
    stockAccountCardTableInUnitName:'2796 Tên đơn vị nhập kho',
    stockAccountCardInvoicesType1:'2797 Phiếu thanh toán bán lẻ',
    stockAccountCardInvoicesType2:'2798 Đơn điều chuyển cửa hàng',
    stockAccountCardInvoicesType3:'2799 Đơn phân phối cửa hàng',
    stockAccountCardInvoicesType4:'2800 Phiếu trả hàng từ cửa hàng về kho',
    stockAccountCardInvoicesType5:'2801 Kiểm kê hóa đơn.',
    stockAccountCardInvoicesType6:'2802 Điều chỉnh tồn kho cửa hàng',
    stockAccountCardInvoicesType7:'2803 Phiếu đổi hàng bằng điểm thành viên',
    stockAccountCardInvoicesType8:'2804 Đơn hàng khách',
    stockAccountCardMessageGoodsNoRequired:'2805 Mã hàng không được để trống',
    stockAccountCardMessageDateRequired:'2806 Ngày không được để trống',
    stockAccountCardTableSum:'2807 Tổng cộng',
    stockAccountCardTableStart:'2808 Đầu kỳ',
    stockAccountCardTableEnd:'2809 đến',
    stockAccountCardTo:'2810 Cuối kỳ',
    tradeInDialogTitle:'2811 Thông tin mua thêm',
    tradeInDialogSearchPlaceholder:'2812 Nhập mã hàng, mã vạch hoặc quét mã vạch treo thẻ để tra cứu',
    tradeInDialogQueryBtn:'2813 Truy vấn',
    tradeInDialogNoImage:'2814 Chưa có hình ảnh',
    tradeInDialogGoodsNo:'2815 Mã hàng：',
    tradeInDialogBarCode:'2816 Mã vạch：',
    tradeInDialogAddPrice:'2817 Giá mua thêm：',
    tradeInDialogOriginalPrice:'2818 Giá gốc',
    tradeInDialogCancelBtn:'2819 Hủy',
    tradeInDialogConfirmBtn:'2820 Xác nhận',
    tradeInDialogErrorMaxReached:'2821 Hàng hóa mua thêm được chọn đã đạt giới hạn trên của hoạt động',
    tradeInDialogErrorCannotReduce:'2822 Số lượng hiện tại là 0, không thể giảm thêm',
    tradeInDialogErrorExceedMax:'2823 Hoạt động hiện tại chỉ được chọn tối đa {count} mặt hàng mua thêm',
    publicUserSetParticipant:'2824 Thiết lập nhân viên tham gia đơn chung',
    publicUserParticipantList:'2825 Nhân viên tham gia đơn chung',
    publicUserPerformanceLogic:'2826 Logic tính hiệu suất đơn chung：',
    publicUserPerformanceFormula:'2827 Hiệu suất in đơn ÷ Tổng phần của NV tham gia đơn chung × Phần cá nhân',
    publicUserSelectParticipant:'2828 Vui lòng chọn người tham gia',
    publicUserShopPublicShare:'2829 Phần đơn chung của cửa hàng',
    publicUserShopManager:'2830 Quản lý cửa hàng',
    publicUserShopAssistant:'2831 Trợ lý cửa hàng',
    publicUserShopGuide:'2832 Nhân viên tư vấn',
    publicUserPartTime:'2833 Nhân viên tạm thời',
    publicUserCancel:'2834 Hủy',
    publicUserConfirm:'2835 Xác nhận',
    publicUserName:'2836 Tên',
    publicUserPosition:'2837 Chức vụ',
    publicUserMinParticipantError:'2838 NV tham gia đơn chung không được ít hơn hai người',
    publicUserOpenSuccess:'2839 Đơn chung cửa hàng đã bật',
    checkTicketTitle:'2840 Xác nhận sử dụng phiếu ưu đãi',
    checkTicketChannelDouyin:'2841 Xác nhận sử dụng Douyin',
    checkTicketChannelKuaishou:'2842 Xác nhận sử dụng Kuaishou',
    checkTicketChannelWechat:'2843 Thẻ ưu đãi WeChat',
    checkTicketCurrentChannel:'2844 Kênh xác thực phiếu hiện tại：',
    checkTicketScanTip:'2845 Vui lòng quét mã phiếu ưu đãi của khách hàng',
    checkTicketSubmitBtn:'2846 Xác nhận gửi mã phiếu',
    checkTicketChooseVerificationWay1:'2847 Mã phiếu này có {codeTicketList} cách xác thực, vui lòng chọn 1 cách để xác thực.',
    checkTicketSource:'2849 Nguồn：',
    checkTicketType:'2850 Loại：',
    checkTicketValidityPeriod:'2851 Hiệu lực：',
    checkTicketUnusableReason:'2852 Lý do không khả dụng：',
    checkTicketRescanBtn:'2853 Quét lại mã phiếu',
    checkTicketConfirmChooseWayBtn:'2854 Xác nhận chọn cách xác nhận này',
    checkTicketConfirmVerificationBtn:'2855 Xác nhận xác nhận sử dụng',
    checkTicketErrorMemberInconsistentWithPinker:'2856 Thành viên không khớp, vui lòng hủy phiếu ưu đãi Pinka trước',
    checkTicketErrorMemberInconsistent:'2857 Thành viên không khớp, vui lòng hủy chọn thành viên trước',
    checkTicketErrorChooseOneWay:'2858 Vui lòng chọn 1 cách để xác nhận sử dụng',
    ticketGoodDialogTitle:'2859 Chọn hàng hóa để xác nhận sử dụng phiếu ưu đãi (Khi quét mã vui lòng chuyển phương thức nhập sang tiếng Anh)',
    ticketGoodSource:'2860 Nguồn：',
    ticketGoodType:'2861 Loại：',
    ticketGoodValidity:'2862 Hiệu lực：',
    ticketToDate:'2863 đến',
    ticketGoodReScanCode:'2864 Quét lại mã phiếu',
    ticketGoodScanPlaceholder:'2865 Quét mã vạch hàng hóa để thêm, khi nhập thủ công cần nhấn Enter',
    ticketGoodChooseGift:'2866 Chọn quà tặng (Tối đa {giftNumLimit} chiếc)',
    ticketGoodDeductTagPrice:'2867 Khấu trừ giá treo thẻ {tagTriceAmount} VNĐ',
    noImageText:'2868 Chưa có hình ảnh',
    ticketGoodAvailableStock:'2869 Tồn kho khả dụng：',
    ticketGoodTagPriceLabel:'2870 Giá treo thẻ：',
    ticketGoodCurrentRetailPriceLabel:'2871 Giá bán lẻ hiện tại：',
    ticketGoodPiece:'2872 Chiếc',
    ticketGoodGroup:'2873 Nhóm',
    ticketGoodDelete:'2874 Xóa',
    ticketGoodNoGift:'2875 Chưa có quà tặng, vui lòng thêm quà tặng trước',
    ticketGoodAddMinus:'2876 Cộng/Trừ',
    ticketGoodTip:'2877 Nhắc nhở',
    ticketGoodCombination:'2878 Phối hợp',
    ticketGoodNoGoods:'2879 Chưa có hàng hóa, vui lòng thêm hàng hóa trước',
    ticketGoodGift:'2880 Quà tặng',
    ticketGoodCouponDesc:'2881 Mô tả phiếu ưu đãi',
    ticketGoodSatisfiedCombination:'2882 Đã đáp ứng kết hợp (Nhấp để chọn)',
    ticketGoodNoSatisfiedCombination:'2883 Chưa đáp ứng kết hợp nào',
    ticketGoodPriceCalculation:'2884 Tính toán giá',
    ticketGoodGroupSubtotal:'2885 Nhóm {index} Tạm tính: ¥{goodsAmount}',
    ticketGoodNeedMakeUp:'2886 Cần bù chênh lệch ¥{differenceAmount}',
    ticketGoodTagPriceTotal:'2887 Tổng giá treo thẻ (không bao gồm quà tặng): ¥{goodsTagPrice}',
    ticketGoodTotal:'2888 Tổng cộng (không bao gồm quà tặng): ¥{goodsRetailPrice}',
    ticketGoodTotalReceivable:'2889 Tổng phải thu: ¥{realPrice}',
    ticketGoodClear:'2890 Xóa trắng',
    ticketGoodConfirmCheck:'2891 Xác nhận hàng hóa và xác nhận sử dụng',
    ticketGoodFinishChoose:'2892 Hoàn tất lựa chọn',
    ticketGoodConfirmDeleteGoods:'2893 Xác nhận xóa hàng hóa?',
    ticketGoodConfirmClearGoods:'2894 Xác nhận xóa trắng hàng hóa?',
    ticketGoodNoGoodsOrGift:'2895 Chưa có hàng hóa hoặc quà tặng',
    ticketGoodPleaseScan:'2896 Vui lòng quét thẻ treo hoặc nhập mã vạch',
    ticketListVerifiedTickets:'2897 Phiếu đã xác nhận sử dụng',
    ticketListNoImage:'2898 Chưa có hình ảnh',
    ticketListPiece:'2899 Chiếc',
    ticketListGift:'2900 Quà tặng',
    ticketListTotal:'2901 Tổng cộng',
    ticketListItem:'2902 mẫu',
    ticketListTagPrice:'2903 Giá treo thẻ',
    ticketListOriginalPrice:'2904 Giá gốc',
    ticketListTagDiscount:'2905 Ưu đãi giá treo thẻ',
    ticketListDiscount:'2906 Ưu đãi',
    ticketListReduce:'2907 Trừ',
    ticketListNeedMakeUp:'2908 Cần bù chênh lệch',
    ticketListNoRefund:'2909 Không hoàn trả chênh lệch',
    ticketListChooseGift:'2910 Chọn quà tặng',
    ticketListReselectVerification:'2911 Chọn lại cách xác nhận',
    ticketListReselectGoods:'2912 Chọn lại hàng hóa',
    ticketListCancelVerification:'2913 Hủy xác nhận sử dụng',
    ticketListConfirmCancel:'2914 Xác nhận hủy xác nhận sử dụng?',
    ticketListCancelPrompt:'2915 Nhắc nhở hủy',
    ticketGiveTitle:'2916 Chọn quà tặng',
    ticketGivePlaceholder:'2917 Quét mã vạch hàng hóa để thêm, khi nhập thủ công cần nhấn Enter',
    ticketGiveGiftLimit:'2918 Tối đa {giftNumLimit} quà tặng, đã chọn {giftNum}',
    ticketGiveEmptyTip:'2919 Vui lòng quét mã để thêm quà tặng',
    ticketGiveNoImage:'2920 Chưa có hình ảnh',
    ticketGiveTagPrice:'2921 Giá treo thẻ：',
    ticketGiveRetailPrice:'2922 Giá bán lẻ hiện tại：',
    ticketGiveAvailableStock:'2923 Tồn kho khả dụng：',
    ticketGiveClose:'2924 Đóng',
    ticketGiveConfirm:'2925 Xác nhận',
    ticketGiveMaxGiftError:'2926 Đã đạt giới hạn quà tặng, không thể thêm nữa!',
    typeAddedGoods:'3389 Loại hàng hóa được thêm vào'
  },
  //app
  app:{
    publicTest:'3387 bản thử nghiệm công khai'
  },
  // 状态标签
  statusTag: {
    sended: '3520 Đã Phát Hành',
    orderpack: '3521 Đang Lấy Hàng',
    orderpacked: '3522 Đã Lấy Hàng Xong',
    packing: '3523 Đang Đóng Gói',
    packed: '3524 Đã Đóng Gói Xong',
    outed: '3525 Đã Xuất Hàng',
    checked: '3526 Đã Ký Nhận',
    void: '3527 Đã Hủy Bỏ',
    joined: '3528 Đã Nhập Kho'
  }
}
